var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 863.001,
    height: 459.5,
    viewBox: "0 0 863.001 459.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M124.946,220.376c10.887,29.1,21.108,76.094,22.218,83.2s1,90.089-.107,93.641-12.349,3.453-17.173,7.779-7.932,3.108-8.6-.559-3.108-45.653-5.329-62.32-1.11-33.771-1.776-35.654-22.769-30.655-23.213-62.872,33.993-23.213,33.993-23.213Z",
    transform: "translate(-90.964 -219.218)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M39.333,220.288c-4.663,15.549-5.221,34.659-.888,56.433s9.218,31.88,9.333,36.879-7.22,10.994-16.774,33.1S3.457,393.691,2.01,399.693a16.181,16.181,0,0,0,10.029,8.7c7.518,2.289,11.186-3.376,16.292-1.929,0,0,10.887-12.778,28.657-41.32S81.2,328.936,81.426,317.6s3.667-76.76,1.332-87.425S39.326,220.3,39.326,220.3Z",
    transform: "translate(-2.01 -220.283)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(-96.999 -143.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset_3",
    "data-name": "Asset 3",
    transform: "translate(97.033 143.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-0.034 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M294.961,310.5h81.6s-13.181-30.971-31.313-15.492c-9.024-22.583-30.714,5.576-30.714,5.576S290.743,288.124,294.961,310.5Z",
    transform: "translate(65.618 63.744)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M77.038,312.706H.008s-1.553-20.321,14.379-20.884,19,7.569,19,7.569,1.712-24.32,17.644-23.011,10.344,25.9,10.344,25.9,5.832-6.456,14.073-.795S77.038,312.706,77.038,312.706Z",
    transform: "translate(0.034 61.538)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M451.2,312.712h-77.03s-1.59-20.321,14.342-20.92,18.989,7.569,18.989,7.569,1.712-24.32,17.644-23.011,10.356,25.9,10.356,25.9,5.832-6.456,14.061-.795S451.2,312.712,451.2,312.712Z",
    transform: "translate(83.36 61.531)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M54.55,11.465s8.3,4.561,12.129,12.154c15.235-9.879,24.637-12.154,24.637-12.154s-19.343,0-24.637,6.114C61.385,10.694,54.55,11.465,54.55,11.465Z",
    transform: "translate(12.19 2.546)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M656.17,11.465s8.3,4.561,12.129,12.154c15.235-9.879,24.638-12.154,24.638-12.154s-19.343,0-24.638,6.114C663,10.694,656.17,11.465,656.17,11.465Z",
    transform: "translate(146.172 2.546)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M88.81,66s-5.612,3.081-8.2,8.217C70.31,67.566,63.94,66,63.94,66s13.083,0,16.665,4.108A9.708,9.708,0,0,1,88.81,66Z",
    transform: "translate(14.281 14.696)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M519.578,41.531s-5.612,3.093-8.2,8.229c-10.3-6.688-16.653-8.229-16.653-8.229s13.083,0,16.653,4.121a9.708,9.708,0,0,1,8.2-4.121Z",
    transform: "translate(110.217 9.247)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M21.32,47.934s14.672-4.169,18.414,11.542c12.4-21.055,27.584-13.12,27.584-13.12s-18.12-3.778-28.7,26.5C36.64,49.218,21.32,47.934,21.32,47.934Z",
    transform: "translate(4.789 9.996)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M541.21,3.044s14.672-4.169,18.414,11.542c12.4-21.055,27.584-13.12,27.584-13.12s-18.133-3.754-28.7,26.5C556.53,4.328,541.21,3.044,541.21,3.044Z",
    transform: "translate(120.57 -0.001)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M386.986,184.169c0,42.99-18.414,54.643-41.132,54.643s-41.144-11.652-41.144-54.643S323.124,2.83,345.854,2.83,386.986,141.2,386.986,184.169Z",
    transform: "translate(67.901 0.629)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 10.527,
    height: 289.414,
    transform: "translate(406.712 84.818)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M265.6,188.222a2.922,2.922,0,1,1-2.922-2.922A2.922,2.922,0,0,1,265.6,188.222Z",
    transform: "translate(57.891 41.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 2.947,
    cy: 2.947,
    r: 2.947,
    transform: "translate(538.85 269.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 2.947,
    cy: 2.947,
    r: 2.947,
    transform: "translate(538.85 295.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M446.568,265.111a2.959,2.959,0,1,0-2.947,2.947,2.959,2.959,0,0,0,2.947-2.947Z",
    transform: "translate(98.175 58.378)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 1",
    transform: "translate(153.998 215.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(0.002 0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M260.745,266.8c16.667,6.929,52.842,6.76,56.708,8.728,2.817,1.439,11.109-6.378,6.041-8.506-5.551-2.335-9.31-3.552-15.81-5.949-7.212-2.664-26.819-13.214-35.141-13.429-3.614-.092-7.434,2.067-13.253,5.765s-5.765,10.4,1.455,13.4Z",
    transform: "translate(-59.798 -58.052)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(250.019 206.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M328.207,277.772c-4.249-3.6.268-10.06,7.579-7.35a82.458,82.458,0,0,0,11.8,3.376c2.213.413,6.416,3.767,7,4.578s5.183,4.64,4.693,4.976-.13,1.125-3.591-.475c-2.886-1.332-2.9-2.082-3.69-2.465a43.436,43.436,0,0,1-3.637-2.626,40.731,40.731,0,0,1,4.54,5.482,19.693,19.693,0,0,1,2.243,5.459s-1.424.612-2.794-1.309c0,0-.666,1.095-2.412-.475s-5.773-5.466-5.773-5.466,2.419,3.974,2.442,5.16.758,2.8.115,2.917-2.419-1.072-2.955-3.56-3.981-1.807-6.959-1.623-8.6-6.592-8.6-6.592Z",
    transform: "translate(-326.565 -269.776)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M347.46,282.884a11.488,11.488,0,0,1,1.837,1.256,27.168,27.168,0,0,1,2.879,2.557c.919.919,1.784,1.792,2.3,2.213l.2.168c.988.827,1.409,1.179,2.1,1.011l.138-.092a44.173,44.173,0,0,0-3.759-5.252c-1.141-1.064-3.361-3.774-3.361-3.774s2.58,2.358,3.721,3.422a45.4,45.4,0,0,1,3.943,5.52l.115.184-.6.413-.046.015c-.972.26-1.547-.214-2.58-1.087l-.2-.168c-.521-.436-1.4-1.309-2.32-2.236a48.6,48.6,0,0,0-4.349-4.15Z",
    transform: "translate(-331.462 -272.399)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M354.06,278.958c.115-.084.949.835.949.835,3,3.384,4.2,4.777,4.808,5.933.023.046,2.4,4.655,1.968,5.275a.727.727,0,0,1-.612.268,3.244,3.244,0,0,1-2.6-1.562.228.228,0,0,1,.092-.322.248.248,0,0,1,.337.054,2.868,2.868,0,0,0,2.021,1.355.617.617,0,0,0,.367-.038,25.434,25.434,0,0,0-2.014-4.8c-.559-1.064-5.405-6.936-5.313-7Z",
    transform: "translate(-333.009 -271.927)",
    fill: "#c76852"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M137.5,139.855c-.452-17.571-10.856-35.539-12.4-39.773s.8-9.149-1.929-16.284c-2.6-6.822-8-12.548-15.9-10.5-18.352,4.754-9.547,26.413-9.547,26.413s5.849,20.426,11.017,31.443,12.694,21.307,18.673,20.947c4.839-.291,10.55,5.329,10.1-12.242Z",
    transform: "translate(-22.412 -17.087)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M101.7,76.068c11.675-4.019,17.908-1.233,22.938,8.69s10.282,34.184,10.282,34.184-8.827,6.393-18.987,6.684-11.821-2.243-11.821-2.243-6.936-22.777-8.491-31.244S96.068,78,101.7,76.068Z",
    transform: "translate(-22.296 -17.419)",
    fill: "#f2d8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M109.181,71.709s4.088,1.011,7.335,9.111,1.937,13.819.674,25-3.882,12.081-5.995,18.9-7.694,31.114-5.933,47.345c1.631,15.037,5.773,21.843,5.773,21.843l-61.716.115s-.3-10.711,3.675-26c2.044-7.878-1.585-53.271-2.228-61.486-.743-9.494-9.478-24.484,17.364-34.605,18.137-6.837,41.067-.207,41.067-.207Z",
    transform: "translate(-11.445 -16.138)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(69.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M97.717,37.143c-2.366,8.636-4.77,17.3-6.094,20.832-1.439,3.836-1.539,7.7,3.131,12.556,5.267,5.466,15.343,8.644,20.579,3.231,2.136-2.213.988-3.338,3.476-19.11S100.082,28.507,97.717,37.143Z",
    transform: "translate(-90.749 -7.978)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(0.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M129.243,10.607c8.8,8.8-.544,41.672-4,43.563-14.263,7.794-26.475-12.61-27.929-16.422-2.2-5.78-5.711-22.226,8.383-29.973s18.78-1.929,23.55,2.84Z",
    transform: "translate(-91.926 -0.942)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M104.353.553c4.088-1.225,8.873-.069,10.389.367,6.508-.735,9.777,3.637,11.622,6.247a6.1,6.1,0,0,1,.758,5.183.687.687,0,0,1-1.156.3,8.039,8.039,0,0,0-5.191-2.511,7,7,0,0,0-1.317.046c-.276.031-1.225.276-1.516.345-5.114,1.194-14.393,7.2-15.909,13.207a23.755,23.755,0,0,1-2.327,5.3c-.237.459-1.171,1.309-1.416,1.837a11.329,11.329,0,0,1-.1,1.217c-.13,1.263-1.753,5.75-3,5.551-1.876-1.378-2.649-5.3-3.614-8.59A25.257,25.257,0,0,1,93.206,12.8C96.154,6.448,99.124,2.138,104.361.56Z",
    transform: "translate(-90.908 -0.006)",
    fill: "#8c4a4a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(4.838 21.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M100.728,28.675s-3.614-1.73-3.5,3.468,3.369,7.557,5.191,5.543.628-7.373.628-7.373a4.231,4.231,0,0,0-2.32-1.646Z",
    transform: "translate(-97.227 -28.399)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M100.429,40.954a2.019,2.019,0,0,0,.544.306,2.338,2.338,0,0,0,1.194,0c.674-.107.62-.069.628-.084a.319.319,0,0,1,.352-.306.331.331,0,0,1,.314.36,1.072,1.072,0,0,1-.635.819c-.168.084-.276-.176-.544-.13a3.186,3.186,0,0,1-1.6-.077,1.113,1.113,0,0,1-.322-.214c.054-.291.046-.536.069-.681Z",
    transform: "translate(-97.961 -31.322)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M102.314,36.023a3.833,3.833,0,0,0,.23-1.952,3.574,3.574,0,0,0-.276-1,3.369,3.369,0,0,0-.574-.9,3.166,3.166,0,0,0-1.807-1.026,3,3,0,0,0-1.937.268,9.712,9.712,0,0,1,1.646.643,4.1,4.1,0,0,1,1.21.926,5.236,5.236,0,0,1,.827,1.332c.237.513.429,1.08.674,1.692Z",
    transform: "translate(-97.396 -29.033)",
    fill: "#c76852"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M133.5,41.568a29.043,29.043,0,0,1,.949,6.454c-.138,1.386-2.986,1.968-2.986,1.968s3.254.934,4.41-1.324c0,0-1.049-5.3-2.373-7.1Z",
    transform: "translate(-100.413 -9.746)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M114.8,14.9c4.785-3.3,8.016-4.042,10.68-2.657s3.989,2.848,5.252,2.167,2.527-2.2,3.828-1.96,2.236,3.43,2.236,3.43,3.7-8.345-2.052-11.369S127.506.277,122.522,1.249c-3,.59-8.942,6.133-8.942,6.133l1.225,7.526Z",
    transform: "translate(-96.222 -0.221)",
    fill: "#8c4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M126.4,30.1c-.291,2.067-.8.429-4.326.521-2.473.061-5.03,1.217-4.762.115.3-1.21-.168-1.83,2.435-2.435C124.12,27.282,126.777,27.42,126.4,30.1Z",
    transform: "translate(-97.093 -6.501)",
    fill: "#8c4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M138.051,32.179c-.3,1.638.482,1.148,2.611,1.623,2.159.482,2.274,1.317,2.4.482.153-1.095.107-2.251-.452-2.611-2.3-1.462-4.218-1.347-4.555.505Z",
    transform: "translate(-101.943 -7.194)",
    fill: "#8c4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M138.618,38.984a1.427,1.427,0,1,0,1.279-1.547A1.427,1.427,0,0,0,138.618,38.984Z",
    transform: "translate(-102.089 -8.779)",
    fill: "#363334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M121.188,37.165a1.552,1.552,0,0,0,1.692,1.378,1.532,1.532,0,0,0,1.386-1.677,1.546,1.546,0,0,0-3.078.3Z",
    transform: "translate(-98.003 -8.322)",
    fill: "#363334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M126.608,55.77s.842,2.343,1.73,2.848a6.714,6.714,0,0,0,4.165.1,8.276,8.276,0,0,0,1.439-1.96c-2.366.789-7.342-.988-7.342-.988Z",
    transform: "translate(-99.274 -13.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M124.742,11.478c3.353,2.894,8.391,7.809,11.392,9.011a4.909,4.909,0,0,0-1.524-2.879,12.759,12.759,0,0,1,5.244,5.52A.892.892,0,0,0,140,22.3l1.891,2.986s2.159-6.837,1.677-11.63a12.811,12.811,0,0,1,1.08,2.994s0-6.714-3.476-10.068-10.55-7.909-16.782-5.4.36,10.29.36,10.29Z",
    transform: "translate(-98.128 -0.113)",
    fill: "#8c4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M115.771,16.5c-4.846,3.062-7.488,7.135-7.725,9.532a6.564,6.564,0,0,1-.72-2.726s-.835,2.726-1.317,5.122-.949,2.756-.949,2.756-.253-2.274-.727-4.433a9.376,9.376,0,0,1,4.915-9.593c4.555-2.282,6.523-.666,6.523-.666Z",
    transform: "translate(-94.026 -3.74)",
    fill: "#8c4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M96.353,44.489a12.272,12.272,0,0,1-2.037,2.634,6.49,6.49,0,0,1-.237-2.4l-.36,1.08s-2.4-6.439-2.58-11.668,5.811,6.515,5.811,6.515Z",
    transform: "translate(-90.961 -7.692)",
    fill: "#8c4a4a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M119.969,65.41a14.516,14.516,0,0,1-7.564-2.68c-3.468-2.6-9.271-6.936-10.267-9.685s-.291-7.725-.291-7.725-.949,5.574-.23,8.092,8.031,9.471,12.227,11.507,6.117,1.975,6.117,1.975V65.4Z",
    transform: "translate(-93.233 -10.628)",
    fill: "#c76852"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M128.378,136.846a.337.337,0,0,1-.329-.283.33.33,0,0,1,.283-.375c.413-.061.842-.145,1.279-.245a.331.331,0,1,1,.153.643c-.452.107-.9.191-1.34.26Zm2.6-.6a.335.335,0,0,1-.322-.237.331.331,0,0,1,.222-.413c.406-.122.819-.268,1.24-.429a.332.332,0,1,1,.237.62c-.436.161-.865.314-1.279.436a.449.449,0,0,1-.1.015Zm2.5-.934a.335.335,0,0,1-.306-.2.329.329,0,0,1,.176-.436c.39-.168.789-.352,1.2-.544a.334.334,0,1,1,.283.6c-.421.2-.827.383-1.225.559a.4.4,0,0,1-.13.031Zm2.412-1.141a.34.34,0,0,1-.3-.184.334.334,0,0,1,.145-.452c.375-.191.758-.4,1.171-.62a.334.334,0,0,1,.314.59c-.421.23-.8.429-1.187.628a.349.349,0,0,1-.153.038Zm2.35-1.263a.337.337,0,0,1-.291-.168.33.33,0,0,1,.13-.452c.26-.145.521-.291.773-.436l.39-.222a.332.332,0,1,1,.322.582l-.39.222c-.253.138-.505.283-.773.436a.322.322,0,0,1-.161.046Zm2.327-1.3a.333.333,0,0,1-.153-.628c.49-.26.873-.459,1.21-.612a.334.334,0,0,1,.283.6c-.322.153-.7.337-1.171.6a.311.311,0,0,1-.161.038Z",
    transform: "translate(-30.015 -30.554)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M128.088,135.256a.337.337,0,0,1-.329-.283.33.33,0,0,1,.283-.375c.413-.061.842-.145,1.279-.245a.331.331,0,0,1,.153.643c-.452.107-.9.191-1.34.26Zm2.6-.6a.335.335,0,0,1-.322-.237.331.331,0,0,1,.222-.413c.406-.122.819-.268,1.24-.429a.332.332,0,1,1,.237.62c-.436.161-.865.314-1.279.436a.448.448,0,0,1-.1.015Zm2.5-.934a.335.335,0,0,1-.306-.2.329.329,0,0,1,.176-.436c.39-.168.789-.352,1.2-.544a.334.334,0,0,1,.283.6c-.421.2-.827.383-1.225.559a.4.4,0,0,1-.13.031Zm2.412-1.141a.34.34,0,0,1-.3-.184.334.334,0,0,1,.145-.452c.375-.191.758-.4,1.171-.62a.334.334,0,1,1,.314.59c-.421.23-.8.429-1.187.628a.348.348,0,0,1-.153.038Zm2.35-1.263a.337.337,0,0,1-.291-.168.33.33,0,0,1,.13-.452c.26-.145.521-.291.773-.436l.39-.222a.332.332,0,0,1,.322.582l-.39.222c-.253.138-.505.283-.773.436a.322.322,0,0,1-.161.046Zm2.327-1.3a.333.333,0,0,1-.153-.628c.49-.26.873-.459,1.21-.612a.334.334,0,1,1,.283.6c-.322.153-.7.337-1.171.6a.311.311,0,0,1-.161.038Z",
    transform: "translate(-29.947 -30.181)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M128.35,168.956c12.74,10.014,44.443,17.165,47.3,19.829,1.286,1.2,11.859,5.551,13.49,2.71,1.011-1.761-5.6-10.764-7.357-11.446-3.928-1.524-5.78-3.5-10.826-7.112-5.6-4.012-21.69-16.652-28.917-18.543-3.131-.819-5.313-.965-11.392,1.409s-7.817,8.812-2.3,13.153Z",
    transform: "translate(-29.305 -36.067)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(117.022 149.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(0 89.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M153.861,362.32a60.345,60.345,0,1,0,70.283-48.409,60.346,60.346,0,0,0-70.283,48.409Zm11.966,2.2a48.173,48.173,0,1,1,38.648,56.1A48.172,48.172,0,0,1,165.827,364.525Z",
    transform: "translate(-152.851 -312.901)",
    fill: "#363334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M160.618,364.872A55.109,55.109,0,1,0,224.8,320.658a55.106,55.106,0,0,0-64.181,44.214Zm6.822,1.256a48.173,48.173,0,1,1,38.648,56.1,48.172,48.172,0,0,1-38.648-56.1Z",
    transform: "translate(-154.455 -314.503)",
    fill: "#e2ebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M163.158,365.826A53.136,53.136,0,1,0,225.042,323.2a53.127,53.127,0,0,0-61.884,42.629Zm3.009.559A50.073,50.073,0,1,1,206.338,424.7a50.074,50.074,0,0,1-40.171-58.316Z",
    transform: "translate(-155.058 -315.106)",
    fill: "#b5bdc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M165.758,366.812A51.119,51.119,0,1,0,225.292,325.8a51.115,51.115,0,0,0-59.534,41.014Zm2.9.536a48.173,48.173,0,1,1,38.648,56.1,48.172,48.172,0,0,1-38.648-56.1Z",
    transform: "translate(-155.676 -315.723)",
    fill: "#9ba1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M166.965,385.638l43.3-9.1-43.509-8.016a1.152,1.152,0,1,1,.413-2.266l43.617,8.039-37.14-24.239a1.151,1.151,0,1,1,1.256-1.929l37.048,24.185-25.1-36.435a1.154,1.154,0,0,1,1.906-1.3l25.158,36.519L204.794,327.7a1.151,1.151,0,1,1,2.251-.482l9.1,43.3L224.163,327a1.152,1.152,0,0,1,2.266.413l-8.039,43.617,24.239-37.14a1.151,1.151,0,1,1,1.929,1.256l-24.186,37.048,36.435-25.1a1.153,1.153,0,1,1,1.309,1.9L221.6,374.154l43.395-9.118a1.154,1.154,0,0,1,.475,2.259l-43.3,9.1,43.517,8.016a1.152,1.152,0,0,1-.413,2.266l-43.617-8.039,37.132,24.239a1.151,1.151,0,0,1-.835,2.1,1.246,1.246,0,0,1-.421-.168l-37.048-24.178,25.1,36.435a1.164,1.164,0,0,1-.3,1.608,1.156,1.156,0,0,1-1.608-.3l-25.158-36.519,9.118,43.4a1.152,1.152,0,0,1-.888,1.363,1.085,1.085,0,0,1-.444,0,1.163,1.163,0,0,1-.919-.9l-9.1-43.3-8.016,43.517a1.152,1.152,0,0,1-2.266-.413l8.039-43.617L189.8,419.049a1.149,1.149,0,0,1-1.171.505,1.247,1.247,0,0,1-.421-.168,1.151,1.151,0,0,1-.337-1.592l24.186-37.055-36.435,25.1a1.156,1.156,0,0,1-1.608-.3,1.164,1.164,0,0,1,.3-1.608l36.519-25.158L167.432,387.9a1.084,1.084,0,0,1-.444,0,1.151,1.151,0,0,1-.031-2.259Z",
    transform: "translate(-155.887 -315.984)",
    fill: "#c5cddb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(141.315 159.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M337.43,431.535a27.116,27.116,0,1,1,0,.008Zm11.507-.069a15.779,15.779,0,1,0,15.68-15.879,15.785,15.785,0,0,0-15.68,15.879Z",
    transform: "translate(-337.429 -404.079)",
    fill: "#363334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M346.12,433.533a20.633,20.633,0,1,0,20.5-20.763A20.657,20.657,0,0,0,346.12,433.533Zm4.854-.031a15.779,15.779,0,1,1,15.879,15.672A15.8,15.8,0,0,1,350.974,433.5Z",
    transform: "translate(-339.466 -406.116)",
    fill: "#e2ebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M348.7,434.123a18.778,18.778,0,1,1,0,.008Zm2.886-.015a15.779,15.779,0,1,1,15.879,15.672,15.8,15.8,0,0,1-15.879-15.672Z",
    transform: "translate(-340.071 -406.721)",
    fill: "#b5bdc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M350.56,434.551a17.234,17.234,0,1,0,17.127-17.341A17.256,17.256,0,0,0,350.56,434.551Zm1.462-.008A15.779,15.779,0,1,1,367.9,450.215a15.8,15.8,0,0,1-15.879-15.672Z",
    transform: "translate(-340.507 -407.157)",
    fill: "#9ba1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M353,431.017l9.585,1.769-8.2-5.352a15.444,15.444,0,0,1,1.317-2.014l8.108,5.29-5.512-8a15.477,15.477,0,0,1,1.983-1.37l5.574,8.092-2.021-9.631a15.908,15.908,0,0,1,2.358-.5l2.006,9.539,1.769-9.593a15.02,15.02,0,0,1,2.366.452l-1.784,9.685,5.375-8.238a16,16,0,0,1,2.006,1.332l-5.306,8.131,7.97-5.489a16.928,16.928,0,0,1,1.363,1.991l-8.054,5.543,9.532-2.006a16.1,16.1,0,0,1,.482,2.358l-9.425,1.983,9.44,1.738a15.954,15.954,0,0,1-.459,2.366l-9.516-1.753,8.077,5.267a15.985,15.985,0,0,1-1.332,2.006l-7.97-5.2,5.39,7.817a16.056,16.056,0,0,1-1.991,1.363l-5.443-7.9,1.968,9.379a14.981,14.981,0,0,1-2.358.49l-1.952-9.271-1.715,9.325a15.935,15.935,0,0,1-2.366-.444L366,440.748l-5.252,8.039a15.967,15.967,0,0,1-2.014-1.317l5.191-7.947-7.84,5.405a15.515,15.515,0,0,1-1.378-1.983l7.939-5.466-9.471,1.991a14.821,14.821,0,0,1-.505-2.358l9.379-1.975-9.471-1.746a15.253,15.253,0,0,1,.436-2.373Z",
    transform: "translate(-340.981 -407.635)",
    fill: "#9ba1ab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(165.738 122.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M402.458,424.253,369.33,357.576l3.836-1.906,33.082,66.585C404.992,422.929,403.721,423.587,402.458,424.253Z",
    transform: "translate(-369.33 -355.67)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M406.555,422.615l-32.921-66.271a1.567,1.567,0,0,1-.084-.375l.6-.3,33.082,66.585C407.007,422.377,406.785,422.492,406.555,422.615Z",
    transform: "translate(-370.319 -355.67)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M402.458,424.614,369.33,357.937l1.462-.727,33.1,66.646c-.482.253-.965.505-1.447.766Z",
    transform: "translate(-369.33 -356.031)",
    fill: "#838991"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(166.534 189.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M441.073,454.352,418.917,472.3,399.21,444.82l41.81-1.96Z",
    transform: "translate(-377.13 -442.86)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M412.172,460.871l-41.8.26,22.065-17.953,41.8-.268Z",
    transform: "translate(-370.37 -442.872)",
    fill: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M326.044,339.128l-99.468.628c-4.418.031-11.408,6.094-15.128,8.475-10.734,6.867-17.525,19.247-13.107,19.217l108.969,4.885c4.418-.031,26.819-20.84,26.789-25.257a8.009,8.009,0,0,0-8.054-7.955Z",
    transform: "translate(-163.193 -229.439)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M337.1,340.345a7.993,7.993,0,0,0-4.3-1.225l-99.468.628a8.012,8.012,0,0,0-7.426,5.145c-2.458,7.6,42.162,4.019,83.084,3.767,40.968-.26,31.045-3.361,28.105-8.307Z",
    transform: "translate(-169.953 -229.439)",
    fill: "#de9735"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(57.305 68.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M228.011,343.643l5.275-.031-.3-46.947a5.569,5.569,0,0,1,5.528-5.6l92.233-.582a5.569,5.569,0,0,1,5.6,5.528l.3,46.947,5.275-.031-.3-46.947a10.843,10.843,0,0,0-10.9-10.764l-92.233.582a10.843,10.843,0,0,0-10.764,10.9l.3,46.947Z",
    transform: "translate(-227.705 -285.212)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M227.708,296.694a10.848,10.848,0,0,1,10.764-10.9l92.233-.582a10.843,10.843,0,0,1,10.9,10.764l.3,46.939a2.855,2.855,0,0,1-.965-2.09l-.276-43.594a10.461,10.461,0,0,0-10.519-10.389l-91.1.574a10.461,10.461,0,0,0-10.389,10.519l.276,43.594a2.874,2.874,0,0,1-.934,2.105l-.3-46.939Z",
    transform: "translate(-227.7 -285.21)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M232.263,344.093l-.283-45.6a8.875,8.875,0,0,1,8.82-8.927l89.63-.567a8.875,8.875,0,0,1,8.927,8.82l.283,45.6-2.014.015-.291-46.526a5.574,5.574,0,0,0-5.6-5.528l-92.233.582a5.574,5.574,0,0,0-5.528,5.6l.291,46.526-2.014.015Z",
    transform: "translate(-228.703 -286.098)",
    fill: "#90959c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(57.305 78.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M341.607,299.178l-5.275.031.291,45.936a5.569,5.569,0,0,1-5.528,5.6l-92.233.582a5.569,5.569,0,0,1-5.6-5.528l-.291-46.526-5.275.031.291,46.526a10.843,10.843,0,0,0,10.9,10.764l92.233-.582a10.843,10.843,0,0,0,10.764-10.9L341.6,299.17Z",
    transform: "translate(-227.7 -298.267)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M341.9,344.838a10.848,10.848,0,0,1-10.764,10.9l-92.233.582A10.843,10.843,0,0,1,228,345.557l-.3-46.939c.475-.628,1.485-1.018,1.21-.008l.023,45.691a10.461,10.461,0,0,0,10.519,10.389l91.1-.574A10.461,10.461,0,0,0,340.941,343.6l-.368-44.688c0-.835.5-.6,1.034,0l.291,45.936Z",
    transform: "translate(-227.7 -297.991)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M339.33,298.953l.352,45.079a8.874,8.874,0,0,1-8.82,8.927l-89.63.567a8.874,8.874,0,0,1-8.927-8.82l-.145-45.6,1.868-.015.291,46.526a5.574,5.574,0,0,0,5.6,5.528l92.233-.582a5.574,5.574,0,0,0,5.528-5.6l-.291-46.526,1.952.505Z",
    transform: "translate(-228.745 -298.096)",
    fill: "#90959c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M335.031,284.3c-3.736,6.347-2.925,3.874-33.212,4.058s-37.124.23-43.686.276-4.961-2.32-3.629-3.828,3.69-3.315,5.443-3.323,73.33-.459,75.068-.475,2.481,3.277,2.481,3.277l-2.458.015Z",
    transform: "translate(-176.398 -215.819)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(4.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(0 1.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M160.5,197.633h.528l2.1-.015,42.4-.268a10.843,10.843,0,0,1,10.9,10.764l.735,116.977-5.275.031-.735-116.977a5.574,5.574,0,0,0-5.6-5.528l-42.583.268h-.015l-1.562.008h-.505c-2.419.015-1.73-5.26-.39-5.275Z",
    transform: "translate(-159.281 -197.35)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0.007 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M216.24,324.586l-.727-115.208a10.461,10.461,0,0,0-10.519-10.389l-45.554.283c.191-.911.6-1.638,1.095-1.638h.528l2.1-.015,42.4-.268a10.843,10.843,0,0,1,10.9,10.764l.735,116.977h-.835a2.2,2.2,0,0,1-.115-.505Z",
    transform: "translate(-159.325 -197.35)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M159.305,201.413l44.933-.283a8.875,8.875,0,0,1,8.927,8.82l.727,116.043-2.014.015-.735-116.977a5.574,5.574,0,0,0-5.6-5.528l-42.583.268h-.015l-1.562.008h-.505c-1.133,0-1.562-1.148-1.592-2.373Z",
    transform: "translate(-159.29 -198.236)",
    fill: "#838991"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M176.728,195.982l19.837-.122c2.886-.015,5.229,1.8,5.244,4.058s-2.312,4.111-5.2,4.127l-19.837.122c-2.886.015-5.229-1.8-5.244-4.058S173.842,196,176.728,195.982Z",
    transform: "translate(-162.152 -195.86)",
    fill: "#3b393a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(6.062 55.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M162.025,397.122h.528l2.1-.015,42.4-.268a10.843,10.843,0,0,0,10.764-10.9L217.08,268.96l-5.275.031.735,116.977a5.569,5.569,0,0,1-5.528,5.6l-42.583.268h-.015l-1.562.008h-.505c-2.419.015-1.669,5.283-.329,5.275Z",
    transform: "translate(-160.768 -268.96)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(0.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M216.186,269.481l.727,115.208a10.456,10.456,0,0,1-10.389,10.519l-45.554.283c.207.911.62,1.631,1.11,1.631h.528l2.1-.015,42.4-.268a10.843,10.843,0,0,0,10.764-10.9l-.735-116.977H216.3A3.009,3.009,0,0,0,216.186,269.481Z",
    transform: "translate(-160.832 -268.96)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M160.8,394.253l44.933-.283a8.875,8.875,0,0,0,8.82-8.927L213.824,269l-2.014.015.735,116.977a5.569,5.569,0,0,1-5.528,5.6l-42.583.268h-.015l-1.562.008h-.505c-1.133,0-1.554,1.164-1.562,2.4Z",
    transform: "translate(-160.79 -268.969)",
    fill: "#838991"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(166.044 95.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M370.281,409.086l-.551-87.195,5.275-.031.544,86.59A26.529,26.529,0,0,0,370.281,409.086Z",
    transform: "translate(-369.73 -321.339)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M375.908,408.344c0-.061.015-.115.015-.176l-.544-86.935c0-.184.084.176.115,0h.835l.544,87.049c-.329.008-.643.038-.965.054Z",
    transform: "translate(-371.054 -321.18)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M370.281,408.947l-.551-87.662,2.014-.015.551,87.256v.069c-.681.1-1.355.207-2.006.352Z",
    transform: "translate(-369.73 -321.201)",
    fill: "#838991"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(63.743 151.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M144.96,302.29c-5.1-20.35-14.378-76.224-27.148-95.188C99.039,179.219,83.26,222.031,83.26,222.031s13.835,52.383,23.4,65.735,8.016,14.057,8.123,21.054,30.173-6.538,30.173-6.538Z",
    transform: "translate(-83.26 -197.669)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(30.864 75.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M139.837,417.808s-1.47,15.029-1.784,24.423-3.882,9.118-2.634,13.7c1.164,4.264,3.989,3.514,14.493,2.84s20.457-.59,25.41-1.2,1.072-5.8-1.248-6.263-14.363-2.3-17.793-3.951c-7.235-3.476-4.67-18.711-4.67-18.711L139.837,417.8Z",
    transform: "translate(-126.288 -324.951)",
    fill: "#f07e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M125.186,311.519c1.937-.7-.092-6.76,1.937-7.235,2.527-.6,1.271-4.341,3.851-4.731,2.519-.383,5.229-4.418,6.936-2.526,4.326,4.793,13.781,17.211,16.284,26.237.452,11.576,1.263,17.716-.283,39.9-1.9,27.095-6.485,41.871-3.866,52.62,2.557,10.489-18.627,9.953-16.116,3.575,2.779-7.051.528-28.863-3.675-43.188-13.36-45.546-2.029-46.112-5.061-64.633Z",
    transform: "translate(-123.573 -296.525)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M188.345,466.594h-.031a.284.284,0,0,1-.283-.291h0s-.069-.528-1.2-1.432c-1.2-.957-4.058-.6-4.088-.6a.3.3,0,0,1-.322-.245.286.286,0,0,1,.245-.322c.122-.023,3.124-.383,4.517.72,1.355,1.072,1.416,1.753,1.416,1.883a.289.289,0,0,1-.253.283Z",
    transform: "translate(-137.366 -335.694)",
    fill: "#a3634c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M188.384,464.084a.28.28,0,0,1-.237-.084,1.566,1.566,0,0,0-.919-.406.288.288,0,0,1,.038-.574,2.162,2.162,0,0,1,1.294.582.289.289,0,0,1,0,.406.3.3,0,0,1-.168.084Z",
    transform: "translate(-138.431 -335.55)",
    fill: "#a3634c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M186.978,462.507a.38.38,0,0,1-.13-.015l-.6-.222a.29.29,0,0,1-.168-.367.283.283,0,0,1,.367-.168l.6.222a.29.29,0,0,1,.168.367A.271.271,0,0,1,186.978,462.507Z",
    transform: "translate(-138.219 -335.244)",
    fill: "#a3634c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M152.142,340.859a.612.612,0,0,0,.084-.038.262.262,0,0,0,.061-.375c-3.07-4.3-10.1-11.009-10.167-11.078a.271.271,0,1,0-.375.39c.069.069,7.059,6.737,10.1,11a.288.288,0,0,0,.291.107Z",
    transform: "translate(-127.813 -304.205)",
    fill: "#b55d3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(37.92 192.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M134.955,468.331a16.454,16.454,0,0,0,.643,3.085c.314.5,8.835,1.378,10.473,1.148,0,0,.857-1.217,1.554-1.148s6.737.582,8.912,2.128,17.027.773,20.932-.084c1.171-.26,1.677-4.111,1.677-4.111L143.4,467.81l-8.46.528Z",
    transform: "translate(-133.293 -453.471)",
    fill: "#453a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M134.229,450.305a.942.942,0,0,1,1.279-.651c2.228,1.018,7.511,2.886,10.9,1.853a43.453,43.453,0,0,0,6.607-2.274,1.062,1.062,0,0,1,1.233.1c1.233,1,4.548,4.938,10.833,5.2,7.717.322,16.989,6.094,13.161,11.913-.62.942-9.417,1.776-16.759,1.738-4.517-.023-10.152-1.309-14.125-1.547-4.088-.245-7.411-.513-9-.727-5.91-.812-6.814-6.707-4.15-15.6Z",
    transform: "translate(-132.789 -449.081)",
    fill: "#c95d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M158.484,449.333a1.063,1.063,0,0,0-1.233-.1,28.507,28.507,0,0,1-5.918,2.618c-.337.291-.544.475-.544.475l9.417,7.733a64.87,64.87,0,0,0,6.515-5.9c-4.609-1.034-7.189-3.989-8.238-4.839Z",
    transform: "translate(-137.008 -449.081)",
    fill: "#bd5346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M165.867,469.642c1.86.008,3.813-.038,5.7-.122l3.3-12.487a19.674,19.674,0,0,0-5.4-1.034,14.21,14.21,0,0,1-3.82-.689h-.038c-4.448,4.716-3.6,5.3-7.625,5.061-3.851-.23-6.867,4.624-6.546,7.71.1,0,.2.015.3.015,3.973.237,9.608,1.523,14.125,1.547Z",
    transform: "translate(-137.156 -450.541)",
    fill: "#9e463a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M177.97,456.89c-5.244,3.882-5.972,11.14-5.65,13.115,6.975-.077,14.623-.857,15.2-1.73C190.748,463.352,184.608,458.475,177.97,456.89Z",
    transform: "translate(-142.04 -450.912)",
    fill: "#bd5346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M139.186,457.016c-2.6-1.508-1.8-3.491-2.534-6.6,0,0-.942-.107-2.236-.207a1.237,1.237,0,0,0-.191.36c-2.657,8.889-1.761,14.784,4.15,15.6,1.478.2,4.479.452,8.184.681-.3-5.765-4.862-8.368-7.38-9.823Z",
    transform: "translate(-132.793 -449.346)",
    fill: "#bd5346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M167.388,455.141a7.255,7.255,0,0,0-2.81,2.649c-.88,1.669-1.6,1.608-1.5.773s2.144-3.116,2.817-3.422a5.342,5.342,0,0,0,.988-.551l.911.367-.413.176Z",
    transform: "translate(-139.886 -450.373)",
    fill: "#453a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M165.02,453.718a8.709,8.709,0,0,0-3.422,2.45c-.934,1.447-1.263,1.669-1.409,1.539s-.436-.544.176-1.378a7.431,7.431,0,0,1,3.981-3.009l.666.4Z",
    transform: "translate(-139.165 -450.075)",
    fill: "#453a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M162.761,452.192l-.612-.482a9.021,9.021,0,0,0-2.588,1.493,6.253,6.253,0,0,0-1.6,1.952c-.161.482.36.789.75.145a7.4,7.4,0,0,1,1.906-2.067,9.9,9.9,0,0,1,2.151-1.049Z",
    transform: "translate(-138.682 -449.697)",
    fill: "#453a34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(69.642 167.83)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M124.946,220.376c10.887,29.1,21.108,76.094,22.218,83.2s1,90.089-.107,93.641-12.349,3.453-17.173,7.779-7.932,3.108-8.6-.559-3.108-45.653-5.329-62.32-1.11-33.771-1.776-35.654-22.769-30.655-23.213-62.872,33.993-23.213,33.993-23.213Z",
    transform: "translate(-90.964 -219.218)",
    fill: "#ff9b54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(-27.714 -16.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(11.085 68.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M71.293,288.08s-5.145,7.036.873,11.576,14.868,2.006,14.868,2.006-9.478,2.1-13.628-5.007-2.113-8.575-2.113-8.575Z",
    transform: "translate(-69.244 -287.308)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M86.774,288.433s-6.209-4.1-8.82,1.937S85.143,301.7,85.143,301.7a16.278,16.278,0,0,0,3.82-.276s-4.31-.191-8.169-5.336-.26-8.284,1.837-8.246A19.549,19.549,0,0,1,86.774,288.433Z",
    transform: "translate(-71.182 -287.071)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M91.279,293.56c-.23-.015-2.473.658-2.519,3.667s3,4.594,3,4.594a6.791,6.791,0,0,1-1.684-5.26c.421-3.1,1.21-3,1.21-3Z",
    transform: "translate(-73.819 -288.592)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(7.491 92.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M76.861,334.853h0a14.605,14.605,0,0,0-1.462-8.031c-3.261-6.753-7.1-8.161-7.1-8.161s5.742,6.408,5.987,12.625-1.37,8.391-3.866,10.986c-1.883,1.439-5.865,1.868-5.865,1.868s6.913,2.641,10.305-2.664a14.313,14.313,0,0,0,2-6.615Z",
    transform: "translate(-64.55 -318.66)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M75.308,345.979a10.273,10.273,0,0,0,7.013-7.342,11.53,11.53,0,0,0,.115-3.706c-.712-5.65-3.216-7.411-3.216-7.411s2.649,5.849,1.256,10.55a14.215,14.215,0,0,1-2.136,4.624c-2,2.894-3.039,3.292-3.039,3.292Z",
    transform: "translate(-67.07 -320.737)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(42.241 25.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M122.251,248.293h0a14.605,14.605,0,0,0-1.462-8.031c-3.261-6.753-7.1-8.161-7.1-8.161s5.742,6.408,5.987,12.625-1.37,8.391-3.866,10.986c-1.883,1.439-5.865,1.868-5.865,1.868s6.913,2.641,10.305-2.664a14.315,14.315,0,0,0,2-6.622Z",
    transform: "translate(-109.94 -232.1)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M120.7,259.409a10.273,10.273,0,0,0,7.013-7.342,11.53,11.53,0,0,0,.115-3.706c-.712-5.65-3.216-7.411-3.216-7.411s2.649,5.849,1.256,10.55a14.215,14.215,0,0,1-2.136,4.624c-2,2.894-3.039,3.292-3.039,3.292Z",
    transform: "translate(-112.46 -234.174)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(0 54.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M142.318,420.4h0a14.687,14.687,0,0,1,7.449-3.346c7.411-1.141,10.749,1.225,10.749,1.225s-8.536-1.1-13.8,2.22-6.14,5.888-6.867,9.409c-.122,2.366,1.784,5.888,1.784,5.888s-6.094-4.2-3.644-10.006a14.352,14.352,0,0,1,4.318-5.4Z",
    transform: "translate(-74.138 -304.235)",
    fill: "#f2cca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M55.259,283.686a10.271,10.271,0,0,1,2.075-9.938,11.706,11.706,0,0,1,2.986-2.2C65.38,268.94,68.251,270,68.251,270s-6.324,1.133-9.409,4.938a13.957,13.957,0,0,0-2.6,4.379c-1.256,3.284-.988,4.364-.988,4.364Z",
    transform: "translate(-54.766 -269.79)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(26.053 84.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M92.022,323.87a2.532,2.532,0,0,0-.283-.758,16.1,16.1,0,0,1-.123-7.388c.6-3.522,1.141-7.534,1.141-7.534s-4.586,8.215-3.889,12.671a14.818,14.818,0,0,0,1.623,4.846c.965,2.465,5.918,4.663,5.918,4.663S92.734,326.718,92.022,323.87Z",
    transform: "translate(-88.796 -308.19)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M96.8,320.171c.4-1.026.9-1.968,1.141-2.817.789-2.657-.429-6.944-.429-6.944a16.231,16.231,0,0,1-1.416,6.048,14.346,14.346,0,0,0-1.279,6.2,4.9,4.9,0,0,0,1.792,2.6s-.681-3.062.184-5.1Z",
    transform: "translate(-90.203 -308.71)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(49.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M124.237,213.349a2.382,2.382,0,0,0-.505-.635,16.143,16.143,0,0,1-2.35-7c-.5-3.537-1.194-7.526-1.194-7.526s-1.876,9.218.138,13.253a14.753,14.753,0,0,0,3.016,4.127c1.669,2.059,7.051,2.649,7.051,2.649s-4.609-2.366-6.155-4.869Z",
    transform: "translate(-119.393 -198.19)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M127.554,208.5c.061-1.1.253-2.144.237-3.032-.054-2.771-2.511-6.485-2.511-6.485a16.163,16.163,0,0,1,.49,6.194,14.239,14.239,0,0,0,.666,6.293,4.9,4.9,0,0,0,2.5,1.937s-1.577-2.71-1.37-4.915Z",
    transform: "translate(-120.773 -198.375)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(29.636 41.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M96.7,268.43a2.532,2.532,0,0,0-.283-.758,16.1,16.1,0,0,1-.123-7.388c.6-3.522,1.141-7.534,1.141-7.534s-4.586,8.215-3.889,12.671a14.818,14.818,0,0,0,1.623,4.846c.965,2.465,5.918,4.663,5.918,4.663s-3.675-3.652-4.387-6.5Z",
    transform: "translate(-93.476 -252.75)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M101.478,264.742c.4-1.026.9-1.968,1.141-2.817.789-2.657-.429-6.944-.429-6.944a16.231,16.231,0,0,1-1.416,6.048,14.346,14.346,0,0,0-1.279,6.2,4.9,4.9,0,0,0,1.792,2.6s-.681-3.062.184-5.1Z",
    transform: "translate(-94.883 -253.273)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M120.832,400.62a20.518,20.518,0,0,0,2.2-1.118c4.326-2.565,5.987-8.713,5.987-8.713s-1.86,2.105-5.635,5.665c-2.159,2.036-5.367,2.611-7.717,2.733a12.39,12.39,0,0,1-4.854-2.121,20.05,20.05,0,0,0,8.942,5.321,18.983,18.983,0,0,0,6.737-.306c5.65-1.355,7.779-4.3,7.779-4.3s-7.932,3.346-13.429,2.84Z",
    transform: "translate(-67.902 -243.334)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M138,421.646c-6.347-4.693-6.01-7.656-6.01-7.656-1,2.917.383,7.5,4.486,10.083,4.953,3.353,10.16.283,10.16.283a15.268,15.268,0,0,1-8.644-2.71Z",
    transform: "translate(-72.795 -248.772)",
    fill: "#f2cca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M104.512,230.142c1.792-7.687,4.647-8.552,4.647-8.552-3.078.237-6.73,3.323-7.48,8.115-1.118,5.88,3.767,9.44,3.767,9.44a15.189,15.189,0,0,1-.934-9.011Z",
    transform: "translate(-65.723 -203.675)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M158.37,445.412c3.843-6.9,6.822-6.936,6.822-6.936-3.016-.62-7.388,1.34-9.432,5.734-2.695,5.344,1.018,10.114,1.018,10.114a15.176,15.176,0,0,1,1.592-8.919Z",
    transform: "translate(-78.208 -254.485)",
    fill: "#f2cca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M82.606,358.884c-7.5,2.458-9.716.467-9.716.467,1.8,2.5,6.339,4.035,10.818,2.182,5.6-2.1,6.117-8.123,6.117-8.123a15.23,15.23,0,0,1-7.22,5.474Z",
    transform: "translate(-59.014 -234.573)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(34.585 60.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M111.057,289.99a34.621,34.621,0,0,1-5.3,4.793,24.967,24.967,0,0,1-5.819,3.039,14.017,14.017,0,0,0,4.624-.184c4.349-1.286,6.492-7.648,6.492-7.648Z",
    transform: "translate(-99.94 -280.244)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M115.631,277.26s-3.093,8.123-8.644,10.06a10.922,10.922,0,0,1-6.737.7,8.671,8.671,0,0,0,6.393,1.2c3.621-.222,9.249-8.491,8.988-11.966Z",
    transform: "translate(-100.013 -277.26)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(60.968 14.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M145.517,229.49a34.621,34.621,0,0,1-5.3,4.793,24.968,24.968,0,0,1-5.819,3.039,14.018,14.018,0,0,0,4.624-.184c4.349-1.286,6.492-7.648,6.492-7.648Z",
    transform: "translate(-134.4 -219.744)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M150.091,216.76s-3.093,8.123-8.644,10.06a10.922,10.922,0,0,1-6.737.7,8.671,8.671,0,0,0,6.393,1.2c3.621-.222,9.249-8.491,8.988-11.966Z",
    transform: "translate(-134.473 -216.76)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(9.198 28.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M77.9,248.45a34.621,34.621,0,0,1-5.3,4.793,24.968,24.968,0,0,1-5.819,3.039A14.018,14.018,0,0,0,71.4,256.1C75.753,254.812,77.9,248.45,77.9,248.45Z",
    transform: "translate(-66.78 -238.704)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M82.471,235.72s-3.093,8.123-8.644,10.06a10.922,10.922,0,0,1-6.737.7,8.671,8.671,0,0,0,6.393,1.2c3.621-.222,9.249-8.491,8.988-11.966Z",
    transform: "translate(-66.853 -235.72)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(55.517 187.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M138.4,455.53a34.62,34.62,0,0,1-5.3,4.793,24.967,24.967,0,0,1-5.819,3.039,14.017,14.017,0,0,0,4.624-.184c4.349-1.286,6.492-7.648,6.492-7.648Z",
    transform: "translate(-127.28 -445.784)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M142.971,442.8s-3.093,8.123-8.644,10.06a10.922,10.922,0,0,1-6.737.7,8.671,8.671,0,0,0,6.393,1.2c3.621-.222,9.249-8.491,8.988-11.966Z",
    transform: "translate(-127.353 -442.8)",
    fill: "#f2cca7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(66.652 98.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M143.184,329.76s-4.249,7.61,2.274,11.385,15,.184,15,.184-9.149,3.239-14.133-3.307-3.139-8.253-3.139-8.253Z",
    transform: "translate(-141.824 -327.823)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M158.583,328.1s-6.661-3.323-8.521,3,8.521,10.366,8.521,10.366a16.052,16.052,0,0,0,3.759-.743s-4.3.337-8.759-4.3-1.263-8.192.819-8.406a19.165,19.165,0,0,1,4.188.084Z",
    transform: "translate(-143.702 -327.231)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M163.61,332.75c-.23.008-2.373.957-2.059,3.951s3.537,4.2,3.537,4.2a6.794,6.794,0,0,1-2.312-5.015c.038-3.124.835-3.124.835-3.124Z",
    transform: "translate(-146.44 -328.524)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(68.387 124.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M155.168,375.449h0a14.68,14.68,0,0,0-2.427-7.794c-4.058-6.309-8.047-7.235-8.047-7.235s6.477,5.658,7.48,11.806-.337,8.5-2.5,11.377c-1.692,1.661-5.589,2.572-5.589,2.572s7.189,1.784,9.907-3.9a14.364,14.364,0,0,0,1.179-6.814Z",
    transform: "translate(-144.09 -360.42)",
    fill: "#f2cca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M154.71,386.666a10.279,10.279,0,0,0,6.071-8.138,11.751,11.751,0,0,0-.337-3.69c-1.4-5.528-4.1-6.967-4.1-6.967s3.338,5.482,2.534,10.32a14.436,14.436,0,0,1-1.554,4.846c-1.631,3.116-2.611,3.637-2.611,3.637Z",
    transform: "translate(-146.579 -362.166)",
    fill: "#f2cca7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(94.8 54.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M189.668,284h0a14.679,14.679,0,0,0-2.427-7.794c-4.058-6.309-8.047-7.235-8.047-7.235s6.477,5.658,7.48,11.806-.337,8.5-2.5,11.377c-1.692,1.661-5.589,2.572-5.589,2.572s7.189,1.784,9.907-3.9a14.365,14.365,0,0,0,1.179-6.814Z",
    transform: "translate(-178.59 -268.97)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M189.22,295.216a10.279,10.279,0,0,0,6.071-8.138,11.75,11.75,0,0,0-.337-3.69c-1.4-5.528-4.1-6.967-4.1-6.967s3.338,5.482,2.534,10.32a14.436,14.436,0,0,1-1.554,4.846c-1.631,3.116-2.611,3.637-2.611,3.637Z",
    transform: "translate(-181.082 -270.716)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(54.529 86.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M131.33,318.242h0a14.573,14.573,0,0,1,6.982-4.226c7.22-2.037,10.818-.092,10.818-.092s-8.605-.054-13.421,3.889-5.375,6.592-5.665,10.175c.168,2.366,2.488,5.627,2.488,5.627s-6.561-3.43-4.831-9.486a14.42,14.42,0,0,1,3.629-5.888Z",
    transform: "translate(-126.323 -312.051)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M126.924,326.967a10.28,10.28,0,0,1,.85-10.121,11.576,11.576,0,0,1,2.7-2.542c4.708-3.208,7.679-2.5,7.679-2.5s-6.133,1.891-8.736,6.048a14.207,14.207,0,0,0-2.044,4.663c-.842,3.415-.452,4.456-.452,4.456Z",
    transform: "translate(-125.99 -311.734)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(39.585 125.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M110.781,377.008a2.558,2.558,0,0,0-.452-.681,16.109,16.109,0,0,1-1.769-7.174c-.207-3.568-.574-7.6-.574-7.6s-2.634,9.034-.957,13.222a14.8,14.8,0,0,0,2.672,4.364c1.493,2.19,6.806,3.223,6.806,3.223s-4.4-2.733-5.727-5.359Z",
    transform: "translate(-106.471 -361.55)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M114.616,372.43c.153-1.087.429-2.121.49-3,.176-2.764-1.968-6.668-1.968-6.668a16.158,16.158,0,0,1-.023,6.209,14.412,14.412,0,0,0,.138,6.332,4.9,4.9,0,0,0,2.327,2.144s-1.347-2.833-.965-5.015Z",
    transform: "translate(-107.964 -361.834)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(96.399 27.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M186.644,249.182a2.61,2.61,0,0,0-.574-.574,16.143,16.143,0,0,1-3.185-6.661c-.926-3.445-2.105-7.327-2.105-7.327s-.735,9.379,1.753,13.138a14.66,14.66,0,0,0,3.5,3.729c1.906,1.837,7.319,1.769,7.319,1.769s-4.862-1.784-6.7-4.081Z",
    transform: "translate(-180.678 -234.62)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M189.122,243.992c-.069-1.095-.008-2.159-.138-3.039-.39-2.741-3.284-6.132-3.284-6.132a16.257,16.257,0,0,1,1.24,6.087,14.316,14.316,0,0,0,1.424,6.171,4.946,4.946,0,0,0,2.718,1.623s-1.9-2.5-1.96-4.708Z",
    transform: "translate(-181.855 -234.667)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(82.462 71.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M166.23,307.1a2.681,2.681,0,0,0-.375-.72,16.136,16.136,0,0,1-1.018-7.319c.161-3.568.214-7.618.214-7.618s-3.545,8.713-2.32,13.054a14.848,14.848,0,0,0,2.2,4.617c1.256,2.327,6.439,3.9,6.439,3.9s-4.1-3.177-5.145-5.918Z",
    transform: "translate(-162.474 -291.44)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M170.526,302.9c.268-1.072.651-2.06.8-2.932.459-2.733-1.271-6.837-1.271-6.837a16.158,16.158,0,0,1-.666,6.178,14.32,14.32,0,0,0-.513,6.309,4.887,4.887,0,0,0,2.1,2.366S169.921,305.028,170.526,302.9Z",
    transform: "translate(-163.937 -291.836)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M129.629,377.547a20.831,20.831,0,0,0,2.044-1.378c3.981-3.078,4.877-9.379,4.877-9.379s-1.585,2.32-4.908,6.309c-1.9,2.282-5.007,3.246-7.327,3.652a12.314,12.314,0,0,1-5.076-1.516,19.938,19.938,0,0,0,9.516,4.188,19.126,19.126,0,0,0,6.653-1.125c5.443-2.029,7.2-5.214,7.2-5.214s-7.472,4.287-12.985,4.456Z",
    transform: "translate(-69.878 -237.709)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M128.251,352.477c-6.875-3.882-6.9-6.867-6.9-6.867-.643,3.016,1.294,7.4,5.681,9.463,5.329,2.726,10.121-.957,10.121-.957a15.243,15.243,0,0,1-8.912-1.638Z",
    transform: "translate(-70.345 -232.744)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M172.877,271.309c.835-7.847,3.568-9.049,3.568-9.049-3.024.6-6.278,4.119-6.431,8.965-.39,5.972,4.892,8.912,4.892,8.912a15.194,15.194,0,0,1-2.029-8.827Z",
    transform: "translate(-81.775 -213.208)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M114.777,310.972c2.971-7.312,5.926-7.717,5.926-7.717-3.07-.253-7.174,2.228-8.659,6.845-2.021,5.635,2.243,9.915,2.243,9.915A15.176,15.176,0,0,1,114.777,310.972Z",
    transform: "translate(-68.064 -222.812)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M163.063,398.109c-7.143,3.353-9.593,1.646-9.593,1.646,2.09,2.266,6.783,3.231,11,.85,5.306-2.764,5.084-8.8,5.084-8.8a15.209,15.209,0,0,1-6.492,6.309Z",
    transform: "translate(-77.902 -243.571)",
    fill: "#f2cca7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(78.47 106.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M168.123,351.06a34.451,34.451,0,0,1-4.678,5.4,25.111,25.111,0,0,1-5.405,3.729,13.956,13.956,0,0,0,4.571-.743C166.768,357.644,168.123,351.06,168.123,351.06Z",
    transform: "translate(-157.443 -340.832)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M171.217,337.708s-2.075,8.437-7.357,11.04a10.874,10.874,0,0,1-6.6,1.516,8.658,8.658,0,0,0,6.492.413c3.568-.658,8.146-9.547,7.465-12.977Z",
    transform: "translate(-157.26 -337.7)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(69.191 32.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M156,254.35a34.449,34.449,0,0,1-4.678,5.4,25.11,25.11,0,0,1-5.405,3.728,14.2,14.2,0,0,0,4.571-.743c4.157-1.8,5.512-8.383,5.512-8.383Z",
    transform: "translate(-145.323 -244.122)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M159.1,241s-2.075,8.437-7.357,11.04a10.874,10.874,0,0,1-6.6,1.516,8.658,8.658,0,0,0,6.492.413c3.568-.658,8.146-9.547,7.465-12.977Z",
    transform: "translate(-145.14 -240.99)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(60.777 59.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M145,289.28a34.451,34.451,0,0,1-4.678,5.4,25.11,25.11,0,0,1-5.405,3.728,14.2,14.2,0,0,0,4.571-.743c4.157-1.8,5.512-8.383,5.512-8.383Z",
    transform: "translate(-134.33 -279.052)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M148.107,275.928s-2.075,8.437-7.357,11.04a10.874,10.874,0,0,1-6.6,1.516,8.658,8.658,0,0,0,6.492.413c3.568-.658,8.146-9.547,7.465-12.977Z",
    transform: "translate(-134.15 -275.92)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(34.807 101.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M111.083,344.06a34.451,34.451,0,0,1-4.678,5.4A25.111,25.111,0,0,1,101,353.186a13.955,13.955,0,0,0,4.571-.743c4.157-1.8,5.512-8.383,5.512-8.383Z",
    transform: "translate(-100.41 -333.839)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M114.187,330.71s-2.075,8.437-7.357,11.04a10.928,10.928,0,0,1-6.6,1.524,8.658,8.658,0,0,0,6.492.413c3.568-.658,8.146-9.547,7.465-12.977Z",
    transform: "translate(-100.23 -330.71)",
    fill: "#ffe4c7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(144.231 142.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M188.39,188.361s3.537-2.9,6.944-1.256,7.939,7.587,10.106,9.287-2.519,1.141-3.591.352-5.107-4.081-5.107-4.081l-5.007-1.095-3.346-3.216Z",
    transform: "translate(-188.39 -186.6)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M195.9,193.851l.184.023a4.918,4.918,0,0,1,3.376,1.432c.521.421.965.812,1.363,1.164a11.923,11.923,0,0,0,2.167,1.646c1.2.635,3.269,1.217,3.866.628.253-.253-.237-.666-1.133-1.378a18.044,18.044,0,0,1-2.611-2.825c.1-.061,2.105,1.914,2.894,2.549.988.8,1.7,1.37,1.156,1.906-.873.888-3.338,0-4.395-.559a11.984,11.984,0,0,1-2.251-1.7c-.39-.345-.842-.735-1.355-1.148a4.531,4.531,0,0,0-3.147-1.332l-.184-.023a6.539,6.539,0,0,1-3.009-1.164,16.369,16.369,0,0,0,3.062.789Z",
    transform: "translate(-189.428 -188.116)",
    fill: "#c76852"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(143.468 152.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M196.314,198.949c-1.118-.513-1.432,1.952-.827,4.463s.919,4.479,2.672,4.494,1.883-1.2,1.256-3.545-1.592-4.724-3.1-5.413Z",
    transform: "translate(-189.219 -198.881)",
    fill: "#e48b6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M192.07,205.791c.069-4.387-.207-6.048,1.187-6.041s2.488,6.087,1.845,7.243c-.689,1.225-3.055.727-3.024-1.2Z",
    transform: "translate(-188.489 -199.085)",
    fill: "#e48b6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M189.228,207.55c1.6.168,2.037-2.6,1.776-5.076s-1.118-2.282-2.381-.735c-2.3,2.817-.957,5.635.6,5.8Z",
    transform: "translate(-187.393 -199.282)",
    fill: "#e48b6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M204.114,205.164c.49,2,1.187,3.575-.49,3.935a.954.954,0,0,1-.291.023c-1.271.107-1.975-.635-2.2-1.883v-.054c-1.018-2.557-1.355-6.232-.536-6.8,1.324-.911,3.032,2.779,3.522,4.77Z",
    transform: "translate(-190.381 -199.2)",
    fill: "#e48b6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M200.128,202.718a3.864,3.864,0,0,0,0,.421c.008.138.023.276.038.421.038.276.069.551.115.827.092.544.2,1.087.314,1.623s.245,1.072.383,1.6.276,1.057.4,1.608a6.208,6.208,0,0,0,.031-1.684,14.748,14.748,0,0,0-.268-1.646q-.184-.815-.436-1.608c-.084-.268-.176-.528-.276-.789-.054-.13-.1-.26-.153-.39l-.077-.191a1.537,1.537,0,0,1-.077-.2Z",
    transform: "translate(-190.376 -199.778)",
    fill: "#a3634c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M195.21,201.65a15,15,0,0,0,.107,1.562c.054.513.13,1.026.207,1.531s.161,1.011.253,1.516c.023.122.038.253.069.383l.061.383c.023.13.031.253.054.383s.023.26.046.39a4.764,4.764,0,0,0,.207-1.569,10.572,10.572,0,0,0-.138-1.562,15.153,15.153,0,0,0-.329-1.531,9.172,9.172,0,0,0-.528-1.478Z",
    transform: "translate(-189.225 -199.53)",
    fill: "#a3634c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M191.95,202.72c-.115.888-.145,1.746-.2,2.6-.031.421-.054.85-.107,1.263a4.007,4.007,0,0,1-.314,1.233,1.615,1.615,0,0,0,.459-.505,2.846,2.846,0,0,0,.276-.628,5.668,5.668,0,0,0,.237-1.324,7.754,7.754,0,0,0-.046-1.332,5.4,5.4,0,0,0-.306-1.294Z",
    transform: "translate(-188.316 -199.781)",
    fill: "#a3634c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M256.09,174.461s10.045,1.164,14.11,7.886,4.525,11.048,4.441,20.549-2.58,10.359-3.966,16.208-10.366,28.113-6.921,41.779c3.185,12.655,4.441,17.663,4.441,17.663l-50.04,4.724s2.9-14.883-3.162-33.059A129.262,129.262,0,0,1,208.951,206c.482-6.921-8.246-18.849,16.56-29.583,14.026-6.071,30.578-1.96,30.578-1.96Z",
    transform: "translate(-48.719 -40.577)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M282.5,234.925c2.1-11.852,2.733-32.867,2.733-32.867s2.94-22.938-14.087-22.838c-7.335.046-10.78,6.883-11.561,14.072-.819,7.518,2.3,11.622,1.876,16.07s-5.933,18.4-2.488,35.317,8.36,9.157,12.64,8.207c5.29-1.164,8.8-6.11,10.895-17.961Z",
    transform: "translate(-60.439 -42.013)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M279.62,178.01c8.774,2.863,11.507,15.274,11.729,22.134s-.222,28.825-.222,28.825-1.554-.919-5,0-10.328,0-10.328,0Z",
    transform: "translate(-64.647 -41.729)",
    fill: "#bdccd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M284.259,243.981a.332.332,0,0,1-.329-.3.34.34,0,0,1,.3-.367c.107-.008.222-.023.329-.038a.336.336,0,0,1,.084.666c-.115.015-.23.031-.345.038h-.031Zm1.654-.26a.341.341,0,0,1-.329-.268.323.323,0,0,1,.26-.39c.4-.084.8-.176,1.194-.268l.1-.023a.333.333,0,1,1,.145.651l-.1.023c-.4.092-.8.184-1.21.268H285.9Zm2.6-.574a.333.333,0,0,1-.069-.658c.5-.1.942-.168,1.347-.214a.335.335,0,1,1,.069.666,11.982,11.982,0,0,0-1.286.207Zm3.966-.084a.352.352,0,0,1-.077-.008,7.405,7.405,0,0,0-1.256-.168.333.333,0,1,1,.023-.666,6.866,6.866,0,0,1,1.386.184.333.333,0,0,1-.069.658Z",
    transform: "translate(-66.552 -56.78)",
    fill: "#9facb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M284.549,242.241a.332.332,0,0,1-.329-.3.34.34,0,0,1,.3-.367c.107-.008.222-.023.329-.038a.336.336,0,0,1,.084.666c-.115.015-.23.031-.345.038h-.031Zm1.654-.26a.341.341,0,0,1-.329-.268.323.323,0,0,1,.26-.39c.4-.084.8-.176,1.194-.268l.1-.023a.333.333,0,0,1,.145.651l-.1.023c-.4.092-.8.184-1.21.268h-.069Zm2.6-.574a.333.333,0,0,1-.069-.658c.5-.1.942-.168,1.347-.214a.335.335,0,1,1,.069.666,11.982,11.982,0,0,0-1.286.207h-.061Zm3.966-.084a.351.351,0,0,1-.077-.008,7.408,7.408,0,0,0-1.256-.168.333.333,0,1,1,.023-.666,6.867,6.867,0,0,1,1.386.184.333.333,0,0,1-.069.658Z",
    transform: "translate(-66.62 -56.372)",
    fill: "#9facb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(179.882 229.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(116.776 87.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M407.426,426.232h0c-2.771-1.1-.88-12.678-.88-12.678l-18.436-.184s1.914,13.2,2.029,17.578,5.413,5.436,5.413,5.436l4.525.214a7.541,7.541,0,0,0,7.35-10.374Z",
    transform: "translate(-387.63 -413.37)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(0 9.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M388.308,446.745s1.914,4.739,2.251,5.16,8.759.567,10.351.237c0,0,.758-1.156,1.447-1.148s6.584.138,8.889,1.225c1.21.574,13.115-.13,15.7-1.225,1.08-.459,1.4-3.33,1.4-3.33l-30.379.406-9.67-1.34Z",
    transform: "translate(-387.674 -430.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M388.369,432.788a.949.949,0,0,1,1.21-.681c2.251.743,7.97,2.389,11.224,1.21a30.146,30.146,0,0,0,5.926-2.9,1.114,1.114,0,0,1,1.217,0c1.279.8,4.8,4.073,10.986,3.836,7.587-.3,12.464,5.306,9.118,10.8-.544.888-4.494,1.164-11.706,1.684-4.433.322-10.045-.406-13.965-.322-4.027.092-7.3.1-8.873.023-5.857-.283-7.143-5.489-5.145-13.635Z",
    transform: "translate(-387.483 -426.475)",
    fill: "#3a3b4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M409.946,433.513s2.863-.781.138-2.825-1.952-4.892-3.108-5.237a3.281,3.281,0,0,0-2.32.237c-2.427.75-4.678,2.167-3.943,3.177s1.608,2.213.145,3.292-6.462.26-8.314-1.6-3.369-3.323-3.9-.459-.957,5.428-.957,5.428,4.708,1.7,6.178,1.585,16.085-3.606,16.085-3.606Z",
    transform: "translate(-387.531 -425.324)",
    fill: "#3a3b4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M414.226,431.922s-4.908-.7-7.266,5c0,0,.13,1.677,1.24.138a13.545,13.545,0,0,1,2.052-2.657,9.062,9.062,0,0,1,5.306-1.608l-1.34-.873Z",
    transform: "translate(-392.048 -426.864)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M418.111,434.05a11.552,11.552,0,0,0-4.249,1.5,7.731,7.731,0,0,0-2.672,3.177c-.444,1.171.75,1.577,1.332.421a7.294,7.294,0,0,1,2.672-2.879,38.548,38.548,0,0,1,4.379-1.707l-1.455-.505Z",
    transform: "translate(-393.017 -427.369)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M422.659,435.19s-2.894,1.057-3.912,2.251A4.792,4.792,0,0,0,417.4,440.5c-.069.988.842,1.455,1.271-.1a4.9,4.9,0,0,1,2.557-3.193c1.416-.888,2.833-1.837,2.833-1.837l-1.409-.176Z",
    transform: "translate(-394.494 -427.636)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M381.824,307.878c9.746,3.369,11.369,15.879,13.773,30.571S402.534,398,402.534,398a23.843,23.843,0,0,1-22.478,2.726s-19.01-56-17.318-66.516,19.087-26.345,19.087-26.345Z",
    transform: "translate(-264.882 -301.238)",
    fill: "#86a9d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M235.212,314.307c-2.021,19.454,8.016,32.378,26.942,31.076s92.363-5.3,97.492-21.5c3.683-11.63,1-25.219-55.43-24.66-70.321.689-69,15.082-69,15.082Z",
    transform: "translate(-234.956 -299.208)",
    fill: "#86a9d4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M400.618,428.079a.337.337,0,0,1-.329-.283.33.33,0,0,1,.283-.375c.145-.023.291-.046.429-.061a.334.334,0,0,1,.107.658l-.436.069h-.046Zm1.746-.306a.341.341,0,0,1-.329-.268.323.323,0,0,1,.26-.39c.429-.092.865-.191,1.279-.3a.332.332,0,0,1,.168.643c-.429.115-.873.214-1.317.306h-.069Zm2.58-.674a.329.329,0,0,1-.314-.23.338.338,0,0,1,.214-.421c.421-.13.842-.276,1.24-.429a.332.332,0,1,1,.237.62c-.413.161-.842.306-1.279.444A.448.448,0,0,1,404.944,427.1Zm2.488-.949a.331.331,0,0,1-.138-.635c.406-.184.8-.383,1.171-.582a.334.334,0,1,1,.314.59c-.39.207-.8.413-1.217.6a.3.3,0,0,1-.138.031Zm2.335-1.279a.323.323,0,0,1-.276-.153.332.332,0,0,1,.092-.459,8.023,8.023,0,0,0,1.026-.766.33.33,0,1,1,.452.482,8.564,8.564,0,0,1-1.11.835.321.321,0,0,1-.184.054Z",
    transform: "translate(-93.826 -99.249)",
    fill: "#9bc2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M400.618,426.2a.337.337,0,0,1-.329-.283.33.33,0,0,1,.283-.375c.145-.023.291-.046.429-.061a.334.334,0,0,1,.107.658l-.436.069h-.046Zm1.746-.306a.341.341,0,0,1-.329-.268.323.323,0,0,1,.26-.39c.429-.092.865-.191,1.279-.3a.332.332,0,0,1,.168.643c-.429.115-.873.214-1.317.306h-.069Zm2.58-.674a.329.329,0,0,1-.314-.23.338.338,0,0,1,.214-.421c.421-.13.842-.276,1.24-.429a.332.332,0,1,1,.237.62c-.413.161-.842.306-1.279.444A.446.446,0,0,1,404.944,425.219Zm2.488-.949a.33.33,0,0,1-.306-.2.336.336,0,0,1,.168-.444c.406-.184.8-.383,1.171-.582a.335.335,0,0,1,.452.13.331.331,0,0,1-.138.452c-.39.207-.8.413-1.217.6a.3.3,0,0,1-.138.031Zm2.335-1.279a.323.323,0,0,1-.276-.153.332.332,0,0,1,.092-.459,8.032,8.032,0,0,0,1.026-.766.33.33,0,0,1,.452.482,8.562,8.562,0,0,1-1.11.835.321.321,0,0,1-.184.054Z",
    transform: "translate(-93.826 -98.808)",
    fill: "#9bc2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(284.776 323.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M391.906,435.372c-2.771-1.1-.88-12.678-.88-12.678l-18.436-.184s1.914,13.2,2.029,17.578,5.413,5.436,5.413,5.436,11.1,4.119,14.991.452-3.108-10.6-3.108-10.6Z",
    transform: "translate(-372.11 -422.51)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(0 9.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M372.788,455.885s1.914,4.739,2.251,5.16,8.759.567,10.351.237c0,0,.758-1.156,1.447-1.148s6.584.138,8.889,1.225c1.21.574,13.115-.13,15.7-1.225,1.08-.459,1.4-3.33,1.4-3.33l-30.379.406-9.67-1.34Z",
    transform: "translate(-372.154 -439.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M372.849,441.928a.949.949,0,0,1,1.21-.681c2.251.743,7.97,2.389,11.224,1.21a30.143,30.143,0,0,0,5.926-2.9,1.115,1.115,0,0,1,1.217,0c1.279.8,4.8,4.073,10.986,3.836,7.587-.3,12.464,5.306,9.118,10.8-.544.888-4.494,1.164-11.706,1.684-4.433.322-10.045-.406-13.965-.322-4.027.092-7.3.1-8.873.023-5.857-.283-7.143-5.489-5.145-13.635Z",
    transform: "translate(-371.963 -435.622)",
    fill: "#45465a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M394.426,442.663s2.863-.781.138-2.825-1.952-4.885-3.108-5.237a3.281,3.281,0,0,0-2.32.237c-2.427.75-4.678,2.167-3.943,3.177s1.608,2.213.145,3.292-6.462.26-8.314-1.6-3.369-3.323-3.9-.459-.957,5.428-.957,5.428,4.708,1.7,6.178,1.585,16.085-3.606,16.085-3.606Z",
    transform: "translate(-372.011 -434.474)",
    fill: "#45465a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M398.7,441.062s-4.908-.7-7.266,5c0,0,.13,1.677,1.24.138a13.544,13.544,0,0,1,2.052-2.657,9.062,9.062,0,0,1,5.306-1.608l-1.34-.873Z",
    transform: "translate(-376.526 -436.012)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M402.591,443.19a11.552,11.552,0,0,0-4.249,1.5,7.731,7.731,0,0,0-2.672,3.177c-.444,1.171.75,1.577,1.332.421a7.294,7.294,0,0,1,2.672-2.879,37.5,37.5,0,0,1,4.379-1.715l-1.455-.505Z",
    transform: "translate(-377.497 -436.517)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M407.139,444.33s-2.894,1.057-3.912,2.251a4.792,4.792,0,0,0-1.347,3.062c-.069.988.842,1.455,1.271-.1a4.9,4.9,0,0,1,2.557-3.193c1.416-.888,2.833-1.837,2.833-1.837l-1.409-.176Z",
    transform: "translate(-378.974 -436.784)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M366.46,311.19c11.063,3.231,11.905,16.529,14.738,32s8.7,62.757,8.7,62.757-9.731,8.391-22.547,3.361c0,0-20.748-58.737-19.339-69.885s18.459-28.236,18.459-28.236Z",
    transform: "translate(-81.556 -72.946)",
    fill: "#8baed9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M381.712,437.59h-.061a.333.333,0,1,1,.008-.666h.061c.429,0,.85-.008,1.256-.031a.334.334,0,1,1,.038.666c-.413.023-.85.031-1.294.031Zm-1.393-.031H380.3c-.436-.023-.888-.054-1.34-.092a.334.334,0,1,1,.054-.666c.444.038.888.069,1.317.084a.322.322,0,0,1,.314.345.335.335,0,0,1-.329.322Zm4-.1a.326.326,0,0,1-.329-.3.334.334,0,0,1,.3-.367c.444-.046.88-.115,1.294-.191a.335.335,0,1,1,.122.658c-.429.077-.88.145-1.34.2h-.038Zm-6.653-.122h-.038c-.436-.054-.888-.115-1.332-.184a.334.334,0,0,1,.107-.658c.436.069.88.13,1.309.176a.33.33,0,0,1-.038.658Zm9.271-.352a.335.335,0,0,1-.084-.658q.632-.161,1.263-.368a.334.334,0,0,1,.207.635c-.429.138-.865.268-1.3.375-.031,0-.054.008-.084.008Zm-11.905-.046h-.061c-.452-.084-.9-.176-1.317-.268a.333.333,0,0,1,.145-.651c.413.092.85.184,1.294.26a.336.336,0,0,1-.061.666Zm14.447-.773a.336.336,0,0,1-.314-.214.325.325,0,0,1,.191-.429c.406-.161.812-.337,1.21-.521a.334.334,0,0,1,.283.6c-.406.191-.827.367-1.24.536a.346.346,0,0,1-.122.023Zm2.419-1.125a.333.333,0,0,1-.153-.628c.383-.207.766-.429,1.133-.658a.334.334,0,1,1,.352.567c-.383.237-.773.467-1.171.681a.311.311,0,0,1-.161.038Zm2.266-1.409a.314.314,0,0,1-.268-.138.332.332,0,0,1,.077-.467,10.619,10.619,0,0,0,1.018-.8.331.331,0,1,1,.444.49,13.27,13.27,0,0,1-1.079.85.315.315,0,0,1-.191.061Z",
    transform: "translate(-87.522 -101.295)",
    fill: "#9bc2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M381.282,435.7h-.061a.333.333,0,0,1,.008-.666h.061c.429,0,.85-.008,1.256-.031a.334.334,0,1,1,.038.666c-.421.023-.85.031-1.294.031Zm-1.393-.031h-.015c-.436-.023-.888-.054-1.34-.092a.334.334,0,0,1,.054-.666c.444.038.888.069,1.317.084a.322.322,0,0,1,.314.345.335.335,0,0,1-.329.322Zm4-.1a.326.326,0,0,1-.329-.3.335.335,0,0,1,.3-.367c.444-.046.88-.115,1.294-.191a.337.337,0,0,1,.39.268.331.331,0,0,1-.268.39c-.429.077-.88.145-1.34.2h-.038Zm-6.653-.122h-.038c-.436-.054-.888-.115-1.332-.184a.334.334,0,0,1,.107-.658c.436.069.88.13,1.309.176a.33.33,0,0,1-.038.658Zm9.271-.36a.335.335,0,0,1-.084-.658q.632-.161,1.263-.367a.334.334,0,0,1,.207.635c-.429.138-.865.268-1.3.375-.031,0-.054.008-.084.008ZM374.6,435.04h-.061c-.452-.084-.9-.176-1.317-.268a.333.333,0,1,1,.145-.651c.413.092.85.184,1.294.26a.336.336,0,0,1-.061.666Zm14.447-.773a.336.336,0,0,1-.314-.214.325.325,0,0,1,.191-.429c.406-.161.812-.337,1.21-.521a.334.334,0,0,1,.283.6c-.406.191-.827.367-1.24.536a.346.346,0,0,1-.122.023Zm2.419-1.125a.333.333,0,0,1-.153-.628c.383-.207.766-.429,1.133-.658a.334.334,0,0,1,.352.567c-.383.237-.773.467-1.171.681A.311.311,0,0,1,391.465,433.141Zm2.266-1.409a.314.314,0,0,1-.268-.138.332.332,0,0,1,.077-.467,10.624,10.624,0,0,0,1.018-.8.331.331,0,0,1,.444.49,13.277,13.277,0,0,1-1.079.85.315.315,0,0,1-.191.061Z",
    transform: "translate(-87.421 -100.85)",
    fill: "#9bc2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M217.967,319.662c-2.037,20.557,14.347,28.105,33.457,28.144,47.429.115,85.641-3.667,90.8-20.786,3.706-12.3,7.878-21.475-55.591-21.429-70.8.054-68.667,14.064-68.667,14.064Z",
    transform: "translate(-51.051 -71.633)",
    fill: "#8baed9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M386.169,401.363a.331.331,0,0,1-.329-.291c-.038-.291-3.69-29.024-7.028-51.855l-.329-2.243c-3.085-21.1-3.912-26.773-9.654-33.365-5.842-6.7-34.246-7.266-34.529-7.273a.333.333,0,0,1,.008-.666c.069,0,7.3.138,15.174,1.11,10.627,1.317,17.3,3.468,19.852,6.385,5.872,6.737,6.707,12.449,9.815,33.7l.329,2.243c3.346,22.838,7,51.579,7.036,51.87a.336.336,0,0,1-.291.375h-.046Z",
    transform: "translate(-78.282 -71.652)",
    fill: "#9bc2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M348.841,411.093c0-.651-15.863-65.834-15.863-74.761a5.764,5.764,0,0,0-1.692-4.609c-3.69-3.323-12.61-2.2-30.418-.329-19.247,2.029-46.212,3.139-54.366-3.989-3.9-3.415-4.823-11.2-4.793-13.965l1.286.015c-.031,2.419.6,9.761,4.372,13,7.832,6.722,34.391,5.658,53.37,3.66,18.7-1.968,27.3-3.047,31.413.651a7.06,7.06,0,0,1,2.121,5.566c0,8.919,15.856,74.1,15.863,74.746l-1.286.015Z",
    transform: "translate(-56.656 -73.473)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M235.364,173.922c4.287,3.116,6.209,15.733,15.251,17.418s10.2-12.877,9.072-16.047l2.542.85,3.384,1.692s5.367,3.2,7.151,16.866.888,16.438-.888,23.213-5,15.886-5.888,26.436,2.113,9.111,3,14-.337,4.885,1.447,7.557a17.071,17.071,0,0,1,2.335,5.221s1.049,3.315-10.7,8.154-16.805,5.13-29.154,13.314-15.021,8.077-18.13,7.74-.888-.444-1.332-4.218-2.664-3.552-1.776-7.166c.72-2.917,4.448-13.544,1.225-34.238s-6.339-61.8-1.952-68.016,11.943-9.1,16.392-11.1,8.613-2.128,8.636-1.845l-.6.176Z",
    transform: "translate(-48.94 -40.703)",
    fill: "#bdccd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M221.953,183.99c7.886.038,11.331,6.913,11.89,14.133.582,7.557-2.94,11.683-2.657,16.154s6.247,25.326,1.876,42.338-9.363,9.21-13.934,8.261c-5.643-1.171-9.815-12.969-11.607-24.882s-1.638-33.036-1.638-33.036S203.624,183.906,221.953,183.99Z",
    transform: "translate(-48.238 -43.131)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M215.327,331.084a.333.333,0,0,1-.069-.658s.467-.092,1.271-.322a.334.334,0,1,1,.184.643c-.827.237-1.3.329-1.324.337h-.061Zm2.572-.72a.336.336,0,0,1-.314-.23.332.332,0,0,1,.214-.421c.406-.138.827-.283,1.248-.436a.334.334,0,0,1,.23.628c-.429.161-.85.306-1.271.444A.261.261,0,0,1,217.9,330.364Zm2.5-.926a.33.33,0,0,1-.306-.207.339.339,0,0,1,.184-.436c.406-.168.812-.337,1.217-.521a.325.325,0,0,1,.436.168.336.336,0,0,1-.168.444c-.413.184-.827.36-1.233.528a.347.347,0,0,1-.122.023Zm2.435-1.087a.325.325,0,0,1-.3-.191.337.337,0,0,1,.153-.444c.39-.191.789-.39,1.179-.6a.334.334,0,0,1,.314.59c-.4.207-.8.413-1.2.6a.332.332,0,0,1-.145.031Zm2.366-1.233a.337.337,0,0,1-.291-.168.329.329,0,0,1,.13-.452c.383-.214.766-.436,1.141-.666a.335.335,0,1,1,.345.574c-.383.23-.773.459-1.164.674a.321.321,0,0,1-.161.046Zm2.282-1.37a.346.346,0,0,1-.283-.153.334.334,0,0,1,.1-.459c.367-.237.743-.482,1.1-.735a.33.33,0,0,1,.459.084.334.334,0,0,1-.084.467c-.367.253-.743.505-1.118.743a.3.3,0,0,1-.176.054Zm2.2-1.5a.345.345,0,0,1-.276-.145.334.334,0,0,1,.084-.467c.367-.253.735-.513,1.1-.758a.331.331,0,1,1,.367.551c-.36.245-.727.5-1.095.75a.354.354,0,0,1-.191.061Zm2.2-1.493a.324.324,0,0,1-.276-.153.332.332,0,0,1,.092-.459c.367-.245.75-.49,1.125-.727a.332.332,0,0,1,.36.559c-.375.237-.75.482-1.118.72a.321.321,0,0,1-.184.054Zm2.251-1.432a.318.318,0,0,1-.283-.161.336.336,0,0,1,.107-.459c.375-.23.758-.467,1.141-.7a.335.335,0,0,1,.345.574c-.383.23-.758.459-1.133.689a.364.364,0,0,1-.176.054Zm2.289-1.37a.337.337,0,0,1-.291-.168.328.328,0,0,1,.122-.452c.383-.222.773-.444,1.164-.666a.332.332,0,0,1,.322.582c-.383.214-.773.436-1.156.658a.328.328,0,0,1-.168.046Zm2.327-1.3a.333.333,0,0,1-.153-.628c.39-.214.789-.421,1.179-.628a.334.334,0,1,1,.314.59c-.39.207-.789.413-1.171.628a.311.311,0,0,1-.161.038Zm2.358-1.24a.336.336,0,0,1-.153-.635c.39-.2.8-.4,1.194-.6a.332.332,0,0,1,.291.6c-.4.191-.8.39-1.187.59a.349.349,0,0,1-.153.038Zm2.4-1.171a.325.325,0,0,1-.3-.191.34.34,0,0,1,.161-.444c.4-.191.812-.375,1.21-.567a.336.336,0,0,1,.276.612c-.4.184-.8.375-1.2.559a.311.311,0,0,1-.145.031Zm2.427-1.11a.335.335,0,0,1-.306-.2.325.325,0,0,1,.168-.436c.406-.176.819-.36,1.225-.528a.333.333,0,1,1,.26.612c-.406.176-.819.352-1.217.528a.3.3,0,0,1-.138.031Zm2.45-1.049a.334.334,0,0,1-.122-.643c.406-.168.827-.337,1.24-.505a.335.335,0,0,1,.253.62c-.413.161-.827.329-1.233.5a.358.358,0,0,1-.13.023Zm2.473-.988a.348.348,0,0,1-.314-.214.331.331,0,0,1,.191-.429c.406-.161.827-.314,1.248-.475a.334.334,0,0,1,.23.628c-.421.153-.835.314-1.24.467a.318.318,0,0,1-.122.023Zm2.5-.926a.329.329,0,0,1-.314-.222.338.338,0,0,1,.2-.429c.413-.153.835-.3,1.263-.444a.325.325,0,0,1,.421.207.331.331,0,0,1-.207.421c-.421.145-.842.291-1.256.444a.308.308,0,0,1-.115.023Zm2.519-.873a.326.326,0,0,1-.314-.23.334.334,0,0,1,.207-.421c.145-.046.291-.1.436-.145q.425-.138.827-.276a.332.332,0,1,1,.214.628l-.827.276c-.145.046-.291.1-.436.145a.26.26,0,0,1-.107.015Zm2.527-.857a.329.329,0,0,1-.314-.222.325.325,0,0,1,.207-.421c.429-.153.85-.3,1.256-.444a.334.334,0,1,1,.23.628c-.406.145-.827.291-1.263.444a.279.279,0,0,1-.107.015Zm2.511-.9a.34.34,0,0,1-.314-.214.332.332,0,0,1,.2-.429c.429-.161.842-.314,1.248-.467a.332.332,0,1,1,.237.62c-.406.153-.819.306-1.248.467a.307.307,0,0,1-.115.023Zm2.488-.949a.319.319,0,0,1-.306-.214.327.327,0,0,1,.184-.429c.413-.168.834-.329,1.233-.5a.335.335,0,1,1,.253.62c-.406.168-.819.337-1.24.5A.347.347,0,0,1,263.407,308.59Zm2.465-1.018a.335.335,0,0,1-.306-.2.329.329,0,0,1,.176-.436c.413-.176.827-.36,1.21-.536a.336.336,0,0,1,.276.612c-.391.176-.8.36-1.225.544a.4.4,0,0,1-.13.031Zm2.427-1.1a.325.325,0,0,1-.3-.191.337.337,0,0,1,.153-.444c.413-.2.812-.4,1.187-.59a.336.336,0,1,1,.306.6c-.375.2-.781.4-1.2.6a.311.311,0,0,1-.145.031Zm2.366-1.225a.337.337,0,0,1-.291-.168.328.328,0,0,1,.122-.452c.421-.237.8-.467,1.118-.681a.331.331,0,1,1,.367.551c-.329.222-.72.459-1.156.7A.322.322,0,0,1,270.665,305.245Z",
    transform: "translate(-50.394 -71.234)",
    fill: "#9facb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M215.327,328.9a.332.332,0,0,1-.069-.658s.467-.092,1.271-.322a.334.334,0,0,1,.184.643c-.827.237-1.3.329-1.324.337Zm2.572-.72a.336.336,0,0,1-.314-.23.332.332,0,0,1,.214-.421c.406-.138.827-.283,1.248-.436a.334.334,0,0,1,.23.628c-.429.161-.85.306-1.271.444A.519.519,0,0,1,217.9,328.184Zm2.5-.926a.33.33,0,0,1-.306-.207.339.339,0,0,1,.184-.436c.406-.168.812-.337,1.217-.521a.331.331,0,0,1,.268.6c-.413.184-.827.36-1.233.528a.347.347,0,0,1-.122.023Zm2.435-1.087a.325.325,0,0,1-.3-.191.337.337,0,0,1,.153-.444c.39-.191.789-.39,1.179-.6a.334.334,0,0,1,.314.59c-.4.207-.8.413-1.2.6a.332.332,0,0,1-.145.031Zm2.366-1.233a.337.337,0,0,1-.291-.168.329.329,0,0,1,.13-.452c.383-.214.766-.436,1.141-.666a.335.335,0,1,1,.345.574c-.383.23-.773.459-1.164.674a.321.321,0,0,1-.161.046Zm2.282-1.37a.346.346,0,0,1-.283-.153.334.334,0,0,1,.1-.459c.367-.237.743-.482,1.1-.735a.33.33,0,1,1,.375.544c-.367.253-.743.505-1.118.743a.3.3,0,0,1-.176.054Zm2.2-1.5a.345.345,0,0,1-.276-.145.334.334,0,0,1,.084-.467c.367-.253.735-.513,1.1-.758a.331.331,0,1,1,.367.551c-.36.245-.727.5-1.095.75a.354.354,0,0,1-.191.061Zm2.2-1.493a.324.324,0,0,1-.276-.153.332.332,0,0,1,.092-.459c.367-.245.75-.49,1.125-.727a.332.332,0,0,1,.36.559c-.375.237-.75.482-1.118.72a.321.321,0,0,1-.184.054Zm2.251-1.432a.318.318,0,0,1-.283-.161.336.336,0,0,1,.107-.459c.375-.23.758-.467,1.141-.7a.336.336,0,0,1,.459.115.33.33,0,0,1-.115.459c-.383.23-.758.459-1.133.689a.364.364,0,0,1-.176.054Zm2.289-1.37a.337.337,0,0,1-.291-.168.328.328,0,0,1,.122-.452c.383-.222.773-.444,1.164-.666a.332.332,0,1,1,.322.582c-.383.214-.773.436-1.156.658a.328.328,0,0,1-.168.046Zm2.327-1.3a.333.333,0,0,1-.153-.628c.39-.214.789-.421,1.179-.628a.334.334,0,1,1,.314.589c-.39.207-.789.413-1.171.628a.311.311,0,0,1-.161.038Zm2.358-1.24a.336.336,0,0,1-.153-.635c.39-.2.8-.4,1.194-.6a.332.332,0,0,1,.291.6c-.4.191-.8.39-1.187.589a.348.348,0,0,1-.153.038Zm2.4-1.171a.325.325,0,0,1-.3-.191.34.34,0,0,1,.161-.444c.4-.191.812-.375,1.21-.567a.336.336,0,1,1,.276.612c-.4.184-.8.375-1.2.559a.311.311,0,0,1-.145.031Zm2.427-1.11a.335.335,0,0,1-.306-.2.325.325,0,0,1,.168-.436c.406-.176.819-.36,1.225-.528a.333.333,0,1,1,.26.612c-.406.176-.819.352-1.217.528a.3.3,0,0,1-.138.031Zm2.45-1.049a.334.334,0,0,1-.122-.643c.406-.168.827-.337,1.24-.505a.335.335,0,0,1,.253.62c-.413.161-.827.329-1.233.5a.358.358,0,0,1-.13.023Zm2.473-.988a.348.348,0,0,1-.314-.214.331.331,0,0,1,.191-.429c.406-.161.827-.314,1.248-.475a.334.334,0,0,1,.23.628c-.421.153-.835.314-1.24.467a.317.317,0,0,1-.122.023Zm2.5-.926a.329.329,0,0,1-.314-.222.338.338,0,0,1,.2-.429c.413-.153.835-.3,1.263-.444a.332.332,0,0,1,.214.628c-.421.145-.842.291-1.256.444a.308.308,0,0,1-.115.023Zm2.519-.873a.326.326,0,0,1-.314-.23.334.334,0,0,1,.207-.421c.145-.046.291-.1.436-.146q.425-.138.827-.276a.332.332,0,1,1,.214.628l-.827.276c-.145.046-.291.1-.436.145a.26.26,0,0,1-.107.015Zm2.527-.857a.329.329,0,0,1-.314-.222.325.325,0,0,1,.207-.421c.429-.153.85-.3,1.256-.444a.334.334,0,1,1,.23.628c-.406.145-.827.291-1.263.444a.279.279,0,0,1-.107.015Zm2.511-.9a.34.34,0,0,1-.314-.214.332.332,0,0,1,.2-.429c.429-.161.842-.314,1.248-.467a.332.332,0,1,1,.237.62c-.406.153-.819.306-1.248.467a.307.307,0,0,1-.115.023Zm2.488-.949a.319.319,0,0,1-.306-.214.327.327,0,0,1,.184-.429c.413-.168.834-.329,1.233-.5a.335.335,0,0,1,.253.62c-.406.168-.819.337-1.24.5A.347.347,0,0,1,263.407,306.41Zm2.465-1.018a.335.335,0,0,1-.306-.2.329.329,0,0,1,.176-.436c.413-.176.827-.36,1.21-.536a.336.336,0,0,1,.276.612c-.391.176-.8.36-1.225.544a.4.4,0,0,1-.13.031Zm2.427-1.1a.325.325,0,0,1-.3-.191.337.337,0,0,1,.153-.444c.413-.2.812-.4,1.187-.589a.336.336,0,1,1,.306.6c-.375.2-.781.4-1.2.6a.311.311,0,0,1-.145.031Zm2.366-1.225a.337.337,0,0,1-.291-.168.328.328,0,0,1,.122-.452c.421-.237.8-.467,1.118-.681a.331.331,0,1,1,.367.551c-.329.222-.72.459-1.156.7A.321.321,0,0,1,270.665,303.065Z",
    transform: "translate(-50.394 -70.723)",
    fill: "#9facb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(250.903 206.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M327.72,272.008s4.249-3.514,8.33-1.516,9.524,9.195,12.127,11.262-3.024,1.386-4.31.429-6.125-4.946-6.125-4.946l-6.01-1.332Z",
    transform: "translate(-327.72 -269.877)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M336.737,278.657l.222.023a5.96,5.96,0,0,1,4.058,1.73c.62.513,1.164.988,1.638,1.409a14.374,14.374,0,0,0,2.6,2c1.439.773,3.92,1.478,4.64.766.3-.306-.291-.812-1.355-1.677a21.465,21.465,0,0,1-3.131-3.43c.115-.069,2.519,2.32,3.468,3.085,1.187.965,2.037,1.654,1.393,2.312-1.049,1.079-4,0-5.275-.674a14.6,14.6,0,0,1-2.695-2.059c-.475-.421-1.011-.9-1.623-1.393a5.383,5.383,0,0,0-3.774-1.615l-.222-.023a7.9,7.9,0,0,1-3.614-1.409,19.906,19.906,0,0,0,3.675.957Z",
    transform: "translate(-328.973 -271.711)",
    fill: "#c76852"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M221.232,183c-9.44.781-13.115,6.783-15.779,14s-1.562,45.8-1.562,45.8,6.783,4.41,13.888,1.853,12-2,15.994-1.669a9.9,9.9,0,0,0,6.11-1.11S242.546,213.1,237,198.327,221.224,183,221.224,183Z",
    transform: "translate(-47.739 -42.899)",
    fill: "#bdccd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M244.067,248.016a.337.337,0,0,1-.008-.674,12.928,12.928,0,0,0,4.992-1.087c-.054-2-.459-18.022-.253-30.77.145-8.567-2.649-12.342-2.672-12.38a.333.333,0,0,1,.528-.406c.122.161,2.955,3.973,2.81,12.793-.222,13.528.253,30.77.26,30.946a.324.324,0,0,1-.176.3A13.119,13.119,0,0,1,244.059,248Z",
    transform: "translate(-57.13 -47.486)",
    fill: "#9facb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M287.27,231.7a.335.335,0,0,1-.322-.429c.038-.138,4.1-13.651,3.66-23.366a62.755,62.755,0,0,0-4.2-18.773.333.333,0,0,1,.613-.26,63.452,63.452,0,0,1,4.249,18.995c.444,9.83-3.644,23.458-3.69,23.6a.335.335,0,0,1-.322.237Z",
    transform: "translate(-67.129 -44.227)",
    fill: "#9facb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(184.603 133.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M241.932,175.143a.357.357,0,0,1-.245-.107c-.283-.3-.452-.444-.452-.444a.329.329,0,0,1-.031-.467.337.337,0,0,1,.467-.038,6.327,6.327,0,0,1,.5.49.331.331,0,0,1-.015.475.324.324,0,0,1-.23.092Z",
    transform: "translate(-241.122 -174.01)",
    fill: "#9facb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M260.66,193.958h0a9.9,9.9,0,0,1-1.4-.122.332.332,0,0,1,.092-.658,9.985,9.985,0,0,0,1.317.115.333.333,0,0,1-.008.666Zm1.363-.077a.335.335,0,0,1-.046-.666,7.927,7.927,0,0,0,1.279-.283.334.334,0,1,1,.207.635,8.265,8.265,0,0,1-1.386.306h-.046Zm-4.058-.314a.455.455,0,0,1-.084-.008c-.459-.115-.911-.245-1.34-.39a.332.332,0,0,1,.214-.628c.406.138.842.268,1.279.375a.334.334,0,0,1-.077.658Zm6.653-.513a.332.332,0,0,1-.3-.176.338.338,0,0,1,.138-.452,7.044,7.044,0,0,0,1.095-.712.333.333,0,0,1,.406.528,8.592,8.592,0,0,1-1.194.773.348.348,0,0,1-.153.038Zm-9.226-.383a.3.3,0,0,1-.138-.031,13.589,13.589,0,0,1-1.24-.651.335.335,0,0,1,.345-.574c.375.222.773.429,1.179.62a.333.333,0,0,1,.161.444.328.328,0,0,1-.306.191Zm11.377-1.279a.338.338,0,0,1-.23-.092.345.345,0,0,1-.015-.475,10.268,10.268,0,0,0,.842-1.018.335.335,0,1,1,.544.39,10.578,10.578,0,0,1-.9,1.087A.343.343,0,0,1,266.77,191.393Zm-13.72-.122a.33.33,0,0,1-.2-.069,11.854,11.854,0,0,1-1.064-.9.336.336,0,1,1,.459-.49,11.75,11.75,0,0,0,1.011.857.331.331,0,0,1,.061.467.348.348,0,0,1-.268.13Zm-1.983-1.868a.339.339,0,0,1-.253-.115c-.291-.337-.59-.7-.873-1.087a.334.334,0,0,1,.536-.4c.276.367.551.72.835,1.041a.328.328,0,0,1-.031.467.334.334,0,0,1-.222.084Zm17.31-.214a.349.349,0,0,1-.168-.046.33.33,0,0,1-.122-.452c.054-.1.107-.191.161-.283a6.137,6.137,0,0,0,.406-.9.332.332,0,0,1,.62.237,9.1,9.1,0,0,1-.444.98c-.054.1-.107.2-.168.3a.337.337,0,0,1-.291.168Zm-18.941-1.975a.346.346,0,0,1-.283-.153c-.237-.367-.475-.766-.72-1.179a.331.331,0,0,1,.574-.329c.23.406.467.8.7,1.156a.334.334,0,0,1-.1.459.3.3,0,0,1-.176.054Zm19.936-.559a.455.455,0,0,1-.084-.008.334.334,0,0,1-.237-.406c.107-.421.2-.857.268-1.309a.334.334,0,0,1,.658.107c-.077.467-.168.926-.283,1.363A.334.334,0,0,1,269.373,186.654Zm-21.3-1.807a.332.332,0,0,1-.3-.176c-.2-.383-.406-.789-.62-1.225a.332.332,0,0,1,.6-.291c.214.436.413.835.612,1.21a.338.338,0,0,1-.138.452.349.349,0,0,1-.153.038Zm21.743-.888h-.023a.334.334,0,0,1-.306-.36c.031-.4.046-.8.046-1.179v-.161a.333.333,0,0,1,.666-.008v.168c0,.4-.015.812-.054,1.225a.333.333,0,0,1-.329.306ZM246.864,182.4a.34.34,0,0,1-.3-.184c-.2-.406-.413-.812-.62-1.2a.334.334,0,0,1,.59-.314c.214.4.429.812.628,1.225a.324.324,0,0,1-.153.444A.332.332,0,0,1,246.864,182.4Zm-1.294-2.4a.357.357,0,0,1-.291-.161c-.23-.39-.467-.781-.712-1.148a.332.332,0,1,1,.559-.36c.245.375.49.773.727,1.171a.343.343,0,0,1-.115.459.349.349,0,0,1-.168.046Zm-1.485-2.289a.314.314,0,0,1-.268-.138c-.268-.375-.544-.735-.819-1.072a.332.332,0,0,1,.513-.421c.276.345.559.712.842,1.1a.332.332,0,0,1-.077.467.315.315,0,0,1-.191.061Z",
    transform: "translate(-241.544 -174.466)",
    fill: "#9facb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M277.842,182.444a.337.337,0,0,1-.329-.291c-.031-.222-.069-.429-.115-.628a.333.333,0,1,1,.651-.145c.046.214.092.444.122.681a.33.33,0,0,1-.283.375h-.046Z",
    transform: "translate(-249.623 -175.676)",
    fill: "#9facb3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M212.853,262.1c-.291,0-.59-.015-.9-.038a.334.334,0,0,1,.054-.666c.283.023.567.038.842.038h.452a.333.333,0,1,1,.023.666h-.475Zm1.792-.13a.337.337,0,0,1-.329-.283.33.33,0,0,1,.283-.375c.421-.061.835-.138,1.279-.245a.331.331,0,1,1,.153.643c-.459.107-.9.191-1.34.26Zm-3.981-.084H210.6c-.429-.077-.88-.184-1.324-.306a.332.332,0,0,1,.168-.643c.429.115.857.214,1.271.291a.336.336,0,0,1-.061.666Zm6.569-.528a.335.335,0,0,1-.322-.237.331.331,0,0,1,.222-.413c.421-.13.85-.276,1.263-.406a.334.334,0,0,1,.207.635c-.413.138-.842.283-1.271.413a.448.448,0,0,1-.1.015Zm-9.141-.168a.345.345,0,0,1-.107-.015q-.632-.218-1.263-.482a.333.333,0,1,1,.26-.612c.406.168.819.329,1.225.467a.33.33,0,0,1-.107.643Zm11.676-.658a.335.335,0,0,1-.322-.237.342.342,0,0,1,.222-.421c.467-.145.888-.268,1.294-.375a.332.332,0,0,1,.168.643c-.4.107-.812.222-1.263.367a.448.448,0,0,1-.1.015Zm-14.141-.367a.332.332,0,0,1-.145-.031c-.743-.36-1.187-.628-1.21-.635a.335.335,0,0,1,.345-.574s.444.26,1.156.612a.328.328,0,0,1,.153.444.34.34,0,0,1-.3.184Zm16.713-.3a.333.333,0,0,1-.069-.658c.436-.084.888-.161,1.332-.222a.332.332,0,1,1,.092.658c-.436.054-.865.13-1.294.214h-.061Zm11.966-.1h0c-.406,0-.842-.008-1.347-.031a.333.333,0,1,1,.023-.666c.49.023.926.031,1.317.031a.333.333,0,1,1-.008.666Zm1.332-.038a.329.329,0,0,1-.329-.314.323.323,0,0,1,.306-.352,9.693,9.693,0,0,0,1.279-.161.336.336,0,0,1,.39.26.332.332,0,0,1-.26.39,9.747,9.747,0,0,1-1.363.168h-.023Zm-4-.054h-.023l-.812-.046-.521-.031a.334.334,0,0,1,.038-.666l.521.031.812.046a.333.333,0,0,1-.015.666Zm-2.664-.153h-.015c-.482-.023-.919-.038-1.324-.046a.335.335,0,0,1-.329-.345.34.34,0,0,1,.345-.329c.413.008.85.023,1.34.046a.333.333,0,0,1-.015.666Zm-4,0a.329.329,0,0,1-.329-.314.323.323,0,0,1,.306-.352c.421-.031.88-.046,1.347-.054a.333.333,0,1,1,.008.666c-.459,0-.9.023-1.317.054h-.023Zm13.253-.345a.335.335,0,0,1-.306-.2.325.325,0,0,1,.168-.436,3.213,3.213,0,0,0,.9-.574.331.331,0,1,1,.444.49,3.907,3.907,0,0,1-1.072.689.3.3,0,0,1-.138.031Z",
    transform: "translate(-47.843 -60.45)",
    fill: "#9facb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M212.853,259.986c-.291,0-.59-.015-.9-.038a.334.334,0,0,1,.054-.666c.283.023.567.038.842.038h.452a.333.333,0,0,1,.345.322.339.339,0,0,1-.322.345h-.475Zm1.792-.13a.337.337,0,0,1-.329-.283.33.33,0,0,1,.283-.375c.421-.061.835-.138,1.279-.245a.331.331,0,0,1,.153.643c-.459.107-.9.191-1.34.26Zm-3.981-.084H210.6c-.429-.077-.88-.184-1.324-.306a.332.332,0,1,1,.168-.643c.429.115.857.214,1.271.291a.336.336,0,0,1-.061.666Zm6.569-.528a.335.335,0,0,1-.322-.237.331.331,0,0,1,.222-.413c.421-.13.85-.276,1.263-.406a.334.334,0,0,1,.207.635c-.413.138-.842.283-1.271.413a.446.446,0,0,1-.1.015Zm-9.141-.168a.345.345,0,0,1-.107-.015q-.632-.218-1.263-.482a.333.333,0,0,1,.26-.613c.406.168.819.329,1.225.467a.33.33,0,0,1-.107.643Zm11.676-.658a.335.335,0,0,1-.322-.237.342.342,0,0,1,.222-.421c.467-.145.888-.268,1.294-.375a.332.332,0,0,1,.168.643c-.4.107-.812.222-1.263.368a.448.448,0,0,1-.1.015Zm-14.141-.367a.332.332,0,0,1-.145-.031c-.743-.36-1.187-.628-1.21-.643a.335.335,0,0,1,.345-.574s.444.26,1.156.612a.328.328,0,0,1,.153.444.34.34,0,0,1-.3.184Zm28.672-.207h0c-.406,0-.85-.023-1.347-.054a.334.334,0,0,1,.038-.666c.49.031.919.046,1.317.054a.333.333,0,1,1-.008.666Zm1.332-.038a.322.322,0,0,1-.329-.306.334.334,0,0,1,.306-.36,9.788,9.788,0,0,0,1.271-.176.333.333,0,1,1,.145.651,9.9,9.9,0,0,1-1.363.191h-.023Zm-13.283-.054a.333.333,0,0,1-.069-.658c.436-.084.888-.161,1.332-.222a.332.332,0,0,1,.092.658c-.436.054-.865.13-1.294.214h-.061Zm9.294-.061h-.031c-.283-.023-.559-.046-.85-.077l-.482-.046a.334.334,0,0,1,.054-.666l.482.046c.283.023.567.054.842.077a.334.334,0,0,1-.023.666Zm-2.657-.23h-.023c-.482-.038-.911-.061-1.317-.077a.333.333,0,0,1,.023-.666c.413.015.85.046,1.34.077a.334.334,0,0,1-.023.666Zm-4-.061a.334.334,0,0,1-.023-.666q.643-.046,1.355-.046h0a.338.338,0,0,1,.337.329.333.333,0,0,1-.329.337c-.452,0-.9.015-1.309.046H225Zm13.237-.176a.335.335,0,0,1-.306-.2.325.325,0,0,1,.168-.436,4.858,4.858,0,0,0,.934-.536.334.334,0,1,1,.4.536,5.583,5.583,0,0,1-1.064.612.455.455,0,0,1-.13.031Z",
    transform: "translate(-47.843 -60.007)",
    fill: "#9facb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(0 162.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(1.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M90.6,320.468c-.4-21.958,5.022-81.522-2.335-104.1-2.144-6.577-37.461-5.459-39.9,13.031s1.822,51.87,8.154,67.664,5.359,21.751,3.9,28.94S90.6,320.468,90.6,320.468Z",
    transform: "translate(-12.666 -212.706)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(0 84.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(0 74.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M27.031,420.748S16.979,432.186,11.52,439.842s-7.74,5.734-9.233,10.236c-1.386,4.2,1.386,5.13,10.512,10.374,2.718,1.562,5.933,5.267,8.437,6.079,5.9,1.922,9.693,1.493,13.521,1.279,4.984-.283,4.1-4.234,2.419-5.91-.88-.873-3.369-.291-6.24-1.615a18.6,18.6,0,0,1-6.523-5.826c-4.111-6.9,6.446-18.175,6.446-18.175L27.031,420.74Z",
    transform: "translate(-1.95 -420.74)",
    fill: "#f07e54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M47.06,480.066a.11.11,0,0,1-.031-.015.284.284,0,0,1-.077-.4h0s.237-.482-.214-1.853c-.475-1.462-3.047-2.741-3.078-2.756a.289.289,0,0,1-.13-.383.284.284,0,0,1,.383-.13c.115.054,2.817,1.409,3.369,3.093.536,1.638.214,2.243.145,2.35a.291.291,0,0,1-.367.1Z",
    transform: "translate(-11.689 -433.341)",
    fill: "#a3634c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M48.494,477.961a.294.294,0,0,1-.153-.2,1.667,1.667,0,0,0-.536-.85.287.287,0,0,1,.345-.459,2.165,2.165,0,0,1,.758,1.194.287.287,0,0,1-.222.337.294.294,0,0,1-.184-.023Z",
    transform: "translate(-12.672 -433.786)",
    fill: "#a3634c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M48.2,475.868a.267.267,0,0,1-.1-.084l-.383-.513a.285.285,0,0,1,.459-.337l.383.513a.284.284,0,0,1-.36.421Z",
    transform: "translate(-12.663 -433.415)",
    fill: "#a3634c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M61.56,326.375c2.006.49,20.342-5.16,20.067-2.626-.176,1.623.972,21.988-1.393,26.314-6.018,9.9-9.716,17.586-23.267,35.21-16.545,21.536-28.542,31.313-32.293,41.718-3.667,10.16-21.024-2-15.412-5.926,6.217-4.341,16.392-23.764,20.8-38.028,14.026-45.347,23.787-39.551,31.489-56.67Z",
    transform: "translate(-3.404 -323.092)",
    fill: "#fb9d77"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M86.235,362.648a.541.541,0,0,0,.092.015.269.269,0,0,0,.26-.283c-.176-5.283-2.335-14.753-2.35-14.845a.27.27,0,1,0-.528.115c.023.092,2.167,9.516,2.343,14.746a.265.265,0,0,0,.184.245Z",
    transform: "translate(-21.112 -328.772)",
    fill: "#b55d3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(0 183.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M44.229,475.617s-.98,2.412-1.746,2.588c-1.516.337-23.8,1.11-27,.3-2.182-.551-2.335-2.251-6.944-5.061L7.4,474.66.284,468.7a40.453,40.453,0,0,1-.2-6.3c.268-1.554,44.145,13.214,44.145,13.214Z",
    transform: "translate(-0.002 -454.273)",
    fill: "#453a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M33.412,462.249c-4.341-.276-6.492-1.661-7.534-2.756a12.148,12.148,0,0,1-.865-1.286.529.529,0,0,1-.038-.115l-.015.015c-.39-.674-.49-.972-1.057-1.279-.865-.467-5.13.743-8.123.582a14.627,14.627,0,0,1-7.7-3.039c-2.167-1.952-3.468-3.9-5.076-1.256-.168.276-.314.528-.452.766-2.886,4.1-3.353,8.468-.88,11.04,2.519,2.618,10.374,6.661,12.946,9.2,1.623,1.6,26.23,1.37,29.346-.26,2.817-1.47-1.677-11.048-10.542-11.607Z",
    transform: "translate(-0.017 -451.823)",
    fill: "#c95d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M32.766,469.725c1.661-.046,4.984-4.41,5.7-5.788l-.306-.023c-4.341-.276-6.492-1.661-7.534-2.756a12.148,12.148,0,0,1-.865-1.286.529.529,0,0,1-.038-.115l-.015.015a6.6,6.6,0,0,0-.513-.842h0a55.242,55.242,0,0,1-8.468.781c-1.332-.038.789,3.353,5.918,6.73s4.234,3.346,6.125,3.292Z",
    transform: "translate(-4.769 -453.487)",
    fill: "#bd5346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M38.031,465.033a7.264,7.264,0,0,0-2.657,2.81c-.781,1.723-1.5,1.7-1.455.857s2-3.177,2.618-3.583c.59-.383.934-.6.934-.6l.957.306-.4.2Z",
    transform: "translate(-7.951 -454.798)",
    fill: "#453a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M35.434,463.882a8.79,8.79,0,0,0-3.277,2.649c-.85,1.5-1.164,1.738-1.317,1.623s-.467-.521.092-1.386a7.444,7.444,0,0,1,3.8-3.239l.689.36Z",
    transform: "translate(-7.177 -454.566)",
    fill: "#453a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M33.151,462.375l-.567-.475a8.989,8.989,0,0,0-2.5,1.646A6.3,6.3,0,0,0,28.6,465.59c-.138.49.406.766.758.1a7.5,7.5,0,0,1,1.784-2.174,9.208,9.208,0,0,1,2.014-1.141Z",
    transform: "translate(-6.701 -454.184)",
    fill: "#453a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M36.783,465.363c-.122,0-.237-.015-.36-.023a.469.469,0,0,1-.107-.008,2.429,2.429,0,0,1-.245-.023.577.577,0,0,1-.115-.008c-.107-.008-.214-.023-.314-.038a.588.588,0,0,1-.115-.015l-.207-.023a1.06,1.06,0,0,1-.153-.023l-.161-.023-.153-.023-.253-.046h0c-2.779,2.19-2.435,4.938-4.663,5.443s-4.992-.222-7.319.031c-2.8.306-7.174,1.707-8.169,3.981a25.155,25.155,0,0,1,3.529,2.664c1.623,1.6,26.23,1.37,29.346-.26,2.817-1.47-1.677-11.048-10.542-11.607Z",
    transform: "translate(-3.388 -454.936)",
    fill: "#9e463a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M45.408,465.92c-3.009,5-4.976,8.146-3.751,12.518,5.581-.161,10.665-.6,11.966-1.279C56.188,475.819,52.712,467.8,45.408,465.92Z",
    transform: "translate(-9.679 -455.126)",
    fill: "#bd5346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M6.874,453.237c-1.5-1.416-2.6-2.251-3.882-.13-.168.276-.314.528-.452.766-2.886,4.1-3.353,8.468-.88,11.04,1.47,1.531,4.77,3.552,7.771,5.466A12.806,12.806,0,0,0,8.1,460.923c-2.09-3.552-3.016-4.119-1.225-7.687Z",
    transform: "translate(-0.015 -451.821)",
    fill: "#bd5346"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(1.538 168.645)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M39.333,220.288c-4.663,15.549-5.221,34.659-.888,56.433s9.218,31.88,9.333,36.879-7.22,10.994-16.774,33.1S3.457,393.691,2.01,399.693a16.181,16.181,0,0,0,10.029,8.7c7.518,2.289,11.186-3.376,16.292-1.929,0,0,10.887-12.778,28.657-41.32S81.2,328.936,81.426,317.6s3.667-76.76,1.332-87.425S39.326,220.3,39.326,220.3Z",
    transform: "translate(-2.01 -220.283)",
    fill: "#ff9b54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(-17.502 -31.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(20.935 68.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M8.543,268.91s-5.145,7.036.873,11.576,14.868,2.006,14.868,2.006-9.478,2.1-13.628-5.007-2.113-8.575-2.113-8.575Z",
    transform: "translate(-6.494 -268.13)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M24.034,269.253s-6.209-4.1-8.82,1.937S22.4,282.521,22.4,282.521a16.278,16.278,0,0,0,3.82-.276s-4.31-.191-8.169-5.336-.26-8.284,1.837-8.246A19.549,19.549,0,0,1,24.034,269.253Z",
    transform: "translate(-8.434 -267.891)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M28.539,274.39c-.23-.015-2.473.658-2.519,3.667s3,4.594,3,4.594a6.791,6.791,0,0,1-1.684-5.26c.421-3.1,1.21-3,1.21-3Z",
    transform: "translate(-11.071 -269.415)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(17.349 92.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M14.121,315.683h0a14.605,14.605,0,0,0-1.462-8.031c-3.261-6.753-7.1-8.161-7.1-8.161s5.742,6.408,5.987,12.625-1.37,8.391-3.866,10.986c-1.883,1.439-5.865,1.868-5.865,1.868s6.913,2.641,10.305-2.664a14.313,14.313,0,0,0,2-6.615Z",
    transform: "translate(-1.81 -299.49)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M12.568,326.8a10.273,10.273,0,0,0,7.013-7.342,11.53,11.53,0,0,0,.115-3.706c-.712-5.65-3.216-7.411-3.216-7.411s2.649,5.849,1.256,10.55a14.215,14.215,0,0,1-2.136,4.624c-2,2.894-3.039,3.292-3.039,3.292Z",
    transform: "translate(-4.33 -301.564)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(52.1 25.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M59.511,229.113h0a14.605,14.605,0,0,0-1.462-8.031c-3.261-6.753-7.1-8.161-7.1-8.161s5.742,6.408,5.987,12.625-1.37,8.391-3.866,10.986C51.181,237.971,47.2,238.4,47.2,238.4s6.913,2.641,10.305-2.664a14.315,14.315,0,0,0,2-6.622Z",
    transform: "translate(-47.2 -212.92)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M57.958,240.239a10.273,10.273,0,0,0,7.013-7.342,11.53,11.53,0,0,0,.115-3.706c-.712-5.65-3.216-7.411-3.216-7.411s2.649,5.849,1.256,10.55a14.215,14.215,0,0,1-2.136,4.624c-2,2.894-3.039,3.292-3.039,3.292Z",
    transform: "translate(-49.72 -214.997)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(9.858 54.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M-2.112,256.571h0a14.687,14.687,0,0,1,7.449-3.346c7.411-1.141,10.749,1.225,10.749,1.225s-8.537-1.1-13.8,2.22-6.14,5.888-6.867,9.409c-.122,2.366,1.784,5.888,1.784,5.888s-6.094-4.2-3.644-10a14.351,14.351,0,0,1,4.318-5.4Z",
    transform: "translate(7.75 -251.157)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M-7.481,264.516a10.271,10.271,0,0,1,2.075-9.938,11.708,11.708,0,0,1,2.986-2.2c5.061-2.611,7.932-1.547,7.932-1.547s-6.324,1.133-9.409,4.938a13.956,13.956,0,0,0-2.6,4.379c-1.256,3.284-.988,4.364-.988,4.364Z",
    transform: "translate(7.974 -250.62)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(35.911 84.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M29.282,304.69a2.532,2.532,0,0,0-.283-.758,16.1,16.1,0,0,1-.122-7.388c.6-3.522,1.141-7.534,1.141-7.534s-4.586,8.215-3.889,12.671a14.817,14.817,0,0,0,1.623,4.846c.965,2.465,5.918,4.663,5.918,4.663S29.994,307.538,29.282,304.69Z",
    transform: "translate(-26.056 -289.01)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M34.058,301c.4-1.026.9-1.968,1.141-2.817.789-2.657-.429-6.944-.429-6.944a16.231,16.231,0,0,1-1.416,6.048,14.347,14.347,0,0,0-1.279,6.2,4.9,4.9,0,0,0,1.792,2.6s-.681-3.062.184-5.1Z",
    transform: "translate(-27.463 -289.533)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(59.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M61.5,194.179a2.382,2.382,0,0,0-.505-.635,16.143,16.143,0,0,1-2.35-7c-.5-3.537-1.194-7.526-1.194-7.526s-1.876,9.218.138,13.253A14.753,14.753,0,0,0,60.6,196.4c1.669,2.059,7.051,2.649,7.051,2.649s-4.609-2.366-6.155-4.869Z",
    transform: "translate(-56.653 -179.02)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M64.814,189.316c.061-1.1.253-2.144.237-3.032C65,183.513,62.54,179.8,62.54,179.8a16.163,16.163,0,0,1,.49,6.194,14.291,14.291,0,0,0,.666,6.3,4.9,4.9,0,0,0,2.5,1.937s-1.577-2.71-1.37-4.915Z",
    transform: "translate(-58.033 -179.203)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(39.494 41.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M33.962,249.26a2.532,2.532,0,0,0-.283-.758,16.1,16.1,0,0,1-.122-7.388c.6-3.522,1.141-7.534,1.141-7.534s-4.586,8.215-3.889,12.671a14.817,14.817,0,0,0,1.623,4.846c.965,2.465,5.918,4.663,5.918,4.663s-3.675-3.652-4.387-6.5Z",
    transform: "translate(-30.736 -233.58)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M38.738,245.571c.4-1.026.9-1.968,1.141-2.817.789-2.657-.429-6.944-.429-6.944a16.231,16.231,0,0,1-1.416,6.048,14.346,14.346,0,0,0-1.279,6.2,4.9,4.9,0,0,0,1.792,2.6s-.681-3.062.184-5.1Z",
    transform: "translate(-32.143 -234.103)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M-10.828,315.28a20.524,20.524,0,0,0,2.2-1.118c4.326-2.565,5.987-8.713,5.987-8.713s-1.86,2.105-5.635,5.665c-2.159,2.037-5.367,2.611-7.717,2.733a12.391,12.391,0,0,1-4.854-2.121,20.05,20.05,0,0,0,8.942,5.321,18.981,18.981,0,0,0,6.737-.306c5.65-1.355,7.779-4.3,7.779-4.3s-7.932,3.346-13.429,2.84Z",
    transform: "translate(20.85 -208.654)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M-8.886,289.586c-6.347-4.693-6.01-7.656-6.01-7.656-1,2.917.383,7.5,4.486,10.083,4.953,3.353,10.16.283,10.16.283a15.268,15.268,0,0,1-8.644-2.71Z",
    transform: "translate(19.528 -203.141)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M41.772,210.972c1.792-7.687,4.647-8.552,4.647-8.552-3.078.237-6.73,3.323-7.48,8.115-1.118,5.88,3.767,9.44,3.767,9.44a15.189,15.189,0,0,1-.934-9.011Z",
    transform: "translate(6.875 -184.505)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M19.866,339.714c-7.5,2.458-9.716.467-9.716.467,1.8,2.5,6.339,4.035,10.818,2.182,5.6-2.1,6.117-8.123,6.117-8.123A15.23,15.23,0,0,1,19.866,339.714Z",
    transform: "translate(13.584 -215.403)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(44.443 60.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M48.317,270.82a34.621,34.621,0,0,1-5.3,4.793,24.967,24.967,0,0,1-5.819,3.039,14.017,14.017,0,0,0,4.624-.184c4.349-1.286,6.492-7.648,6.492-7.648Z",
    transform: "translate(-37.2 -261.066)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M52.891,258.08S49.8,266.2,44.247,268.14a10.922,10.922,0,0,1-6.737.7,8.671,8.671,0,0,0,6.393,1.2c3.621-.222,9.249-8.491,8.988-11.966Z",
    transform: "translate(-37.273 -258.08)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(70.826 14.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M82.777,210.31a34.621,34.621,0,0,1-5.3,4.793,24.968,24.968,0,0,1-5.819,3.039,14.017,14.017,0,0,0,4.624-.184C80.633,216.672,82.777,210.31,82.777,210.31Z",
    transform: "translate(-71.66 -200.564)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M87.351,197.58s-3.093,8.123-8.644,10.06a10.922,10.922,0,0,1-6.737.7,8.671,8.671,0,0,0,6.393,1.2c3.621-.222,9.249-8.491,8.988-11.966Z",
    transform: "translate(-71.733 -197.58)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(19.056 28.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M15.157,229.27a34.62,34.62,0,0,1-5.3,4.793A24.968,24.968,0,0,1,4.04,237.1a14.017,14.017,0,0,0,4.624-.184C13.013,235.632,15.157,229.27,15.157,229.27Z",
    transform: "translate(-4.04 -219.524)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M19.731,216.54s-3.093,8.123-8.644,10.06a10.922,10.922,0,0,1-6.737.7,8.671,8.671,0,0,0,6.393,1.2C14.364,228.284,19.991,220.016,19.731,216.54Z",
    transform: "translate(-4.113 -216.54)",
    fill: "#ffe4c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(76.51 98.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M80.444,310.59s-4.249,7.61,2.274,11.385,15,.184,15,.184-9.149,3.239-14.133-3.307-3.139-8.253-3.139-8.253Z",
    transform: "translate(-79.084 -308.653)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M95.843,308.933s-6.661-3.323-8.521,3S95.843,322.3,95.843,322.3a16.051,16.051,0,0,0,3.759-.743s-4.3.337-8.759-4.3-1.263-8.192.819-8.406a19.439,19.439,0,0,1,4.188.077Z",
    transform: "translate(-80.962 -308.061)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M100.87,313.57c-.23.008-2.373.957-2.059,3.951s3.537,4.2,3.537,4.2a6.794,6.794,0,0,1-2.312-5.015c.038-3.124.835-3.124.835-3.124Z",
    transform: "translate(-83.7 -309.352)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(78.237 124.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M92.418,356.279h0a14.68,14.68,0,0,0-2.427-7.794c-4.058-6.309-8.047-7.235-8.047-7.235s6.477,5.658,7.48,11.806-.337,8.5-2.5,11.377c-1.692,1.661-5.589,2.572-5.589,2.572s7.189,1.784,9.907-3.9a14.272,14.272,0,0,0,1.179-6.814Z",
    transform: "translate(-81.34 -341.25)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M91.97,367.5a10.279,10.279,0,0,0,6.071-8.138,11.751,11.751,0,0,0-.337-3.69c-1.4-5.528-4.1-6.967-4.1-6.967s3.338,5.482,2.534,10.32a14.436,14.436,0,0,1-1.554,4.846c-1.631,3.116-2.611,3.637-2.611,3.637Z",
    transform: "translate(-83.832 -342.996)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(104.658 54.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M126.928,264.819h0a14.68,14.68,0,0,0-2.427-7.794c-4.058-6.309-8.047-7.235-8.047-7.235s6.477,5.658,7.48,11.806-.337,8.5-2.5,11.377c-1.692,1.661-5.589,2.572-5.589,2.572s7.189,1.784,9.907-3.9a14.364,14.364,0,0,0,1.179-6.814Z",
    transform: "translate(-115.85 -249.79)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M126.48,276.046a10.279,10.279,0,0,0,6.071-8.138,11.75,11.75,0,0,0-.337-3.69c-1.4-5.528-4.1-6.967-4.1-6.967s3.338,5.482,2.534,10.32a14.436,14.436,0,0,1-1.554,4.846c-1.631,3.116-2.611,3.637-2.611,3.637Z",
    transform: "translate(-118.342 -251.539)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(64.387 86.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M68.59,299.072h0a14.573,14.573,0,0,1,6.982-4.226c7.22-2.037,10.818-.092,10.818-.092s-8.605-.054-13.421,3.889-5.375,6.592-5.665,10.175c.168,2.366,2.488,5.627,2.488,5.627s-6.561-3.43-4.831-9.486A14.42,14.42,0,0,1,68.59,299.072Z",
    transform: "translate(-63.583 -292.881)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M64.184,307.8a10.28,10.28,0,0,1,.85-10.121,11.576,11.576,0,0,1,2.7-2.542c4.708-3.208,7.679-2.5,7.679-2.5s-6.133,1.891-8.736,6.048a14.206,14.206,0,0,0-2.044,4.663C63.793,306.755,64.184,307.8,64.184,307.8Z",
    transform: "translate(-63.25 -292.564)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(49.436 125.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M48.031,357.828a2.559,2.559,0,0,0-.452-.681,16.109,16.109,0,0,1-1.769-7.174c-.207-3.568-.574-7.6-.574-7.6s-2.634,9.034-.957,13.222a14.8,14.8,0,0,0,2.672,4.364c1.493,2.19,6.806,3.223,6.806,3.223s-4.4-2.733-5.727-5.359Z",
    transform: "translate(-43.721 -342.37)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M51.876,353.26c.153-1.087.429-2.121.49-3,.176-2.764-1.968-6.668-1.968-6.668a16.157,16.157,0,0,1-.023,6.209,14.412,14.412,0,0,0,.138,6.332,4.9,4.9,0,0,0,2.327,2.144s-1.347-2.833-.965-5.015Z",
    transform: "translate(-45.216 -342.656)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(106.257 27.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M123.9,230a2.609,2.609,0,0,0-.574-.574,16.143,16.143,0,0,1-3.185-6.661c-.926-3.445-2.105-7.327-2.105-7.327s-.735,9.379,1.753,13.138a14.66,14.66,0,0,0,3.5,3.728c1.906,1.837,7.319,1.769,7.319,1.769s-4.862-1.784-6.7-4.081Z",
    transform: "translate(-117.938 -215.44)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M126.382,224.812c-.069-1.095-.008-2.159-.138-3.039-.39-2.741-3.284-6.133-3.284-6.133a16.257,16.257,0,0,1,1.24,6.087,14.316,14.316,0,0,0,1.424,6.171,4.946,4.946,0,0,0,2.718,1.623s-1.9-2.5-1.96-4.708Z",
    transform: "translate(-119.115 -215.487)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(92.32 71.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M103.49,287.917a2.683,2.683,0,0,0-.375-.72,16.136,16.136,0,0,1-1.018-7.319c.161-3.568.214-7.618.214-7.618s-3.545,8.713-2.32,13.054a14.849,14.849,0,0,0,2.2,4.617c1.256,2.327,6.439,3.9,6.439,3.9s-4.1-3.177-5.145-5.918Z",
    transform: "translate(-99.734 -272.26)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M107.786,283.719c.268-1.072.643-2.059.8-2.932.459-2.733-1.271-6.837-1.271-6.837a16.158,16.158,0,0,1-.666,6.178,14.319,14.319,0,0,0-.513,6.309,4.887,4.887,0,0,0,2.1,2.366S107.181,285.848,107.786,283.719Z",
    transform: "translate(-101.197 -272.656)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M66.889,358.377A20.83,20.83,0,0,0,68.933,357c3.981-3.078,4.877-9.379,4.877-9.379s-1.585,2.32-4.908,6.309c-1.9,2.281-5.007,3.246-7.327,3.652a12.313,12.313,0,0,1-5.076-1.516,19.937,19.937,0,0,0,9.516,4.188,19.126,19.126,0,0,0,6.653-1.125c5.443-2.029,7.2-5.214,7.2-5.214s-7.472,4.287-12.985,4.456Z",
    transform: "translate(2.72 -218.539)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M65.511,333.307c-6.875-3.882-6.9-6.867-6.9-6.867-.643,3.016,1.294,7.4,5.681,9.463,5.329,2.726,10.121-.957,10.121-.957a15.243,15.243,0,0,1-8.912-1.638Z",
    transform: "translate(2.253 -213.574)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M110.137,252.139c.835-7.847,3.568-9.049,3.568-9.049-3.024.6-6.278,4.119-6.431,8.965-.39,5.972,4.892,8.912,4.892,8.912a15.194,15.194,0,0,1-2.029-8.827Z",
    transform: "translate(-9.177 -194.038)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M52.037,291.792c2.971-7.312,5.926-7.717,5.926-7.717-3.07-.253-7.174,2.228-8.659,6.845-2.021,5.635,2.243,9.915,2.243,9.915a15.176,15.176,0,0,1,.49-9.042Z",
    transform: "translate(4.534 -203.64)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M100.323,378.939c-7.143,3.353-9.593,1.646-9.593,1.646,2.09,2.266,6.783,3.231,11,.85,5.306-2.764,5.084-8.8,5.084-8.8a15.164,15.164,0,0,1-6.492,6.309Z",
    transform: "translate(-5.304 -224.401)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(88.328 106.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M105.383,331.89a34.45,34.45,0,0,1-4.678,5.4,25.111,25.111,0,0,1-5.405,3.728,14.2,14.2,0,0,0,4.571-.743c4.157-1.8,5.512-8.383,5.512-8.383Z",
    transform: "translate(-94.703 -321.662)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M108.477,318.538s-2.075,8.437-7.357,11.04a10.873,10.873,0,0,1-6.6,1.516,8.658,8.658,0,0,0,6.492.413c3.568-.658,8.146-9.547,7.465-12.977Z",
    transform: "translate(-94.52 -318.53)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(79.049 32.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M93.263,235.18a34.451,34.451,0,0,1-4.678,5.4,25.11,25.11,0,0,1-5.405,3.729,13.955,13.955,0,0,0,4.571-.743C91.908,241.764,93.263,235.18,93.263,235.18Z",
    transform: "translate(-82.583 -224.951)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M96.357,221.828s-2.075,8.437-7.357,11.04a10.874,10.874,0,0,1-6.6,1.516,8.657,8.657,0,0,0,6.492.413c3.568-.658,8.146-9.555,7.465-12.977Z",
    transform: "translate(-82.4 -221.82)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(70.635 59.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M82.263,270.11a34.45,34.45,0,0,1-4.678,5.4,25.111,25.111,0,0,1-5.405,3.728,14.2,14.2,0,0,0,4.571-.743c4.157-1.8,5.512-8.383,5.512-8.383Z",
    transform: "translate(-71.59 -259.874)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M85.367,256.748s-2.075,8.437-7.357,11.04a10.874,10.874,0,0,1-6.6,1.516,8.658,8.658,0,0,0,6.492.413c3.568-.658,8.146-9.547,7.465-12.977Z",
    transform: "translate(-71.41 -256.74)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(44.665 101.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M48.343,324.89a34.451,34.451,0,0,1-4.678,5.4,25.11,25.11,0,0,1-5.405,3.728,14.2,14.2,0,0,0,4.571-.743C46.988,331.474,48.343,324.89,48.343,324.89Z",
    transform: "translate(-37.67 -314.654)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M51.447,311.528s-2.075,8.437-7.357,11.04a10.873,10.873,0,0,1-6.6,1.516,8.658,8.658,0,0,0,6.492.413c3.568-.658,8.146-9.547,7.465-12.977Z",
    transform: "translate(-37.49 -311.52)",
    fill: "#ffe4c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(-12.38 87.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(7.656 25.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M8.151,384.5h0a14.605,14.605,0,0,0-1.462-8.031c-3.261-6.753-7.1-8.161-7.1-8.161s5.742,6.408,5.987,12.625S4.2,389.326,1.7,391.921c-1.883,1.439-5.865,1.868-5.865,1.868s6.913,2.641,10.305-2.664a14.313,14.313,0,0,0,2-6.615Z",
    transform: "translate(4.16 -368.31)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M6.6,395.629a10.273,10.273,0,0,0,7.013-7.342,11.53,11.53,0,0,0,.115-3.706c-.712-5.65-3.216-7.411-3.216-7.411s2.649,5.849,1.256,10.55a14.215,14.215,0,0,1-2.136,4.624c-2,2.894-3.039,3.292-3.039,3.292Z",
    transform: "translate(1.64 -370.387)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(14.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M10.137,349.569a2.381,2.381,0,0,0-.505-.635,16.143,16.143,0,0,1-2.35-7c-.5-3.537-1.194-7.526-1.194-7.526s-1.876,9.218.138,13.253a14.754,14.754,0,0,0,3.016,4.127c1.669,2.059,7.051,2.649,7.051,2.649S11.683,352.073,10.137,349.569Z",
    transform: "translate(-5.293 -334.41)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M13.444,344.716c.061-1.1.253-2.144.237-3.032-.054-2.771-2.511-6.485-2.511-6.485a16.163,16.163,0,0,1,.49,6.194,14.239,14.239,0,0,0,.666,6.293,4.9,4.9,0,0,0,2.5,1.937s-1.577-2.71-1.37-4.915Z",
    transform: "translate(-6.67 -334.595)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(0 60.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M-3.043,426.21A34.622,34.622,0,0,1-8.341,431a24.967,24.967,0,0,1-5.819,3.039,14.016,14.016,0,0,0,4.624-.184c4.349-1.286,6.492-7.648,6.492-7.648Z",
    transform: "translate(14.16 -416.464)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M1.531,413.48s-3.093,8.123-8.644,10.06a10.922,10.922,0,0,1-6.737.7,8.671,8.671,0,0,0,6.393,1.2C-3.836,425.224,1.791,416.956,1.531,413.48Z",
    transform: "translate(14.087 -413.48)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(26.383 14.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M31.417,365.71a34.622,34.622,0,0,1-5.3,4.793,24.967,24.967,0,0,1-5.819,3.039,14.016,14.016,0,0,0,4.624-.184C29.273,372.072,31.417,365.71,31.417,365.71Z",
    transform: "translate(-20.3 -355.956)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M35.991,352.97s-3.093,8.123-8.644,10.06a10.922,10.922,0,0,1-6.737.7,8.671,8.671,0,0,0,6.393,1.2C30.624,364.714,36.251,356.446,35.991,352.97Z",
    transform: "translate(-20.373 -352.97)",
    fill: "#ffe4c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(32.066 98.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M29.084,465.98s-4.249,7.61,2.274,11.385,15,.184,15,.184-9.149,3.239-14.133-3.307-3.139-8.253-3.139-8.253Z",
    transform: "translate(-27.724 -464.043)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M44.483,464.323s-6.661-3.323-8.521,3,8.514,10.366,8.514,10.366a16.052,16.052,0,0,0,3.759-.743s-4.3.337-8.759-4.3-1.263-8.192.819-8.406A19.163,19.163,0,0,1,44.483,464.323Z",
    transform: "translate(-29.602 -463.451)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M49.51,468.97c-.23.008-2.373.957-2.059,3.951s3.537,4.2,3.537,4.2a6.794,6.794,0,0,1-2.312-5.015c.038-3.124.835-3.124.835-3.124Z",
    transform: "translate(-32.34 -464.744)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(33.794 124.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M41.058,511.669h0a14.68,14.68,0,0,0-2.427-7.794c-4.058-6.309-8.047-7.235-8.047-7.235s6.477,5.658,7.48,11.806-.337,8.5-2.5,11.377c-1.692,1.661-5.589,2.572-5.589,2.572s7.189,1.784,9.907-3.9a14.365,14.365,0,0,0,1.179-6.814Z",
    transform: "translate(-29.98 -496.64)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M40.61,522.886a10.279,10.279,0,0,0,6.071-8.138,11.751,11.751,0,0,0-.337-3.69c-1.4-5.528-4.1-6.967-4.1-6.967s3.338,5.482,2.534,10.32a14.437,14.437,0,0,1-1.554,4.846c-1.631,3.116-2.611,3.637-2.611,3.637Z",
    transform: "translate(-32.472 -498.386)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(60.215 54.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M75.568,420.209h0a14.68,14.68,0,0,0-2.427-7.794c-4.058-6.309-8.047-7.235-8.047-7.235s6.477,5.658,7.48,11.806-.337,8.5-2.5,11.377c-1.692,1.661-5.589,2.572-5.589,2.572s7.189,1.784,9.907-3.9a14.364,14.364,0,0,0,1.179-6.814Z",
    transform: "translate(-64.49 -405.18)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M75.12,431.436a10.279,10.279,0,0,0,6.071-8.138,11.751,11.751,0,0,0-.337-3.69c-1.4-5.528-4.1-6.967-4.1-6.967s3.338,5.482,2.534,10.32a14.436,14.436,0,0,1-1.554,4.846c-1.631,3.116-2.611,3.637-2.611,3.637Z",
    transform: "translate(-66.982 -406.929)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(19.936 86.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M17.23,454.462h0a14.573,14.573,0,0,1,6.982-4.226c7.22-2.037,10.818-.092,10.818-.092s-8.605-.054-13.421,3.889-5.375,6.592-5.665,10.175c.168,2.366,2.488,5.627,2.488,5.627s-6.561-3.43-4.831-9.486A14.42,14.42,0,0,1,17.23,454.462Z",
    transform: "translate(-12.215 -448.271)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M12.814,463.187a10.28,10.28,0,0,1,.85-10.121,11.575,11.575,0,0,1,2.7-2.542c4.708-3.208,7.679-2.5,7.679-2.5s-6.133,1.891-8.736,6.048a14.207,14.207,0,0,0-2.044,4.663C12.423,462.145,12.814,463.187,12.814,463.187Z",
    transform: "translate(-11.88 -447.954)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(4.992 125.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M-3.329,513.228a2.56,2.56,0,0,0-.452-.681,16.109,16.109,0,0,1-1.769-7.174c-.207-3.568-.574-7.6-.574-7.6s-2.634,9.034-.957,13.222a14.8,14.8,0,0,0,2.672,4.364c1.493,2.19,6.806,3.223,6.806,3.223s-4.4-2.733-5.727-5.359Z",
    transform: "translate(7.639 -497.77)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M.506,508.65c.153-1.087.429-2.121.49-3,.176-2.764-1.968-6.668-1.968-6.668a16.158,16.158,0,0,1-.023,6.209,14.413,14.413,0,0,0,.138,6.332,4.9,4.9,0,0,0,2.327,2.144S.124,510.832.506,508.65Z",
    transform: "translate(6.146 -498.054)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(61.813 27.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M72.544,385.4a2.61,2.61,0,0,0-.574-.574,16.143,16.143,0,0,1-3.185-6.661c-.926-3.445-2.105-7.327-2.105-7.327s-.735,9.379,1.753,13.138a14.659,14.659,0,0,0,3.5,3.728c1.906,1.837,7.319,1.769,7.319,1.769s-4.862-1.784-6.7-4.081Z",
    transform: "translate(-66.578 -370.84)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M75.022,380.212c-.069-1.1-.008-2.159-.138-3.039-.39-2.741-3.284-6.133-3.284-6.133a16.257,16.257,0,0,1,1.24,6.087,14.316,14.316,0,0,0,1.424,6.171,4.946,4.946,0,0,0,2.718,1.623s-1.9-2.5-1.96-4.708Z",
    transform: "translate(-67.755 -370.887)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(47.869 71.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M52.12,443.307a2.682,2.682,0,0,0-.375-.72,16.136,16.136,0,0,1-1.018-7.319c.161-3.568.214-7.618.214-7.618s-3.545,8.713-2.32,13.054a14.849,14.849,0,0,0,2.2,4.617c1.256,2.327,6.439,3.9,6.439,3.9s-4.1-3.177-5.145-5.918Z",
    transform: "translate(-48.364 -427.65)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M56.416,439.109c.268-1.072.643-2.059.8-2.932.459-2.733-1.271-6.837-1.271-6.837a16.158,16.158,0,0,1-.666,6.178,14.436,14.436,0,0,0-.513,6.309,4.887,4.887,0,0,0,2.1,2.366S55.811,441.238,56.416,439.109Z",
    transform: "translate(-49.827 -428.046)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M15.529,513.767a20.831,20.831,0,0,0,2.044-1.378c3.981-3.078,4.877-9.379,4.877-9.379s-1.585,2.32-4.908,6.309c-1.9,2.281-5.007,3.246-7.327,3.652a12.314,12.314,0,0,1-5.076-1.516,19.938,19.938,0,0,0,9.516,4.188,19.126,19.126,0,0,0,6.653-1.125c5.443-2.029,7.2-5.214,7.2-5.214s-7.472,4.287-12.985,4.456Z",
    transform: "translate(9.636 -373.929)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M14.151,488.7c-6.875-3.882-6.9-6.867-6.9-6.867-.643,3.017,1.294,7.4,5.681,9.463,5.329,2.726,10.121-.957,10.121-.957a15.243,15.243,0,0,1-8.912-1.638Z",
    transform: "translate(9.169 -368.964)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M58.777,407.529c.835-7.847,3.568-9.049,3.568-9.049-3.024.6-6.278,4.119-6.431,8.965-.39,5.972,4.892,8.912,4.892,8.912a15.194,15.194,0,0,1-2.029-8.827Z",
    transform: "translate(-2.26 -349.428)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M.667,447.182c2.971-7.312,5.926-7.717,5.926-7.717-3.07-.253-7.174,2.228-8.659,6.845-2.021,5.635,2.243,9.915,2.243,9.915a15.176,15.176,0,0,1,.49-9.042Z",
    transform: "translate(11.453 -359.03)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(43.885 106.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M54.013,487.28a34.45,34.45,0,0,1-4.678,5.4,25.111,25.111,0,0,1-5.405,3.728,13.955,13.955,0,0,0,4.571-.743c4.157-1.8,5.512-8.383,5.512-8.383Z",
    transform: "translate(-43.34 -477.052)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M57.117,473.928s-2.075,8.437-7.357,11.04a10.874,10.874,0,0,1-6.6,1.516,8.658,8.658,0,0,0,6.492.413c3.568-.658,8.146-9.555,7.465-12.977Z",
    transform: "translate(-43.16 -473.92)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(34.605 32.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M41.9,390.57a34.45,34.45,0,0,1-4.678,5.4A25.111,25.111,0,0,1,31.82,399.7a13.956,13.956,0,0,0,4.571-.743C40.548,397.154,41.9,390.57,41.9,390.57Z",
    transform: "translate(-31.223 -380.342)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M45,377.218s-2.075,8.437-7.357,11.04a10.874,10.874,0,0,1-6.6,1.516,8.658,8.658,0,0,0,6.492.413c3.568-.658,8.146-9.547,7.465-12.977Z",
    transform: "translate(-31.04 -377.21)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(26.191 59.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M30.9,425.5a34.45,34.45,0,0,1-4.678,5.4,25.111,25.111,0,0,1-5.405,3.728,13.955,13.955,0,0,0,4.571-.743c4.157-1.8,5.512-8.383,5.512-8.383Z",
    transform: "translate(-20.23 -415.272)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M34.007,412.148s-2.075,8.437-7.357,11.04a10.873,10.873,0,0,1-6.6,1.516,8.658,8.658,0,0,0,6.492.413c3.568-.658,8.146-9.547,7.465-12.977Z",
    transform: "translate(-20.05 -412.14)",
    fill: "#ffe4c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(0.214 101.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M-3.017,480.28a34.451,34.451,0,0,1-4.678,5.4,25.11,25.11,0,0,1-5.405,3.728,14.2,14.2,0,0,0,4.571-.743c4.157-1.8,5.512-8.383,5.512-8.383Z",
    transform: "translate(13.697 -470.052)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M.077,466.92S-2,475.357-7.28,477.96a10.928,10.928,0,0,1-6.6,1.524,8.658,8.658,0,0,0,6.492.413C-3.82,479.239.758,470.35.077,466.92Z",
    transform: "translate(13.88 -466.92)",
    fill: "#ffe4c7"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M63.68,239.193c14.945-.038,24.1-9.746,24.1-10.06s-21.491-2.6-21.491-2.6a17.488,17.488,0,0,0-1.753,5.711c-.536,3.606-.857,6.952-.857,6.952Z",
    transform: "translate(-14.927 -53.102)",
    fill: "#d97d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M81.274,68.82c5.221,2.113,7.779,13.551,17.218,13.222s8.667-10.106,8.667-10.106,2.029-.115,2.519-.061,4.042,1.945,6.592,8.169,3.223,12.778,1.447,23.994-3.108,13.666-6.668,24.438-1.784,23.879,0,28.327-.888,5.329.23,9.333,2.664,7.22,2.335,10.328,4.624,7.12,1.669,11.775c-9.884,15.549-35.432,5.329-51.541,2.442s-16.216-6.11-15.771-9.111,3.889-4.111,2.886-9.555S52.526,164.9,52.3,160.8s-.115-24.882-2-42.652-4-26.107-1.11-33.434,13.329-11.66,19.439-13.773A44.138,44.138,0,0,1,81.3,68.828Z",
    transform: "translate(-11.2 -16.136)",
    fill: "#f2d8b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(90.559 167.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(170.098 122.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M373.588,447.613,340.46,380.936l3.836-1.906,33.082,66.585C376.122,446.289,374.851,446.947,373.588,447.613Z",
    transform: "translate(-340.46 -379.03)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M377.675,445.975,344.754,379.7a1.567,1.567,0,0,1-.084-.375l.6-.3,33.082,66.585C378.127,445.737,377.9,445.852,377.675,445.975Z",
    transform: "translate(-341.447 -379.03)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M373.588,447.974,340.46,381.3l1.462-.727,33.1,66.646c-.482.253-.965.505-1.447.766Z",
    transform: "translate(-340.46 -379.391)",
    fill: "#838991"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(192.959 189.312)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 41.802,
    height: 9.792,
    transform: "translate(0.004 1.925) rotate(-0.36)",
    fill: "#ffba59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M412.16,477.67l-41.8.268-.038-11.4,41.8-.268Z",
    transform: "translate(-370.32 -466.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M303.8,362.49l-99.468.628a8,8,0,0,0,.1,16.009L303.9,378.5a8,8,0,0,0-.1-16.009Z",
    transform: "translate(-136.59 -252.633)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M307.983,363.7a7.993,7.993,0,0,0-4.3-1.225l-99.468.628c-3.392.023-13.689,6.477-4.8,14.141,2.335,2,40.83,1.7,81.759,1.447,40.968-.26,33.1-.888,26.812-14.991Z",
    transform: "translate(-136.476 -252.631)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(61.665 68.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M199.131,367l5.275-.031-.3-46.947a5.569,5.569,0,0,1,5.528-5.6l92.233-.582a5.569,5.569,0,0,1,5.6,5.528l.3,46.947,5.275-.031-.3-46.947a10.843,10.843,0,0,0-10.9-10.764l-92.233.582a10.843,10.843,0,0,0-10.764,10.9l.3,46.947Z",
    transform: "translate(-198.832 -308.572)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M198.838,320.054a10.848,10.848,0,0,1,10.764-10.9l92.233-.582a10.843,10.843,0,0,1,10.9,10.764l.3,46.939a2.855,2.855,0,0,1-.965-2.09L311.8,320.59A10.461,10.461,0,0,0,301.276,310.2l-91.1.574a10.461,10.461,0,0,0-10.389,10.519l.276,43.594a2.874,2.874,0,0,1-.934,2.105l-.3-46.939Z",
    transform: "translate(-198.83 -308.57)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M203.393,367.453l-.283-45.6a8.875,8.875,0,0,1,8.82-8.927l89.63-.567a8.875,8.875,0,0,1,8.927,8.82l.283,45.6-2.014.015-.291-46.526a5.574,5.574,0,0,0-5.6-5.528l-92.233.582a5.574,5.574,0,0,0-5.528,5.6l.291,46.526-2.014.015Z",
    transform: "translate(-199.833 -309.458)",
    fill: "#838991"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(61.665 78.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M312.737,322.538l-5.275.031.291,45.936a5.569,5.569,0,0,1-5.528,5.6l-92.233.582a5.569,5.569,0,0,1-5.6-5.528l-.291-46.526-5.275.031.291,46.526a10.843,10.843,0,0,0,10.9,10.764l92.233-.582a10.843,10.843,0,0,0,10.764-10.9l-.291-45.936Z",
    transform: "translate(-198.83 -321.629)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M313.028,368.2a10.848,10.848,0,0,1-10.764,10.9l-92.233.582a10.843,10.843,0,0,1-10.9-10.764l-.3-46.939c.475-.628,1.485-1.018,1.21,0l.023,45.691a10.461,10.461,0,0,0,10.519,10.389l91.1-.574a10.461,10.461,0,0,0,10.389-10.519l-.367-44.688c0-.835.5-.6,1.034,0l.291,45.936Z",
    transform: "translate(-198.83 -321.353)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M310.45,322.313l.352,45.079a8.874,8.874,0,0,1-8.82,8.927l-89.63.567a8.874,8.874,0,0,1-8.927-8.82l-.145-45.6,1.868-.015.291,46.526a5.574,5.574,0,0,0,5.6,5.528l92.233-.582a5.574,5.574,0,0,0,5.528-5.6L308.5,321.8l1.952.505Z",
    transform: "translate(-199.873 -321.458)",
    fill: "#838991"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M306.161,307.662c-3.736,6.347-2.925,3.874-33.212,4.058s-37.124.23-43.685.276-4.961-2.32-3.629-3.828,3.69-3.315,5.443-3.323,73.33-.459,75.068-.475,2.481,3.277,2.481,3.277l-2.458.015Z",
    transform: "translate(-143.167 -239.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(9.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(0 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M131.628,220.993h.528l2.1-.015,42.4-.268a10.843,10.843,0,0,1,10.9,10.764l.735,116.977-5.275.031L182.28,231.5a5.574,5.574,0,0,0-5.6-5.528l-42.583.268h-.015l-1.562.008h-.505c-2.419.015-1.73-5.26-.39-5.275Z",
    transform: "translate(-130.411 -220.71)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M187.37,347.946l-.727-115.208a10.461,10.461,0,0,0-10.519-10.389l-45.554.283c.191-.911.6-1.638,1.095-1.638h.528l2.1-.015,42.4-.268a10.843,10.843,0,0,1,10.9,10.764l.735,116.977h-.835a2.18,2.18,0,0,1-.115-.513Z",
    transform: "translate(-130.455 -220.71)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M130.435,224.773l44.933-.283a8.875,8.875,0,0,1,8.927,8.82l.727,116.043-2.014.015-.735-116.977a5.574,5.574,0,0,0-5.6-5.528l-42.583.268h-.015l-1.562.008h-.505c-1.133,0-1.562-1.148-1.592-2.373Z",
    transform: "translate(-130.42 -221.596)",
    fill: "#838991"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M147.858,219.122,167.7,219c2.886-.015,5.229,1.8,5.244,4.058s-2.312,4.111-5.2,4.127l-19.837.122c-2.886.015-5.229-1.8-5.244-4.058S144.972,219.138,147.858,219.122Z",
    transform: "translate(-133.282 -219)",
    fill: "#3b393a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(10.422 56.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M133.155,420.482h.528l2.1-.015,42.4-.268a10.843,10.843,0,0,0,10.764-10.9L188.21,292.32l-5.275.031.735,116.977a5.569,5.569,0,0,1-5.528,5.6l-42.583.268h-.015l-1.562.008h-.505c-2.419.015-1.669,5.283-.329,5.275Z",
    transform: "translate(-131.898 -292.32)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(0.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M187.306,292.841l.727,115.208a10.456,10.456,0,0,1-10.389,10.519l-45.554.283c.207.911.62,1.631,1.11,1.631h.528l2.1-.015,42.4-.268a10.843,10.843,0,0,0,10.764-10.9l-.735-116.977h-.835A3.008,3.008,0,0,0,187.306,292.841Z",
    transform: "translate(-131.96 -292.32)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M131.928,417.613l44.933-.283a8.874,8.874,0,0,0,8.82-8.927l-.727-116.043-2.014.015.735,116.977a5.569,5.569,0,0,1-5.528,5.6l-42.583.268h-.015l-1.562.008h-.505c-1.133,0-1.554,1.164-1.562,2.4Z",
    transform: "translate(-131.92 -292.329)",
    fill: "#838991"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(170.404 96.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M341.411,432.446l-.551-87.195,5.275-.031.544,86.59A26.528,26.528,0,0,0,341.411,432.446Z",
    transform: "translate(-340.86 -344.699)",
    fill: "#a5acb8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M347.038,431.7c0-.061.015-.115.015-.176l-.544-86.935c0-.184.084.176.115,0h.835L348,431.643c-.329.008-.643.038-.965.054Z",
    transform: "translate(-342.184 -344.54)",
    fill: "#d2dbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M341.411,432.307l-.551-87.662,2.014-.015.551,87.256v.069c-.681.1-1.355.207-2.006.352Z",
    transform: "translate(-340.86 -344.561)",
    fill: "#838991"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(0 90.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M119.368,389.937a64.7,64.7,0,1,0,75.359-51.908,64.707,64.707,0,0,0-75.359,51.908ZM132.2,392.3a51.652,51.652,0,1,1,41.442,60.154A51.656,51.656,0,0,1,132.2,392.3Z",
    transform: "translate(-118.286 -336.946)",
    fill: "#363334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M126.618,392.674a59.087,59.087,0,1,0,68.813-47.406,59.086,59.086,0,0,0-68.813,47.406Zm7.312,1.347a51.652,51.652,0,1,1,41.442,60.154A51.656,51.656,0,0,1,133.929,394.021Z",
    transform: "translate(-120.007 -338.665)",
    fill: "#e2ebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M129.338,393.7A56.974,56.974,0,1,0,195.693,348,56.973,56.973,0,0,0,129.338,393.7Zm3.231.6a53.693,53.693,0,1,1,43.073,62.535A53.694,53.694,0,0,1,132.569,394.3Z",
    transform: "translate(-120.653 -339.313)",
    fill: "#b5bdc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M132.13,394.756a54.813,54.813,0,1,0,63.836-43.976A54.81,54.81,0,0,0,132.13,394.756Zm3.108.574a51.652,51.652,0,1,1,41.442,60.154A51.656,51.656,0,0,1,135.238,395.33Z",
    transform: "translate(-121.316 -339.973)",
    fill: "#9ba1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M133.409,414.931l46.426-9.761-46.656-8.6a1.237,1.237,0,1,1,.444-2.435l46.771,8.613-39.827-25.992a1.237,1.237,0,0,1,1.347-2.075l39.727,25.931-26.911-39.069a1.238,1.238,0,0,1,2.037-1.409L183.74,399.29l-9.777-46.534a1.236,1.236,0,0,1,2.419-.505l9.761,46.434,8.6-46.656a1.237,1.237,0,0,1,2.435.444l-8.613,46.771,25.992-39.819a1.236,1.236,0,1,1,2.067,1.355l-25.931,39.727L229.76,373.6a1.238,1.238,0,1,1,1.409,2.036l-39.153,26.972,46.526-9.777a1.243,1.243,0,0,1,1.462.957,1.227,1.227,0,0,1-.957,1.462l-46.434,9.761,46.664,8.6a1.237,1.237,0,0,1-.444,2.435l-46.763-8.613,39.819,25.985a1.236,1.236,0,0,1-.9,2.251,1.108,1.108,0,0,1-.452-.184l-39.727-25.923,26.911,39.069a1.248,1.248,0,0,1-.314,1.723,1.27,1.27,0,0,1-.926.2,1.2,1.2,0,0,1-.8-.513l-26.972-39.161,9.777,46.534a1.227,1.227,0,0,1-.957,1.462,1.028,1.028,0,0,1-.482,0,1.244,1.244,0,0,1-.988-.957L186.3,411.478l-8.6,46.656a1.237,1.237,0,0,1-2.435-.444l8.613-46.763-25.992,39.819a1.238,1.238,0,0,1-1.256.544,1.107,1.107,0,0,1-.452-.184,1.228,1.228,0,0,1-.36-1.707l25.931-39.727-39.069,26.911a1.263,1.263,0,0,1-.926.2,1.2,1.2,0,0,1-.8-.513,1.248,1.248,0,0,1,.314-1.723l39.153-26.972-46.526,9.777a1.028,1.028,0,0,1-.482,0,1.244,1.244,0,0,1-.988-.957,1.227,1.227,0,0,1,.957-1.462Z",
    transform: "translate(-121.538 -340.243)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(145.675 164.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M308.56,461.285a27.116,27.116,0,1,1,0,.008Zm11.507-.069a15.779,15.779,0,1,0,15.68-15.879,15.785,15.785,0,0,0-15.68,15.879Z",
    transform: "translate(-308.559 -433.829)",
    fill: "#363334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M317.25,463.273a20.633,20.633,0,1,0,20.5-20.763A20.657,20.657,0,0,0,317.25,463.273Zm4.854-.031a15.779,15.779,0,1,1,15.879,15.672A15.8,15.8,0,0,1,322.1,463.242Z",
    transform: "translate(-310.596 -435.864)",
    fill: "#e2ebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M319.83,463.863a18.778,18.778,0,1,1,0,.008Zm2.886-.015a15.779,15.779,0,1,1,15.879,15.672,15.8,15.8,0,0,1-15.879-15.672Z",
    transform: "translate(-311.201 -436.469)",
    fill: "#b5bdc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M321.69,464.291a17.234,17.234,0,1,0,17.127-17.341A17.256,17.256,0,0,0,321.69,464.291Zm1.462-.008a15.779,15.779,0,1,1,15.879,15.672,15.8,15.8,0,0,1-15.879-15.672Z",
    transform: "translate(-311.637 -436.905)",
    fill: "#9ba1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M324.131,460.757l9.585,1.769-8.2-5.352a15.434,15.434,0,0,1,1.317-2.014l8.108,5.29-5.512-8a15.468,15.468,0,0,1,1.983-1.37l5.574,8.092-2.021-9.631a15.911,15.911,0,0,1,2.358-.5l2.006,9.539,1.769-9.593a15.022,15.022,0,0,1,2.366.452l-1.784,9.685,5.375-8.238a15.992,15.992,0,0,1,2.006,1.332l-5.306,8.131,7.97-5.489a16.931,16.931,0,0,1,1.363,1.991l-8.054,5.543,9.532-2.006a16.091,16.091,0,0,1,.482,2.358l-9.425,1.983,9.44,1.738a15.954,15.954,0,0,1-.459,2.366l-9.516-1.753,8.077,5.267a15.992,15.992,0,0,1-1.332,2.006l-7.97-5.2,5.39,7.817a16.045,16.045,0,0,1-1.991,1.363l-5.443-7.9,1.968,9.379a14.98,14.98,0,0,1-2.358.49l-1.952-9.271-1.715,9.325a15.937,15.937,0,0,1-2.366-.444l1.738-9.425-5.252,8.039a15.968,15.968,0,0,1-2.014-1.317l5.191-7.947-7.84,5.405a15.516,15.516,0,0,1-1.378-1.983l7.939-5.466-9.471,1.991a15,15,0,0,1-.505-2.358l9.379-1.975-9.471-1.746a15.26,15.26,0,0,1,.436-2.373Z",
    transform: "translate(-312.111 -437.383)",
    fill: "#ccc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M220.373,283.884c15.871,8.6,51.87,12.143,55.514,14.5,2.657,1.715,10.328-8.223,4.976-9.478-4.586-1.079-7-2.856-13.207-5.9-6.906-3.384-25.326-15.894-33.58-16.966-3.583-.459-7.61,1.294-13.773,4.372s-6.8,9.754.077,13.475Z",
    transform: "translate(-50.502 -62.345)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(221.45 226.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M293.621,295.71c5.13-.36,11.247,2.366,15.886,3.177s6.745,3.07,7.25,3.958,3.874,6.967,3.4,7.243-1.026.59-3.491-2.465-1.73-2.557-2.465-3.047a31.64,31.64,0,0,0-4.15-1.547,45.773,45.773,0,0,1,4.042,6.148,22.587,22.587,0,0,1,1.868,5.834s-1.386.436-2.6-1.692c0,0-.689,1.026-2.274-.8s-5.221-6.293-5.221-6.293,2.105,4.341,2.067,5.551.582,2.94-.031,2.971-2.251-1.4-2.641-4-3.7-2.343-6.538-2.549c-8.322-.59-13.72-11.89-5.107-12.495Z",
    transform: "translate(-289.249 -295.677)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M309.06,307.024a10.244,10.244,0,0,1,1.638,1.286,38.575,38.575,0,0,1,2.664,3.193c.827,1.049,1.615,2.044,2.075,2.542l.184.2c.9.965,1.279,1.378,1.945,1.294l.13-.077a49.69,49.69,0,0,0-3.323-5.819c-1.034-1.225-3.353-4.433-3.353-4.433s2.68,2.9,3.713,4.127a53.422,53.422,0,0,1,3.484,6.11l.1.2-.643.352c-.942.138-1.462-.421-2.4-1.439l-.184-.191c-.475-.513-1.263-1.516-2.1-2.572a43.124,43.124,0,0,0-3.928-4.77Z",
    transform: "translate(-293.893 -297.912)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M319.338,315.479a1.623,1.623,0,0,1-.084-.161.24.24,0,0,1,.1-.322.244.244,0,0,1,.322.1,3.138,3.138,0,0,0,1.853,1.638c.23.054.337.023.352.008a29.7,29.7,0,0,0-1.677-5.13c-.505-1.21-5.068-7.794-4.953-7.863a67.748,67.748,0,0,1,5.39,7.679c.023.054,2.052,5.03,1.615,5.6a.628.628,0,0,1-.6.2,3.361,3.361,0,0,1-2.312-1.761Z",
    transform: "translate(-295.343 -297.569)",
    fill: "#c76852"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M92.274,145.149c-.467-17.571-12.372-36.121-13.926-40.355s.789-9.149-1.945-16.284c-2.611-6.822-8.008-12.541-15.909-10.489-18.352,4.77-9.532,26.421-9.532,26.421s5.865,20.419,11.048,31.436,12.709,21.3,18.688,20.932C85.536,156.51,92.741,162.712,92.274,145.149Z",
    transform: "translate(-11.45 -18.193)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M82.308,175.634c12.87,13.054,46.7,27.363,49.542,30.724,2.075,2.45,12.4-4.747,7.572-7.579-4.127-2.427-5.941-4.854-11.078-9.662-5.7-5.336-19.906-22.915-27.585-26.436-3.33-1.531-7.74-1.064-14.608.015s-9.417,7.281-3.843,12.939Z",
    transform: "translate(-18.58 -37.907)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(112.71 161.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M147.809,217.211c1.891,3.66,3.744,3.384,6.094,6.094s1.309,3.422,4,4.571c1.623.7,3.108,1.156,3.851.5,0,0,3.461,1.409,5.512.107,0,0,2.779,1.386,3.491,1.064s1.524-1.148,1.156-2.067-3.537-3.108-4.471-4.157-5.964-7.641-.207-6.446c2.664.559,1.669-1.776,3-2.664-3.223-.888-3.062-.7-6.018-1.577-6.485-1.922-10.351-1.011-12.977-.8S146.025,213.758,147.809,217.211Z",
    transform: "translate(-147.218 -211.432)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M177.378,229.4a12.886,12.886,0,0,0-1.386-1.324c-.911-.8-2.167-1.906-3.529-3.361-1.493-1.592-2.327-2.787-2.6-4.349h0l-.084.23c0,.077-.145,1.945,2.259,4.517,1.386,1.478,2.649,2.588,3.568,3.407a12.374,12.374,0,0,1,1.309,1.24.376.376,0,0,1,.077.322,2.738,2.738,0,0,1-1.164,1.325c-.314.214-1.9-.39-3.193-1.08l-.176-.092-.153.13c-.612.819-2.412.39-2.419.39a.282.282,0,0,0-.322.253.293.293,0,0,0,.253.329c.038,0,1.952.345,2.718-.4.85.444,2.925,1.439,3.621.965.3-.2,1.279-.919,1.409-1.715a.969.969,0,0,0-.191-.773Z",
    transform: "translate(-152.457 -213.527)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M162.478,230.44h0a.3.3,0,0,1,.413.038,16.04,16.04,0,0,0,2.082,2,5.164,5.164,0,0,0,2.542.766c-.444-.482-1.294-1.409-1.845-2.1a.289.289,0,0,1,.046-.406.294.294,0,0,1,.413.046c.743.926,2.1,2.366,2.105,2.373l.237.245-.283.191c-1.1.75-3.292-.5-3.545-.643a15.714,15.714,0,0,1-2.2-2.105.3.3,0,0,1,.031-.406Z",
    transform: "translate(-150.771 -215.872)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M169.97,230.357a.143.143,0,0,1,.031-.023.293.293,0,0,1,.406.069,22.239,22.239,0,0,0,2.366,2.266.293.293,0,0,1-.383.444,21.815,21.815,0,0,1-2.465-2.381.292.292,0,0,1,.046-.383Z",
    transform: "translate(-152.529 -215.85)",
    fill: "#c76852"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M174.6,214.63c3.889.888,5.13.643,5.375,1.5s-2.549,1.906-4.793,1.853a8.541,8.541,0,0,1-3.66-.842l3.078-2.511Z",
    transform: "translate(-152.915 -212.181)",
    fill: "#fb9d77"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M63.251,76.259c-11.974,3.223-15.664,9.333-14.439,21.108S58.918,133.8,58.918,133.8s10.887.559,19.554-5.107S89.8,122.027,89.8,122.027,80.47,95.475,77.139,87.039,69.031,74.7,63.251,76.266Z",
    transform: "translate(-11.39 -17.802)",
    fill: "#f2d8b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(47.191 102.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M61.977,149.711h0a.34.34,0,0,1-.337-.337.333.333,0,0,1,.337-.329h0c.015,0,.245,0,.651-.015a.333.333,0,0,1,.345.322.339.339,0,0,1-.322.345C62.237,149.711,62,149.711,61.977,149.711Z",
    transform: "translate(-61.64 -137.606)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M64.629,146.362a.329.329,0,0,1-.329-.314.323.323,0,0,1,.306-.352q.666-.046,1.355-.115a.335.335,0,1,1,.069.666c-.459.046-.926.084-1.37.115h-.023Zm2.726-.268a.331.331,0,0,1-.329-.291.336.336,0,0,1,.291-.375c.452-.054.9-.115,1.347-.184a.334.334,0,0,1,.107.658c-.452.069-.911.13-1.363.191H67.37Zm2.7-.413a.336.336,0,0,1-.061-.666c.444-.084.9-.168,1.332-.26a.338.338,0,0,1,.4.26.334.334,0,0,1-.26.4c-.444.092-.9.184-1.355.268h-.061Zm2.68-.567a.327.327,0,0,1-.322-.253.339.339,0,0,1,.245-.406q.666-.161,1.309-.345a.334.334,0,0,1,.184.643c-.436.122-.888.237-1.332.345-.023,0-.054.008-.077.008Zm2.634-.735a.329.329,0,0,1-.314-.23.338.338,0,0,1,.214-.421c.436-.138.865-.283,1.286-.429a.334.334,0,1,1,.23.628q-.643.23-1.309.436a.448.448,0,0,1-.1.015Zm2.572-.926a.334.334,0,0,1-.122-.643c.413-.168.827-.36,1.217-.551a.33.33,0,1,1,.3.59c-.406.207-.835.4-1.263.574a.358.358,0,0,1-.13.023Zm2.442-1.217a.334.334,0,0,1-.283-.161.343.343,0,0,1,.115-.459c.367-.214.735-.452,1.133-.727a.331.331,0,0,1,.367.551c-.406.276-.789.521-1.171.743a.349.349,0,0,1-.168.046Zm2.266-1.524a.324.324,0,0,1-.268-.138.333.333,0,0,1,.077-.467c.207-.153.421-.306.628-.459.153-.115.314-.23.475-.345a.335.335,0,0,1,.39.544c-.161.115-.314.23-.475.345-.214.153-.421.306-.635.459a.322.322,0,0,1-.2.061Zm2.213-1.6a.345.345,0,0,1-.276-.145.334.334,0,0,1,.084-.467c.4-.276.773-.528,1.141-.766a.332.332,0,1,1,.36.559c-.367.237-.735.482-1.125.75a.354.354,0,0,1-.191.061Zm2.3-1.478a.347.347,0,0,1-.291-.168.339.339,0,0,1,.122-.459c.39-.23.8-.459,1.2-.674a.334.334,0,1,1,.314.59c-.4.214-.8.436-1.179.658a.328.328,0,0,1-.168.046Zm2.412-1.286a.325.325,0,0,1-.3-.191.337.337,0,0,1,.153-.444c.406-.2.827-.39,1.248-.582a.331.331,0,0,1,.268.6c-.421.184-.835.375-1.233.567a.332.332,0,0,1-.145.031Z",
    transform: "translate(-62.263 -134.341)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M100.489,135.021a.33.33,0,0,1-.306-.207.339.339,0,0,1,.184-.436c.207-.084.413-.168.62-.245a.325.325,0,0,1,.429.191.328.328,0,0,1-.191.429c-.207.084-.413.161-.612.245a.347.347,0,0,1-.122.023Z",
    transform: "translate(-70.668 -134.109)",
    fill: "#fff7f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(46.532 101.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M61.109,148.261h0a.333.333,0,0,1,.008-.666h0c.008,0,.245,0,.651-.015a.333.333,0,0,1,.345.322.339.339,0,0,1-.322.345c-.413.015-.651.015-.674.015Z",
    transform: "translate(-60.78 -136.156)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M63.759,144.915a.329.329,0,0,1-.329-.314.323.323,0,0,1,.306-.352q.666-.046,1.355-.115a.335.335,0,1,1,.069.666c-.459.046-.926.084-1.37.115h-.023Zm2.726-.26a.331.331,0,0,1-.329-.291.336.336,0,0,1,.291-.375c.452-.054.9-.115,1.347-.184a.334.334,0,0,1,.107.658c-.452.069-.911.13-1.363.191H66.5Zm2.7-.413a.336.336,0,0,1-.061-.666c.444-.084.9-.168,1.332-.26a.338.338,0,0,1,.4.26.334.334,0,0,1-.26.4c-.444.092-.9.184-1.355.268h-.061Zm2.68-.567a.327.327,0,0,1-.322-.253.339.339,0,0,1,.245-.406q.666-.161,1.309-.345a.334.334,0,0,1,.184.643c-.436.122-.888.237-1.332.345-.023,0-.054.008-.077.008Zm2.634-.735a.329.329,0,0,1-.314-.23.338.338,0,0,1,.214-.421c.436-.138.865-.283,1.286-.429a.334.334,0,1,1,.23.628q-.643.23-1.309.436a.449.449,0,0,1-.1.015Zm2.572-.926a.334.334,0,0,1-.123-.643c.413-.168.827-.36,1.217-.551a.33.33,0,1,1,.3.59c-.406.207-.835.4-1.263.574a.357.357,0,0,1-.13.023Zm2.442-1.217a.334.334,0,0,1-.283-.161.343.343,0,0,1,.115-.459c.367-.214.735-.452,1.133-.727a.331.331,0,0,1,.367.551c-.406.276-.789.521-1.171.743a.349.349,0,0,1-.168.046Zm2.266-1.524a.324.324,0,0,1-.268-.138.333.333,0,0,1,.077-.467c.207-.153.421-.306.628-.459.153-.115.314-.23.475-.345a.335.335,0,1,1,.39.544c-.161.115-.314.23-.475.345-.214.153-.421.306-.635.459a.322.322,0,0,1-.2.061Zm2.213-1.6a.345.345,0,0,1-.276-.145.334.334,0,0,1,.084-.467c.4-.276.773-.528,1.141-.766a.332.332,0,0,1,.36.559c-.367.237-.735.482-1.125.75a.354.354,0,0,1-.191.061Zm2.3-1.478a.347.347,0,0,1-.291-.168.339.339,0,0,1,.123-.459c.39-.23.8-.459,1.2-.674a.334.334,0,1,1,.314.59c-.4.214-.8.436-1.179.658a.349.349,0,0,1-.168.046Zm2.412-1.286a.325.325,0,0,1-.3-.191.337.337,0,0,1,.153-.444c.406-.2.827-.39,1.248-.582a.325.325,0,0,1,.436.168.332.332,0,0,1-.168.436c-.421.184-.835.375-1.233.567a.332.332,0,0,1-.145.031Z",
    transform: "translate(-61.401 -132.894)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M99.619,133.571a.33.33,0,0,1-.306-.207.339.339,0,0,1,.184-.436c.207-.084.413-.168.62-.245a.332.332,0,1,1,.237.62c-.207.084-.413.161-.612.245a.347.347,0,0,1-.122.023Z",
    transform: "translate(-69.806 -132.659)",
    fill: "#fff7f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M96.63,127.887a.33.33,0,0,1-.107-.643c.612-.214,1.868-.842,1.883-1.455-.138-1.011-8.567-24.852-11.645-31.972a.333.333,0,1,1,.612-.26c2.8,6.469,11.7,31.237,11.7,32.224,0,1.256-2.1,2.014-2.335,2.09a.26.26,0,0,1-.107.015Z",
    transform: "translate(-20.331 -21.886)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M59.961,142.947a3.166,3.166,0,0,1-.766-.061c-.2-.069-.283-.092-1.409-3.422-.7-2.082-1.585-4.816-2.481-7.694-1.08-3.476-3.751-12.2-5.1-18.053a.333.333,0,0,1,.651-.145c2.167,9.371,7.932,27.141,8.659,28.71a13.814,13.814,0,0,0,1.707-.038.334.334,0,1,1,.054.666c-.237.015-.8.054-1.294.054Z",
    transform: "translate(-11.768 -26.564)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M133.109,131.516a.306.306,0,0,1-.1-.015.335.335,0,0,1-.214-.421A140.511,140.511,0,0,0,137.9,107.69a.331.331,0,0,1,.658.077,140.887,140.887,0,0,1-5.137,23.512.336.336,0,0,1-.314.23Z",
    transform: "translate(-31.124 -25.178)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M107.2,294.386s-.107-35.18,2.228-41.626,3.889-7.22,3.889-7.22a30.649,30.649,0,0,0-4,14.11c-.444,8.667-.459,37.882-.459,37.882l-1.654-3.147Z",
    transform: "translate(-25.128 -57.558)",
    fill: "#ffcf9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M7.278,406.612a.356.356,0,0,1-.176-.046.334.334,0,0,1-.107-.459c.482-.781,47.981-77.946,50.277-89.2,1.148-5.65-1-16.5-3.284-27.975-2.312-11.645-4.938-24.852-4.716-35.386.444-20.824,2.6-25.6,2.695-25.793a.334.334,0,1,1,.6.283c-.023.046-2.2,4.93-2.634,25.525-.222,10.466,2.4,23.634,4.708,35.249,2.4,12.051,4.463,22.455,3.284,28.243-.972,4.777-9.746,21.284-26.077,49.045C19.7,386.76,7.684,406.275,7.569,406.467a.334.334,0,0,1-.283.161Z",
    transform: "translate(-1.629 -53.343)",
    fill: "#ffdfc4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(1.869 346.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M3.1,454.126a.337.337,0,0,1-.291-.168c-.214-.375-.322-.6-.329-.6a.332.332,0,1,1,.6-.291s.107.214.306.567a.334.334,0,0,1-.291.5Z",
    transform: "translate(-2.443 -452.873)",
    fill: "#d97d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M15.636,462.7c-.2,0-.406,0-.6-.015a.334.334,0,1,1,.038-.666,10.443,10.443,0,0,0,1.294-.008.334.334,0,0,1,.054.666c-.26.015-.521.031-.773.031Zm-1.906-.184h-.061a11.785,11.785,0,0,1-1.332-.345.334.334,0,0,1,.207-.635,10.826,10.826,0,0,0,1.256.322.333.333,0,0,1-.069.658Zm3.989-.008a.336.336,0,0,1-.329-.276.331.331,0,0,1,.268-.383c.4-.069.819-.161,1.286-.276a.335.335,0,0,1,.161.651c-.482.115-.919.207-1.332.283h-.061Zm2.6-.62a.335.335,0,0,1-.322-.245.342.342,0,0,1,.23-.413q.356-.1.735-.207c.184-.054.367-.107.544-.161a.332.332,0,0,1,.191.635c-.176.054-.36.107-.544.161-.253.077-.505.145-.743.214A.384.384,0,0,1,20.321,461.887Zm-9.141-.161a.347.347,0,0,1-.122-.023c-.375-.153-.781-.329-1.194-.528l-.046-.023a.334.334,0,1,1,.283-.6l.046.023c.406.191.8.36,1.164.513a.336.336,0,0,1,.184.436.33.33,0,0,1-.306.207Zm11.714-.59a.335.335,0,0,1-.322-.237.331.331,0,0,1,.222-.413c.429-.13.88-.26,1.286-.375a.334.334,0,1,1,.184.643c-.4.115-.85.245-1.279.375a.384.384,0,0,1-.092.015Zm-14.1-.6a.3.3,0,0,1-.176-.054,13.062,13.062,0,0,1-1.118-.8.332.332,0,0,1,.413-.521c.345.276.7.528,1.057.758a.334.334,0,0,1,.1.459.327.327,0,0,1-.283.153Zm16.683-.1a.341.341,0,0,1-.329-.268.323.323,0,0,1,.26-.39,7.548,7.548,0,0,1,1.386-.168h0a.327.327,0,0,1,.329.329.333.333,0,0,1-.329.337,6.269,6.269,0,0,0-1.263.153h-.069Zm-18.78-1.554a.324.324,0,0,1-.23-.092c-.322-.306-.635-.635-.949-.98a.331.331,0,1,1,.5-.436c.3.329.6.651.911.942a.337.337,0,0,1,.008.475.331.331,0,0,1-.237.1ZM4.91,456.9a.323.323,0,0,1-.26-.13c-.276-.36-.544-.727-.8-1.1A.331.331,0,0,1,4.4,455.3c.245.368.505.727.766,1.072a.331.331,0,0,1-.061.467.336.336,0,0,1-.207.069Z",
    transform: "translate(-2.761 -453.406)",
    fill: "#d97d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M36.1,462.037a.345.345,0,0,1-.107-.015,5.464,5.464,0,0,0-.612-.184.335.335,0,1,1,.161-.651c.214.054.429.122.666.2a.33.33,0,0,1-.107.643Z",
    transform: "translate(-10.105 -454.82)",
    fill: "#d97d32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(2.757 345.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M4.259,452.676a.337.337,0,0,1-.291-.168c-.214-.375-.322-.6-.329-.6a.332.332,0,1,1,.6-.291s.107.214.306.567a.334.334,0,0,1-.291.5Z",
    transform: "translate(-3.603 -451.423)",
    fill: "#d97d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M16.8,461.248c-.2,0-.406,0-.6-.015a.334.334,0,1,1,.038-.666,10.443,10.443,0,0,0,1.294-.008.334.334,0,0,1,.054.666c-.26.015-.521.031-.773.031Zm-1.906-.184h-.061a11.785,11.785,0,0,1-1.332-.345.334.334,0,1,1,.207-.635,10.826,10.826,0,0,0,1.256.322.333.333,0,0,1-.069.658Zm3.989-.008a.336.336,0,0,1-.329-.276.331.331,0,0,1,.268-.383c.4-.069.819-.161,1.286-.276a.335.335,0,0,1,.161.651c-.482.115-.919.207-1.332.283h-.061Zm2.6-.62a.335.335,0,0,1-.322-.245.342.342,0,0,1,.23-.413q.356-.1.735-.207c.184-.054.367-.107.544-.161a.332.332,0,0,1,.191.635c-.176.054-.36.107-.544.161-.253.077-.505.145-.743.214A.384.384,0,0,1,21.481,460.437Zm-9.141-.161a.347.347,0,0,1-.122-.023c-.375-.153-.781-.329-1.194-.528l-.046-.023a.333.333,0,0,1-.161-.444.324.324,0,0,1,.444-.153l.046.023c.406.191.8.36,1.164.513a.336.336,0,0,1,.184.436.33.33,0,0,1-.306.207Zm11.714-.59a.335.335,0,0,1-.322-.237.331.331,0,0,1,.222-.413c.429-.13.88-.26,1.286-.375a.342.342,0,0,1,.413.23.335.335,0,0,1-.23.413c-.4.115-.85.245-1.279.375a.384.384,0,0,1-.092.015Zm-14.1-.6a.3.3,0,0,1-.176-.054,13.062,13.062,0,0,1-1.118-.8.332.332,0,0,1,.413-.521c.345.276.7.528,1.057.758a.334.334,0,0,1,.1.459.327.327,0,0,1-.283.153Zm16.683-.1a.341.341,0,0,1-.329-.268.323.323,0,0,1,.26-.39,7.548,7.548,0,0,1,1.386-.168.333.333,0,1,1,.008.666,6.269,6.269,0,0,0-1.263.153h-.069Zm-18.78-1.554a.324.324,0,0,1-.23-.092c-.322-.306-.635-.635-.949-.98a.331.331,0,1,1,.5-.436c.3.329.6.651.911.942a.337.337,0,0,1,.008.475.331.331,0,0,1-.237.1ZM6.07,455.445a.323.323,0,0,1-.26-.13c-.276-.36-.544-.727-.8-1.1a.331.331,0,0,1,.551-.368c.245.368.505.727.766,1.072a.331.331,0,0,1-.061.467.336.336,0,0,1-.207.069Z",
    transform: "translate(-3.921 -451.956)",
    fill: "#d97d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M37.262,460.587a.345.345,0,0,1-.107-.015,5.464,5.464,0,0,0-.612-.184.335.335,0,1,1,.161-.651c.214.054.429.122.666.2a.33.33,0,0,1-.107.643Z",
    transform: "translate(-11.265 -453.37)",
    fill: "#d97d32"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M96.718,231.506c-.291,0-.59,0-.888-.008a.333.333,0,0,1,.008-.666c.444.008.888.008,1.325,0a.333.333,0,1,1,.008.666h-.452Zm1.784-.038a.33.33,0,0,1-.329-.322.333.333,0,0,1,.322-.345c.444-.023.888-.046,1.317-.084a.334.334,0,1,1,.054.666c-.436.038-.888.061-1.34.084H98.51Zm-4-.015H94.49c-.444-.023-.888-.046-1.34-.084a.334.334,0,0,1,.054-.666c.444.031.888.061,1.325.084a.333.333,0,0,1-.015.666Zm6.653-.2a.33.33,0,0,1-.038-.658q.666-.08,1.309-.184a.334.334,0,0,1,.107.658q-.655.1-1.332.184h-.038Zm-9.31,0h-.031c-.436-.046-.888-.092-1.332-.145a.336.336,0,0,1,.084-.666c.444.054.888.107,1.317.145a.336.336,0,0,1,.3.367.332.332,0,0,1-.329.3Zm-2.649-.329h-.046c-.436-.061-.88-.13-1.325-.207a.334.334,0,0,1,.107-.658c.436.077.88.145,1.309.207a.335.335,0,0,1,.283.375A.33.33,0,0,1,89.2,230.925Zm14.585-.1a.341.341,0,0,1-.329-.268.334.334,0,0,1,.26-.4c.436-.092.865-.191,1.279-.306a.332.332,0,0,1,.168.643c-.429.115-.865.214-1.317.314h-.069Zm-17.218-.345H86.5c-.429-.084-.873-.168-1.317-.26a.332.332,0,1,1,.13-.651c.436.092.873.176,1.3.253a.336.336,0,0,1-.061.666Zm19.791-.345a.333.333,0,0,1-.1-.651c.421-.138.835-.291,1.233-.444a.335.335,0,0,1,.253.62c-.406.161-.835.322-1.271.459a.452.452,0,0,1-.107.015Zm-22.4-.2a.393.393,0,0,1-.077-.008c-.306-.069-.612-.138-.919-.214l-.383-.092a.331.331,0,1,1,.153-.643l.383.092c.306.077.612.145.911.214a.333.333,0,0,1-.069.658Zm-2.6-.6a.352.352,0,0,1-.077-.008l-1.294-.306a.331.331,0,1,1,.153-.643l1.294.306a.331.331,0,0,1,.245.4.341.341,0,0,1-.322.26Zm27.47-.191a.331.331,0,0,1-.3-.184.324.324,0,0,1,.153-.444c.4-.2.789-.406,1.141-.628a.335.335,0,1,1,.345.574c-.375.23-.773.444-1.194.651a.332.332,0,0,1-.145.031Zm-30.058-.421a.352.352,0,0,1-.077-.008c-.467-.107-.9-.207-1.294-.306a.331.331,0,0,1,.153-.643c.4.092.827.191,1.294.306a.331.331,0,0,1,.245.4.341.341,0,0,1-.322.26Zm-2.588-.6a.351.351,0,0,1-.077-.008c-.475-.107-.9-.207-1.294-.3a.333.333,0,0,1,.145-.651c.39.092.819.191,1.294.3a.333.333,0,0,1-.069.658Zm34.912-.367a.323.323,0,0,1-.26-.13.331.331,0,0,1,.061-.467,8.113,8.113,0,0,0,.949-.857.336.336,0,1,1,.49.459,8.164,8.164,0,0,1-1.026.926.336.336,0,0,1-.207.069Zm-37.5-.23a.393.393,0,0,1-.077-.008c-.459-.1-.88-.191-1.294-.283a.333.333,0,1,1,.145-.651c.413.092.835.184,1.294.283a.335.335,0,0,1,.253.4A.341.341,0,0,1,73.6,227.518Zm-2.6-.559h-.069c-.375-.077-.766-.161-1.217-.253l-.084-.015a.332.332,0,0,1,.13-.651l.084.015c.444.092.842.176,1.217.253a.333.333,0,0,1-.069.658Zm-2.6-.536h-.069c-.4-.084-.827-.168-1.3-.268a.332.332,0,1,1,.13-.651c.475.1.9.191,1.3.268a.333.333,0,0,1-.069.658Zm-2.6-.544h-.069c-.406-.084-.835-.176-1.3-.276a.336.336,0,1,1,.138-.658c.459.1.9.191,1.3.276a.334.334,0,0,1,.26.4.329.329,0,0,1-.329.268Zm-2.6-.544h-.069l-.268-.054c-.352-.077-.7-.153-1.041-.222a.333.333,0,0,1,.145-.651c.337.077.681.145,1.034.222l.268.054a.337.337,0,0,1-.069.666Zm-2.6-.582a.352.352,0,0,1-.077-.008c-.444-.107-.88-.214-1.3-.322a.335.335,0,1,1,.161-.651c.413.107.85.214,1.286.314a.331.331,0,0,1,.245.4.341.341,0,0,1-.322.26Zm-2.58-.658a.214.214,0,0,1-.084-.015c-.436-.122-.873-.245-1.286-.367a.332.332,0,1,1,.191-.635c.413.122.842.245,1.271.36a.331.331,0,0,1-.084.651Zm-2.557-.758a.306.306,0,0,1-.1-.015c-.436-.145-.865-.291-1.271-.436a.334.334,0,1,1,.23-.628c.4.145.819.283,1.248.429a.333.333,0,0,1-.1.651Zm-2.5-.9a.347.347,0,0,1-.122-.023c-.444-.176-.857-.36-1.24-.544a.334.334,0,1,1,.283-.6c.367.176.773.352,1.2.528a.336.336,0,0,1,.184.436A.33.33,0,0,1,52.948,222.434Zm-2.4-1.148a.328.328,0,0,1-.168-.046,4.388,4.388,0,0,1-1.156-.865.332.332,0,0,1,.513-.421,4.448,4.448,0,0,0,.98.712.334.334,0,0,1-.168.62Z",
    transform: "translate(-11.523 -51.533)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M96.718,230.054c-.291,0-.59,0-.888-.008a.333.333,0,0,1,.008-.666c.444.008.888.008,1.325,0a.333.333,0,0,1,.008.666h-.452Zm1.784-.038a.33.33,0,0,1-.329-.322.333.333,0,0,1,.322-.345c.444-.023.888-.046,1.317-.084a.334.334,0,1,1,.054.666c-.436.038-.888.061-1.34.084H98.51Zm-4-.015H94.49c-.444-.023-.888-.046-1.34-.084a.334.334,0,1,1,.054-.666c.444.031.888.061,1.325.084a.333.333,0,0,1-.015.666Zm6.653-.2a.33.33,0,0,1-.038-.658q.666-.08,1.309-.184a.334.334,0,1,1,.107.658q-.655.1-1.332.184h-.038Zm-9.31,0h-.031c-.436-.046-.888-.092-1.332-.145a.336.336,0,1,1,.084-.666c.444.054.888.107,1.317.145a.336.336,0,0,1,.3.367.332.332,0,0,1-.329.3Zm-2.649-.329h-.046c-.436-.061-.88-.13-1.325-.207a.334.334,0,0,1,.107-.658c.436.077.88.145,1.309.207a.335.335,0,0,1,.283.375A.33.33,0,0,1,89.2,229.472Zm14.585-.1a.341.341,0,0,1-.329-.268.334.334,0,0,1,.26-.4c.436-.092.865-.191,1.279-.306a.332.332,0,1,1,.168.643c-.429.115-.865.214-1.317.314h-.069Zm-17.218-.345H86.5c-.429-.084-.873-.168-1.317-.26a.332.332,0,1,1,.13-.651c.436.092.873.176,1.3.253a.336.336,0,0,1-.061.666Zm19.791-.345a.333.333,0,0,1-.1-.651c.421-.138.835-.291,1.233-.444a.335.335,0,0,1,.253.62c-.406.161-.835.322-1.271.459a.452.452,0,0,1-.107.015Zm-22.4-.2a.393.393,0,0,1-.077-.008c-.306-.069-.612-.138-.919-.214l-.383-.092a.331.331,0,0,1,.153-.643l.383.092c.306.077.612.145.911.214a.333.333,0,0,1-.069.658Zm-2.6-.6a.352.352,0,0,1-.077-.008l-1.294-.306a.331.331,0,1,1,.153-.643l1.294.306a.331.331,0,0,1,.245.4.341.341,0,0,1-.322.26Zm27.47-.191a.331.331,0,0,1-.3-.184.324.324,0,0,1,.153-.444c.4-.2.789-.406,1.141-.628a.33.33,0,0,1,.459.115.336.336,0,0,1-.115.459c-.375.23-.773.444-1.194.651a.332.332,0,0,1-.145.031Zm-30.058-.421a.352.352,0,0,1-.077-.008c-.467-.107-.9-.207-1.294-.306a.331.331,0,0,1,.153-.643c.4.092.827.191,1.294.306a.331.331,0,0,1,.245.4.341.341,0,0,1-.322.26Zm-2.588-.6a.352.352,0,0,1-.077-.008c-.475-.115-.9-.207-1.294-.3a.333.333,0,0,1,.145-.651c.39.092.819.191,1.294.3a.333.333,0,0,1-.069.658Zm34.912-.367a.323.323,0,0,1-.26-.13.331.331,0,0,1,.061-.467,8.112,8.112,0,0,0,.949-.857.336.336,0,1,1,.49.459,8.163,8.163,0,0,1-1.026.926.336.336,0,0,1-.207.069Zm-37.5-.23a.393.393,0,0,1-.077-.008c-.459-.1-.88-.191-1.294-.283a.333.333,0,1,1,.145-.651c.413.092.835.184,1.294.283a.335.335,0,0,1,.253.4A.341.341,0,0,1,73.6,226.065Zm-2.6-.559h-.069c-.375-.077-.766-.161-1.217-.253l-.084-.015a.332.332,0,1,1,.13-.651l.084.015c.444.092.842.176,1.217.253a.333.333,0,0,1-.069.658Zm-2.6-.536h-.069c-.4-.084-.827-.168-1.3-.268a.332.332,0,0,1,.13-.651c.475.1.9.191,1.3.268a.333.333,0,0,1-.069.658Zm-2.6-.544h-.069c-.406-.084-.835-.176-1.3-.276a.336.336,0,1,1,.138-.658c.459.1.9.191,1.3.276a.334.334,0,0,1,.26.4.329.329,0,0,1-.329.268Zm-2.6-.544h-.069l-.268-.054c-.352-.077-.7-.153-1.041-.222a.333.333,0,0,1,.145-.651c.337.077.681.145,1.034.222l.268.054a.337.337,0,0,1-.069.666Zm-2.6-.582a.352.352,0,0,1-.077-.008c-.444-.107-.88-.214-1.3-.322a.335.335,0,0,1,.161-.651c.413.107.85.214,1.286.314a.331.331,0,0,1,.245.4.341.341,0,0,1-.322.26Zm-2.58-.658a.214.214,0,0,1-.084-.015c-.436-.122-.873-.245-1.286-.367a.332.332,0,1,1,.191-.635c.413.122.842.245,1.271.36a.331.331,0,0,1-.084.651Zm-2.557-.758a.306.306,0,0,1-.1-.015c-.436-.145-.865-.291-1.271-.436a.334.334,0,1,1,.23-.628c.4.145.819.283,1.248.429a.333.333,0,0,1-.1.651Zm-2.5-.9a.347.347,0,0,1-.122-.023c-.444-.176-.857-.36-1.24-.544a.334.334,0,0,1,.283-.6c.367.176.773.352,1.2.528a.336.336,0,0,1,.184.436A.33.33,0,0,1,52.948,220.982Zm-2.4-1.156a.328.328,0,0,1-.168-.046,4.388,4.388,0,0,1-1.156-.865.332.332,0,1,1,.513-.421,4.448,4.448,0,0,0,.98.712.334.334,0,0,1-.168.62Z",
    transform: "translate(-11.523 -51.19)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M108.164,83.8h-.115a.333.333,0,1,1,.008-.666h.107a9.953,9.953,0,0,0,1.179-.069.331.331,0,0,1,.077.658,11.4,11.4,0,0,1-1.256.069Zm-1.439-.092h-.046a11.622,11.622,0,0,1-1.347-.26.332.332,0,1,1,.168-.643,10.338,10.338,0,0,0,1.271.245.325.325,0,0,1,.283.375.337.337,0,0,1-.329.291Zm3.966-.214a.334.334,0,0,1-.077-.658,9.162,9.162,0,0,0,1.225-.4.335.335,0,0,1,.253.62,10.473,10.473,0,0,1-1.309.429c-.031,0-.054.008-.084.008Zm-6.546-.444a.207.207,0,0,1-.115-.023,12.878,12.878,0,0,1-1.248-.551.336.336,0,1,1,.306-.6,12.487,12.487,0,0,0,1.187.528.334.334,0,0,1,.191.429.34.34,0,0,1-.314.214Zm9-.567a.318.318,0,0,1-.283-.161.336.336,0,0,1,.115-.459,5.8,5.8,0,0,0,.551-.375c.168-.123.329-.253.482-.383a.332.332,0,1,1,.421.513c-.168.138-.337.276-.513.406-.191.145-.4.276-.6.406a.349.349,0,0,1-.168.046Zm-11.377-.635a.3.3,0,0,1-.176-.054,13.352,13.352,0,0,1-1.11-.789.333.333,0,0,1,.406-.528c.345.268.7.521,1.064.75a.334.334,0,0,1,.1.459.327.327,0,0,1-.283.153ZM115.2,80.794a.324.324,0,0,1-.23-.092.345.345,0,0,1-.015-.475,10.088,10.088,0,0,0,.827-.988.334.334,0,1,1,.536.4,11.493,11.493,0,0,1-.88,1.057.343.343,0,0,1-.245.107ZM99.666,80.22a.338.338,0,0,1-.23-.092c-.329-.3-.651-.62-.965-.957a.336.336,0,1,1,.49-.459c.3.322.612.635.926.926a.322.322,0,0,1,.015.467.343.343,0,0,1-.245.107Zm17.1-1.569a.411.411,0,0,1-.161-.038.33.33,0,0,1-.13-.452A10.774,10.774,0,0,0,117.03,77a.33.33,0,1,1,.612.245,10.826,10.826,0,0,1-.582,1.24.345.345,0,0,1-.291.176Zm-18.918-.383a.351.351,0,0,1-.26-.123c-.191-.237-.383-.49-.574-.743-.084-.107-.161-.222-.245-.329a.334.334,0,1,1,.536-.4c.084.107.161.222.245.329.184.245.367.49.559.72a.336.336,0,0,1-.046.467.316.316,0,0,1-.207.077Zm19.9-2.09a.454.454,0,0,1-.084-.008.334.334,0,0,1-.237-.406,10.976,10.976,0,0,0,.26-1.271.337.337,0,1,1,.666.1,12.2,12.2,0,0,1-.276,1.34.327.327,0,0,1-.322.245Zm-21.514-.031a.323.323,0,0,1-.26-.13c-.276-.36-.551-.712-.819-1.041a.332.332,0,0,1,.521-.413c.268.337.551.689.827,1.049a.331.331,0,0,1-.061.467.336.336,0,0,1-.207.069Zm-1.677-2.075a.327.327,0,0,1-.253-.115c-.3-.352-.59-.681-.873-1a.331.331,0,0,1,.49-.444c.283.314.582.658.888,1.011a.329.329,0,0,1-.038.467.321.321,0,0,1-.214.077Zm23.588-.528h-.015a.334.334,0,0,1-.314-.352c.015-.253.023-.505.023-.766a.335.335,0,0,1,.337-.337.33.33,0,0,1,.337.337c0,.268,0,.536-.023.8a.329.329,0,0,1-.329.314ZM92.768,72.1a.33.33,0,0,1-.237-.1c-.329-.329-.651-.635-.949-.9a.331.331,0,1,1,.436-.5c.314.276.643.59.98.934a.337.337,0,0,1,0,.475.35.35,0,0,1-.237.1Zm-2-1.753a.354.354,0,0,1-.191-.061,2.756,2.756,0,0,0-1.018-.544h.015l.038-.666a3,3,0,0,1,1.347.666.332.332,0,0,1,.077.467.327.327,0,0,1-.276.138Z",
    transform: "translate(-20.994 -16.197)",
    fill: "#fff7f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(189.993 86.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M251.567,156.69c-4.931,13.521-4.019,17.272-.367,20.694,6.385,5.987,3.1,7.572,6.913,5.183a40.491,40.491,0,0,0,16.208-16.744c6.056-11.086-17.816-22.647-22.746-9.134Z",
    transform: "translate(-248.162 -121.401)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M269.17,184.792a4.6,4.6,0,0,1,.245-.521c.092-.168.184-.337.291-.505.054-.084.1-.161.153-.245s.107-.161.161-.245c.107-.161.222-.322.345-.475.061-.077.115-.161.176-.237l.184-.23c.122-.153.253-.306.383-.459s.268-.3.406-.452.283-.291.429-.436.3-.283.452-.429l.23-.214c.077-.069.161-.138.237-.207s.161-.138.245-.207.161-.138.245-.2c.168-.13.345-.26.521-.39.084-.069.176-.13.268-.191l.276-.184c.092-.061.184-.122.283-.184l.3-.176c.1-.054.2-.115.3-.168l.153-.084a1.529,1.529,0,0,1,.161-.077c.214-.107.429-.207.658-.306a5.593,5.593,0,0,1-.4.452l-.107.107-.1.115c-.069.077-.138.145-.207.222l-.207.222c-.069.077-.138.145-.207.222s-.138.145-.207.222-.138.145-.207.222c-.138.145-.276.291-.421.436s-.276.291-.421.436l-.214.214-.214.214-.429.429c-.582.574-1.164,1.141-1.784,1.692-.306.276-.628.551-.949.819-.161.138-.329.268-.5.4s-.345.26-.521.39Z",
    transform: "translate(-253.086 -127.821)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(1.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M251.233,130.266s-1.133,10.856-.536,15.059,1.018,6.653,1.018,6.653l3.062-8.047L259.2,125.81l-7.962,4.456Z",
    transform: "translate(-250.523 -115.595)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M294.522,134.383a5.5,5.5,0,0,1,.8,4.739c-.988,3.361-2.779,9.118-4.111,11.683a12.731,12.731,0,0,1-5.244,5.313l2.519-7.87,2.856-18.329,3.185,4.456Z",
    transform: "translate(-258.832 -116.558)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(0.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M296.45,154.645l-2.381-2.213a.314.314,0,1,1,.429-.459l2.381,2.2a.314.314,0,1,1-.429.459Z",
    transform: "translate(-261.091 -121.707)",
    fill: "#363334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M254.911,143.822a2.094,2.094,0,0,1-2.289-.582c-2.94-3.629-1.24-7.534.505-8.605,1.914-1.179,3.713,1.746,3.713,1.746l-.934,3.943-.988,3.5Z",
    transform: "translate(-251.026 -117.597)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M279.324,158.735a51.729,51.729,0,0,0,2.787-7.373c2.588-6.982,4.134-17.456,4.349-22.325.658-14.569-15.7-19.99-23.726-14.424-14.034,9.739-7.266,21.468-7.266,21.468s-.038.176-.107.49c-2.1,6.707-3.407,9.6-2.067,14.945,1.623,6.462,12.319,10.144,15.963,11.5s8.613-1.493,10.06-4.287Z",
    transform: "translate(-251.43 -112.467)",
    fill: "#fb9d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M284.049,148.548a25.312,25.312,0,0,1,.482,5.842c-.214,1.24-2.9,1.592-2.9,1.592s2.963,1.026,4.18-.934c0,0-.643-4.816-1.761-6.508Z",
    transform: "translate(-258.2 -120.923)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M276.666,136.109c-.475,1.569-1.018,1.455-2.634,1.041s-3.943.291-4.387-.031.429-2.343,2.32-2.81,5.459-.674,4.7,1.8Z",
    transform: "translate(-255.364 -117.518)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M290.245,140.349c-.276,1.608.138,1.7,1.386,1.906s2.549,1.692,2.971,1.562.6-2.3-.5-3.422-3.43-2.6-3.859-.054Z",
    transform: "translate(-260.2 -118.672)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M292.471,148.615a1.334,1.334,0,0,1-1.646,1.026,1.478,1.478,0,0,1-.873-1.822,1.334,1.334,0,0,1,1.646-1.026A1.478,1.478,0,0,1,292.471,148.615Z",
    transform: "translate(-260.137 -120.5)",
    fill: "#363334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M273.691,143.725a1.334,1.334,0,0,1-1.646,1.026,1.478,1.478,0,0,1-.873-1.822,1.334,1.334,0,0,1,1.646-1.026A1.478,1.478,0,0,1,273.691,143.725Z",
    transform: "translate(-255.735 -119.354)",
    fill: "#363334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M284.028,164.88c-2.718.406-7.648-2.71-7.648-2.71s.367,2.894,1.2,3.675a6.8,6.8,0,0,0,4.448,1,9.757,9.757,0,0,0,2-1.975Z",
    transform: "translate(-256.969 -124.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M269.183,150.322a4.256,4.256,0,0,1-.413-.429,3.453,3.453,0,0,1-.138-3.935,1.571,1.571,0,0,1,1.684-.88c.046.015,4.134,1.179,8.521,2.442a2.672,2.672,0,0,1,2.419-.413,3.489,3.489,0,0,1,1.432,1.531c3.966,1.156,6.316,1.853,6.982,2.082a1.735,1.735,0,0,1,1.233,1.263c.268,1.2-.689,2.68-1.355,3.33a4.209,4.209,0,0,1-2.657.911,6.087,6.087,0,0,1-3.392-.819c-.911-.551-1.409-1.837-1.478-3.82a16.664,16.664,0,0,1,.138-2.611c-.766-1.271-1.325-1.914-3.124-.85a.314.314,0,0,1-.008.084,14.248,14.248,0,0,1-.819,2.3c-.743,1.615-1.592,2.5-2.534,2.634a7.319,7.319,0,0,1-3.813-1,12.725,12.725,0,0,1-2.68-1.837Zm9.233-2.259c-4.287-1.233-8.23-2.358-8.276-2.373-.475-.13-.873.429-.98.6a2.83,2.83,0,0,0,.084,3.185c1.179,1.363,4.563,3.307,6.347,3.047,1.455-.207,2.534-3.292,2.825-4.463h0Zm4.333,1.256c-.191,1.547-.276,4.739,1.072,5.558,1.883,1.141,4.463.789,5.275,0a3.614,3.614,0,0,0,1.179-2.741,1.113,1.113,0,0,0-.819-.812c-.643-.222-2.9-.9-6.714-2.006Z",
    transform: "translate(-255.024 -120.102)",
    fill: "#363334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M276.669,158.524a2.243,2.243,0,0,0-.222-.038.591.591,0,0,1-.115-.015h-.115a1.159,1.159,0,0,0-.23.015c-.077.015-.153.023-.23.038a2.746,2.746,0,0,0-.842.36,3.14,3.14,0,0,0-.674.6,2.344,2.344,0,0,0-.452.781c.245-.176.475-.352.7-.521s.452-.329.681-.475a6.556,6.556,0,0,1,.712-.406l.184-.092c.061-.031.13-.054.191-.084l.1-.046.1-.038c.069-.023.138-.054.207-.084Z",
    transform: "translate(-256.362 -123.25)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M285.978,160.41c.13.153.276.291.413.429s.268.283.4.421a6.891,6.891,0,0,1,.7.873,4.73,4.73,0,0,1,.528.965,3.955,3.955,0,0,1,.161.536,3.462,3.462,0,0,1,.077.574,1.555,1.555,0,0,0,.145-.59,2.123,2.123,0,0,0-.046-.62,3.038,3.038,0,0,0-.5-1.125,3.965,3.965,0,0,0-.842-.873,5.723,5.723,0,0,0-.505-.329c-.184-.092-.36-.176-.544-.253Z",
    transform: "translate(-259.217 -123.705)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M268.711,140.585a1.574,1.574,0,0,0-.2-.314A2.528,2.528,0,0,0,268.3,140c-.069-.084-.145-.168-.222-.245s-.153-.153-.222-.23c-.153-.145-.306-.283-.459-.429l-.245-.214c-.084-.077-.168-.153-.26-.245a.846.846,0,0,0-.023.39,1.785,1.785,0,0,0,.107.36,1.981,1.981,0,0,0,.429.6,2.409,2.409,0,0,0,.59.413c.107.046.222.092.337.13a1.48,1.48,0,0,0,.375.054Z",
    transform: "translate(-254.736 -118.602)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M267.659,142.187a1.725,1.725,0,0,0-.322-.184,2.8,2.8,0,0,0-.314-.138c-.1-.046-.207-.077-.306-.115s-.207-.061-.306-.092c-.207-.061-.406-.107-.612-.161l-.314-.077q-.161-.034-.345-.092a.927.927,0,0,0,.161.352,1.479,1.479,0,0,0,.268.268,1.882,1.882,0,0,0,.658.322,2.242,2.242,0,0,0,.712.084,2.892,2.892,0,0,0,.36-.046,1.918,1.918,0,0,0,.352-.123Z",
    transform: "translate(-254.334 -119.233)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M257.369,135.573a.312.312,0,0,1-.023-.436.323.323,0,0,1,.444-.038l9.256,7.9a.315.315,0,0,1-.406.482l-9.256-7.9-.008-.008Z",
    transform: "translate(-252.489 -117.755)",
    fill: "#363334"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M258.212,137.617a17.185,17.185,0,0,0,.949-2.634,17.658,17.658,0,0,1,1.164-2.994L256.03,134s2.588.674.98,5.78,1.2-2.159,1.2-2.159Z",
    transform: "translate(-251.814 -117.043)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M252.9,136.75c2.58-.36,3.055,2.381,2.5,4.716a9.265,9.265,0,0,0-1.279-3.078,4.649,4.649,0,0,0-1.738-1.363,1.654,1.654,0,0,1,.505-.276Z",
    transform: "translate(-250.961 -118.152)",
    fill: "#c76852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M251.51,129.117c.965-5.352,6.163-8.536,6.163-8.536s2.511,4.578,1.631,8.759-4.333,1.983-4.333,1.983a2.032,2.032,0,0,0-1.478-.077c-.574.314-1.975-2.128-1.975-2.128Z",
    transform: "translate(-250.754 -114.369)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M280.857,165.719c-.176.5-.352.988-.536,1.485s-.367.988-.551,1.478l-.283.735-.283.735-.574,1.47-.031.069-.084.069c-.138.115-.276.222-.421.329s-.283.214-.421.322c-.283.214-.567.421-.857.628A18.315,18.315,0,0,1,275,174.2c-.161.092-.329.176-.5.253q-.126.057-.276.115a2.536,2.536,0,0,1-.314.1c-.031,0-.061.015-.092.015a.527.527,0,0,0-.1.015h-.184a1.857,1.857,0,0,1-.3-.015c-.191-.015-.368-.031-.551-.054-.72-.084-1.416-.214-2.113-.36s-1.386-.306-2.075-.49c-.345-.092-.689-.184-1.026-.283s-.681-.207-1.018-.314-.674-.222-1.011-.345-.666-.245-1-.383c-.666-.268-1.325-.551-1.968-.865a20.691,20.691,0,0,1-1.891-1.041c-.306-.191-.6-.39-.9-.6s-.59-.436-.857-.658-.551-.444-.819-.666-.544-.459-.812-.689-.536-.475-.789-.727-.505-.513-.75-.789a7.713,7.713,0,0,1-1.21-1.837,8.8,8.8,0,0,1-.39-1.026,10.576,10.576,0,0,1-.253-1.057,18.028,18.028,0,0,1-.237-2.113c-.038-.7-.054-1.409-.054-2.113.107.7.214,1.393.337,2.082a20.09,20.09,0,0,0,.452,2.037c.046.168.1.329.153.49s.115.322.176.482a7.618,7.618,0,0,0,.429.911,6.75,6.75,0,0,0,.551.827,8.8,8.8,0,0,0,.666.75,18.6,18.6,0,0,0,1.531,1.355c.268.214.544.429.819.635l.835.628.421.306c.069.046.138.1.207.145l.107.069.107.069c.283.191.567.367.865.536.59.345,1.194.658,1.814.949.306.145.628.283.942.421s.635.268.957.39.643.245.972.36.651.23.98.337c.658.214,1.317.413,1.983.6s1.34.36,2.014.513c.337.077.674.153,1.011.222s.674.138,1.011.191c.168.031.337.054.5.069l.23.023h.13c.054-.015.122-.031.191-.054s.145-.046.214-.077c.145-.061.3-.13.444-.2.3-.145.6-.314.9-.482s.6-.345.888-.528.59-.367.88-.559l.873-.574-.107.138c.23-.475.459-.942.7-1.416l.352-.7.352-.7c.237-.467.475-.934.72-1.4s.482-.934.735-1.393Z",
    transform: "translate(-249.416 -123.203)",
    fill: "#c76852"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(570.994 332.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(-0.006 61.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(0 62.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M12.96,313.585c.071.667,13.981-.667,13.924-.391-.582,2.84-2.364,33.273-2.251,33.273H15.119C16.354,346.467,13.216,316.063,12.96,313.585Z",
    transform: "translate(-3.753 -215.006)",
    fill: "#c68660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M33.88,291.743c.057.561,11.723-.561,11.673-.327C45.07,293.8,43.572,319.3,43.665,319.3H35.691c1.037,0-1.6-25.484-1.811-27.564Z",
    transform: "translate(-9.819 -208.693)",
    fill: "#a66b47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M31.418,276.914c-3.848,4.047-11.19,2.336-20.095,3.167-9.43.88-11.24-2.947-11.056-12.873q.469-25.477.937-50.961c.149-7.938,1.235-16.523.17-24.39-.54-3.991-3.295-10.324.923-13.512,2.279-1.718,5.283-2.045,8.13-2.308q5.443-.5,10.892-1.008c15.806-1.463,13.008,13.207,13.008,24.192v66.774c0,5.631-1.044,8.947-2.911,10.914Z",
    transform: "translate(0.006 -174.927)",
    fill: "#475d82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(353.278 62.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M529.214,313.585c-.071.667-13.981-.667-13.924-.391.582,2.84,2.364,33.273,2.251,33.273h9.515C525.82,346.467,528.958,316.063,529.214,313.585Z",
    transform: "translate(-502.679 -215.006)",
    fill: "#c68660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M509.2,291.743c-.057.561-11.723-.561-11.673-.327.483,2.379,1.981,27.884,1.889,27.884h7.974c-1.037,0,1.6-25.484,1.811-27.564Z",
    transform: "translate(-497.53 -208.693)",
    fill: "#a66b47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M502.333,276.914c3.849,4.047,11.19,2.336,20.095,3.167,9.43.88,11.24-2.947,11.056-12.873q-.469-25.477-.937-50.961c-.149-7.938-1.235-16.523-.17-24.39.54-3.991,3.295-10.324-.923-13.512-2.279-1.718-5.283-2.045-8.13-2.308q-5.443-.5-10.892-1.008c-15.806-1.463-13.008,13.207-13.008,24.192v66.774c0,5.631,1.044,8.947,2.911,10.914Z",
    transform: "translate(-498.023 -174.927)",
    fill: "#475d82"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M371.343,255.827H39.25V233.233c0-10.786,2.627-20.727,3.217-31.512q.479-8.776.959-17.56c.135-2.535.305-5.162,1.505-7.4,3.252-6.05,36.319-2.293,43.8-2.293H337.927c10.154,0,24.674-3.493,30.014,7.86,1.953,4.147,2.322,8.84,2.663,13.413.88,11.808,3.43,24.781,1.974,36.518A189.826,189.826,0,0,0,371.343,255.827Z",
    transform: "translate(-11.376 -112.04)",
    fill: "#405475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M333.1,87.914c10.779,0,22.267-1.4,31.022,6.312a26.231,26.231,0,0,1,8.585,22.211c-.781,7.015-4.772,12.674-6.582,19.313-1.392,5.112-.249,9.564.249,14.734,1.058,10.914,3.529,26.35-5.354,34.786a18.337,18.337,0,0,1-2.258,1.825c-5.425,3.714-12.461,3.8-19.029,3.749l-90.07-.7c-27.6-.213-54.653,1.164-82.16,1.164H99.47c-13.8,0-27.337-2.215-41.169-3.33-2.989-.241-6.114-.525-8.641-2.144-6.227-4-2.819-23.4-3.579-30.383-.888-8.13-5.155-16.218-6.54-24.44-1.349-8.017-1.718-16.651,1.988-23.893C45.058,100.219,51.91,95.5,59.21,92.9c16.686-5.936,35.993-4.459,53.4-4.63,19.044-.185,38.094-.192,57.138-.554,14.258-.27,28.729,2.088,43.086,2.521a331.424,331.424,0,0,0,49.079-2.286c17.567-2.066,36.6-.05,54.3-.05s32.606-3.089,47.709,6.667a17.4,17.4,0,0,1,5.169,4.637,7.856,7.856,0,0,1,1.264,6.639L333.1,87.907Z",
    transform: "translate(-11.184 -87.018)",
    fill: "#627595"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 332.093,
    height: 13.179,
    transform: "translate(27.874 143.787)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M137.932,268.451H50.972c-2.94,0-6.362,1.257-8.08-1.974a11.675,11.675,0,0,1-.951-5.19c-.213-7.619-2.684-25.427,5.482-30.028,3.075-1.733,6.774-1.825,10.3-1.875,25.044-.355,50.094.007,75.131.675q19.246.511,38.478,1.2c11.886.412,24.263,2.265,35.8-.852,2.251-.611,5.02-.6,6.483,1.214,1.271,1.576.994,3.983-.1,5.695-1.7,2.641-4.85,4.374-5.986,7.392-1.541,4.118-1.065,10.2-1.512,14.592-.582,5.766-3.366,9.529-9.131,9.777-19.633.845-39.273-.625-58.963-.625Z",
    transform: "translate(-12.006 -128.256)",
    fill: "#627595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M435.8,231.186c.163.092.327.192.483.291,3.053,1.981,4.537,5.773,4.651,9.408.107,3.351-1.25,6.362-1.441,9.628-.163,2.741.305,5.638.2,8.435a16.691,16.691,0,0,1-1.25,6.88c-2.471,4.949-12.27,2.755-17.311,2.755h-126.5c-5.908,0-18.987,3.039-21.437-3.415-1.818-4.764-.923-10.793-.611-15.756.185-2.9,1.449-6.078,1.271-8.734s-2.13-4.466.71-7.022c2.187-1.974,5.34-2.35,8.272-2.6q17.084-1.459,34.246-1.342c11.013.078,22.757,2.435,33.664,1.647,21.451-1.555,43.15-1.243,64.771-1.3,3.976-.014,7.761.135,11.773-.178,2.9-.22,5.986-.114,8.506,1.3Z",
    transform: "translate(-78.887 -128.39)",
    fill: "#627595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M212.3,240.778a.791.791,0,0,1-.163-.028,4.568,4.568,0,0,1-3.167-2.6,8.788,8.788,0,0,0-1.122-1.6c-1.25-1.37-3.025-2.009-5.581-2.009h-.234l-64.338-.078c-17.9-.021-36.206-1.505-53.907-2.94Q77.4,231,71.066,230.511l-7.74-.589a.538.538,0,1,1,.078-1.072l7.74.589q6.348.49,12.724,1.015c17.68,1.434,35.964,2.918,53.822,2.94l64.579.078c2.876,0,4.9.753,6.369,2.365a10.389,10.389,0,0,1,1.257,1.782,3.572,3.572,0,0,0,2.222,2.024c.3-.305.888-.951,1.378-1.491,1.2-1.306,1.938-2.116,2.187-2.308a14.872,14.872,0,0,1,5.8-2.862c4.083-.937,9.756-.035,13.143.5,22.083,3.5,44.293,2.563,65.155,1.3,5.56-.334,11.155-.994,16.573-1.633,4.3-.5,8.741-1.03,13.172-1.392l33.1-2.72a.531.531,0,0,1,.582.49.545.545,0,0,1-.49.582l-33.1,2.72c-4.417.362-8.847.888-13.136,1.392-5.425.639-11.041,1.3-16.629,1.64-20.918,1.264-43.2,2.2-65.389-1.314-3.309-.525-8.861-1.4-12.731-.511a13.889,13.889,0,0,0-5.382,2.663c-.2.156-1.314,1.378-2.059,2.187-1.491,1.633-1.754,1.917-2,1.917Z",
    transform: "translate(-18.212 -128.141)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M270.732,273.439h-.05a.536.536,0,0,1-.483-.589l1.335-14.23c.362-3.877.738-7.882.071-11.759a.54.54,0,0,1,1.065-.185c.7,4.019.312,8.095-.057,12.043l-1.335,14.229a.544.544,0,0,1-.533.49Z",
    transform: "translate(-78.338 -133.181)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(70.118 22.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(2.769 1.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M112.882,130.616a2.926,2.926,0,0,0-1.768-5.311,3,3,0,0,0-3.43,2.535,2.9,2.9,0,0,0,.249,1.938C108.813,131.383,111.5,131.617,112.882,130.616Z",
    transform: "translate(-104.086 -122.908)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M117.4,124a.285.285,0,0,1-.156-.525l2.293-1.5a.288.288,0,0,1,.312.483l-2.293,1.5A.3.3,0,0,1,117.4,124Z",
    transform: "translate(-106.839 -121.935)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M120.451,134.766a.208.208,0,0,1-.114-.028l-3.245-1.647a.259.259,0,0,1,.234-.462l3.245,1.654a.259.259,0,0,1,.114.348.248.248,0,0,1-.227.142Z",
    transform: "translate(-106.792 -125.028)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M104.173,135.844a.28.28,0,0,1-.192-.071.29.29,0,0,1-.021-.4l1.541-1.7a.287.287,0,1,1,.426.383l-1.541,1.7A.28.28,0,0,1,104.173,135.844Z",
    transform: "translate(-103.004 -125.311)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M106.028,124.317a.233.233,0,0,1-.121-.028l-3.1-1.491a.287.287,0,1,1,.249-.518l3.1,1.491a.294.294,0,0,1,.135.383.29.29,0,0,1-.256.163Z",
    transform: "translate(-102.643 -122.027)",
    fill: "#475d82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(115.505 0.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M271.652,128.086a2.926,2.926,0,0,0-1.768-5.311,3,3,0,0,0-3.43,2.535,2.9,2.9,0,0,0,.249,1.938C267.583,128.853,270.267,129.087,271.652,128.086Z",
    transform: "translate(-262.856 -120.385)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M276.183,121.485a.285.285,0,0,1-.156-.525l2.293-1.5a.288.288,0,0,1,.312.483l-2.293,1.5A.3.3,0,0,1,276.183,121.485Z",
    transform: "translate(-265.612 -119.415)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M279.221,132.233a.208.208,0,0,1-.114-.028l-3.245-1.654a.259.259,0,1,1,.234-.462l3.245,1.654a.259.259,0,0,1,.114.348.248.248,0,0,1-.227.142Z",
    transform: "translate(-265.562 -122.502)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M262.943,133.324a.28.28,0,0,1-.192-.071.29.29,0,0,1-.021-.4l1.541-1.7a.287.287,0,0,1,.426.383l-1.534,1.7a.28.28,0,0,1-.213.092Z",
    transform: "translate(-261.774 -122.791)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M264.8,121.787a.233.233,0,0,1-.121-.028l-3.1-1.491a.287.287,0,1,1,.249-.518l3.1,1.491a.294.294,0,0,1,.135.383.29.29,0,0,1-.256.163Z",
    transform: "translate(-261.413 -119.504)",
    fill: "#475d82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(246.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M456.032,127.926a2.926,2.926,0,0,0-1.768-5.311,3,3,0,0,0-3.43,2.535,2.9,2.9,0,0,0,.248,1.938C451.963,128.693,454.647,128.927,456.032,127.926Z",
    transform: "translate(-447.236 -120.218)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M460.553,121.315a.285.285,0,0,1-.156-.525l2.294-1.5a.288.288,0,1,1,.312.483l-2.294,1.5A.3.3,0,0,1,460.553,121.315Z",
    transform: "translate(-449.989 -119.245)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M463.6,132.073a.208.208,0,0,1-.114-.028l-3.245-1.654a.259.259,0,1,1,.234-.462l3.245,1.654a.259.259,0,0,1,.114.348.248.248,0,0,1-.227.142Z",
    transform: "translate(-449.942 -122.335)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M447.323,133.153a.28.28,0,0,1-.192-.071.29.29,0,0,1-.021-.4l1.541-1.7a.283.283,0,0,1,.4-.021.29.29,0,0,1,.021.4l-1.534,1.7a.28.28,0,0,1-.213.092Z",
    transform: "translate(-446.154 -122.62)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M449.178,121.627a.234.234,0,0,1-.121-.028l-3.1-1.491a.287.287,0,0,1,.249-.518l3.1,1.491a.294.294,0,0,1,.135.383.29.29,0,0,1-.256.163Z",
    transform: "translate(-445.793 -119.337)",
    fill: "#475d82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(0 43.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M108.982,189.3a2.926,2.926,0,0,0-1.768-5.311,3,3,0,0,0-3.43,2.535,2.9,2.9,0,0,0,.249,1.938C104.913,190.063,107.6,190.3,108.982,189.3Z",
    transform: "translate(-100.186 -181.588)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M113.5,182.685a.285.285,0,0,1-.156-.525l2.293-1.5a.288.288,0,1,1,.312.483l-2.293,1.5a.312.312,0,0,1-.156.05Z",
    transform: "translate(-102.939 -180.615)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M116.548,193.443a.251.251,0,0,1-.121-.028l-3.245-1.654a.259.259,0,0,1,.234-.462l3.245,1.654a.259.259,0,0,1,.114.348A.248.248,0,0,1,116.548,193.443Z",
    transform: "translate(-102.889 -183.705)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M100.273,194.523a.28.28,0,0,1-.192-.071.29.29,0,0,1-.021-.4l1.541-1.7a.283.283,0,0,1,.4-.021.29.29,0,0,1,.021.4l-1.534,1.7a.28.28,0,0,1-.213.092Z",
    transform: "translate(-99.104 -183.99)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M102.128,183a.233.233,0,0,1-.121-.028l-3.1-1.491a.287.287,0,0,1,.249-.518l3.1,1.491a.294.294,0,0,1,.135.383.29.29,0,0,1-.256.163Z",
    transform: "translate(-98.743 -180.707)",
    fill: "#475d82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(112.735 41.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M267.752,186.766a2.926,2.926,0,0,0-1.768-5.311,3,3,0,0,0-3.43,2.535,2.9,2.9,0,0,0,.249,1.938C263.683,187.533,266.367,187.767,267.752,186.766Z",
    transform: "translate(-258.956 -179.065)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M272.283,180.165a.285.285,0,0,1-.156-.525l2.293-1.5a.288.288,0,0,1,.312.483l-2.293,1.5a.312.312,0,0,1-.156.05Z",
    transform: "translate(-261.712 -178.095)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M275.318,190.913a.251.251,0,0,1-.121-.028l-3.245-1.654a.259.259,0,1,1,.234-.462l3.245,1.654a.259.259,0,0,1,.114.348.248.248,0,0,1-.227.142Z",
    transform: "translate(-261.659 -181.182)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M259.043,192a.28.28,0,0,1-.192-.071.29.29,0,0,1-.021-.4l1.541-1.7a.283.283,0,0,1,.4-.021.29.29,0,0,1,.021.4l-1.541,1.7A.28.28,0,0,1,259.043,192Z",
    transform: "translate(-257.874 -181.47)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M260.9,180.467a.233.233,0,0,1-.121-.028l-3.1-1.491a.287.287,0,0,1,.249-.518l3.1,1.491a.294.294,0,0,1,.135.383.29.29,0,0,1-.256.163Z",
    transform: "translate(-257.513 -178.184)",
    fill: "#475d82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(243.655 41.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M452.132,186.606a2.926,2.926,0,0,0-1.768-5.311,3,3,0,0,0-3.43,2.535,2.9,2.9,0,0,0,.249,1.938C448.063,187.373,450.747,187.607,452.132,186.606Z",
    transform: "translate(-443.336 -178.898)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M456.653,179.995a.285.285,0,0,1-.156-.525l2.294-1.5a.288.288,0,1,1,.312.483l-2.294,1.5a.312.312,0,0,1-.156.05Z",
    transform: "translate(-446.089 -177.925)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M459.7,190.753a.208.208,0,0,1-.114-.028l-3.245-1.654a.259.259,0,0,1,.234-.462l3.245,1.654a.259.259,0,0,1,.114.348.248.248,0,0,1-.227.142Z",
    transform: "translate(-446.042 -181.015)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M443.423,191.833a.28.28,0,0,1-.192-.071.29.29,0,0,1-.021-.4l1.541-1.7a.283.283,0,0,1,.4-.021.29.29,0,0,1,.021.4l-1.541,1.7A.28.28,0,0,1,443.423,191.833Z",
    transform: "translate(-442.254 -181.3)",
    fill: "#475d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M445.278,180.3a.233.233,0,0,1-.121-.028l-3.1-1.491a.287.287,0,0,1,.249-.518l3.1,1.491a.294.294,0,0,1,.135.383.29.29,0,0,1-.256.163Z",
    transform: "translate(-441.893 -178.014)",
    fill: "#475d82"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(194.606 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M338.765,88.224c.93-7.044-6.185-5.219-9.288-1.328a23.42,23.42,0,0,0-3.586,7.9c-2.89,9.444-5.4,19-7.9,28.558-1.931,7.377-3.991,14.826-5.73,22.232-1.69,7.186-3.465,14.67-8.62,20.265a8.547,8.547,0,0,0-1.683,2.173,2.34,2.34,0,0,0,.277,2.577,2.264,2.264,0,0,0,2.258.4c4.069-1.271,8.9-5.822,11.95-8.741a57.3,57.3,0,0,0,15.451-27.11,132.191,132.191,0,0,0,2.734-15.714l4.133-31.228Z",
    transform: "translate(-282.084 -24.197)",
    fill: "#fdc46a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(56.071 233.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M367.007,335.5a11.851,11.851,0,0,1-4.069-.128,5.613,5.613,0,0,1-2.095-1.03,55.807,55.807,0,0,0-5.979,3.948,5,5,0,0,0-1.6,1.676,1.845,1.845,0,0,0,.263,2.159,2.749,2.749,0,0,0,2.244.327l17.19-2.492c2.187-.32,4.644-.8,5.837-2.656a5.818,5.818,0,0,0,.256-4.935A40.782,40.782,0,0,1,367,335.508Z",
    transform: "translate(-353.042 -329.988)",
    fill: "#231e1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M370.193,334.528a41,41,0,0,0,12.057-3.138,22.426,22.426,0,0,0-.873-2.343c0-.249-9.941,1.008-11.325,1.512a39.155,39.155,0,0,0-6.021,2.812,5.614,5.614,0,0,0,2.095,1.03A11.852,11.852,0,0,0,370.193,334.528Z",
    transform: "translate(-356.228 -329.015)",
    fill: "#fea188"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(27.626 225.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M329.006,325.512a14.154,14.154,0,0,1-8.989-1.718,55.319,55.319,0,0,0-5.247,3.451,4.772,4.772,0,0,0-1.562,1.612,1.779,1.779,0,0,0,.241,2.095,2.683,2.683,0,0,0,2.18.334q8.361-1.14,16.729-2.286c2.13-.291,4.516-.738,5.695-2.535a5.094,5.094,0,0,0,.5-3.934,34.564,34.564,0,0,1-9.543,2.975Z",
    transform: "translate(-312.98 -319.358)",
    fill: "#231e1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M331.879,324.217a34.4,34.4,0,0,0,9.543-2.975,17.207,17.207,0,0,0-1.044-3.146c0-.241-9.671.9-11.02,1.378a38.973,38.973,0,0,0-6.469,3.025,14.145,14.145,0,0,0,8.989,1.718Z",
    transform: "translate(-315.854 -318.063)",
    fill: "#fea188"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M315.347,279.86l.057.021c1.853.817,7.875.66,9.55-.5,1.818-1.257,1.6-4.906,1.512-6.824-.227-5.29-1.683-10.587-3.238-15.628A63.086,63.086,0,0,0,316.27,241.8c-2.989-4.729-6.845-8.13-9.089-13.285-3.9-8.961,9.99-12.256,15.941-16.218a138.017,138.017,0,0,0,23.957-20.237c2.017-2.137,4.083-4.651,4-7.59a4.226,4.226,0,0,0-.5-1.96c-2.407-4.3-12.831-1.576-16.537-2.066a38.532,38.532,0,0,0-22.615,3.635c-8.755,4.353-16.409,12.8-23.908,19.058-5.6,4.665-12.248,8.8-13.335,16.637-.746,5.368,2.4,10.431,5.411,14.94,2.634,3.941,5.354,7.853,7.8,11.9,2.393,3.976,5.815,7.427,8.869,10.977,0,1.512,4.992,5.8,6.064,7.044l6.817,7.924c1.676,1.946,3.827,6.192,6.206,7.285Z",
    transform: "translate(-274.074 -52.201)",
    fill: "#4c3932"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M362.494,291.21c1.747-.71,1.882-1.8,1.924-4.331.1-5.425-1.7-10.679-2.62-15.969-1.065-6.142-4.7-12.753-7.8-18.1a40.9,40.9,0,0,0-8.833-11.1c-2.783-2.35-6.156-3.721-8.94-6.071,4.431.32,10.189-1.6,14.35-2.549a130.9,130.9,0,0,0,15.657-4.6c9.039-3.288,17.766-6.149,18.177-17.212.178-4.772,2.9-10-3.046-12.731-4.012-1.839-11.439-2.592-15.706-2.464-8.031.241-17.432,2.2-25.242,4.225a67.771,67.771,0,0,0-24.255,11.524c-9.131,6.987-16.608,17.758-7.378,28.047,8.854,9.87,17.034,20.308,25.171,30.76,4.658,5.986,9.948,10.935,15.131,16.466,1.491,1.591,3.344,4.367,5.524,5.02,2.109.632,4.8-.05,6.866-.589a9.277,9.277,0,0,0,1.03-.334Z",
    transform: "translate(-282.914 -56.849)",
    fill: "#4c3932"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(44.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M382.389,81.61a2.31,2.31,0,0,0,.625-2.45,2.655,2.655,0,0,0-1.761-1.363c-.731-.213-1.512-.241-2.272-.391a7.046,7.046,0,0,1-5.048-3.685c-.469-1.108.128-4.133-1.555-4.452-1.044-.2-2.641.831-3.5,1.314-2.819,1.583-4.97,1.69-7.981,2.08a3.475,3.475,0,0,0-2.613,1.562c-1.037,1.818-.064,4.253-.98,6.177-.6,1.25-3.721,1.86-2.854,3.65a2.162,2.162,0,0,0,1.91,1.072c4,.121,8.45-.27,12.5-.533a45.656,45.656,0,0,0,6.561-.888c1.846-.4,4.935-.653,6.49-1.7a3.144,3.144,0,0,0,.476-.4Z",
    transform: "translate(-341.892 -20.076)",
    fill: "#fe9477"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M360.188,19.728c8.925-.959,15.848,6.923,18.525,14.641,3.075,8.861.376,19.356-8.251,24.028-5.318,2.883-15.422,6.376-20.343,1.115-2.08-2.222-2.577-5.46-2.876-8.492-.618-6.4-2.3-15.834.625-21.763,2.407-4.871,6.738-8.932,12.319-9.536Z",
    transform: "translate(-339.544 -5.696)",
    fill: "#fea188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M344.76,40.694a5.493,5.493,0,0,1-.312,1.8,2,2,0,0,1-.589.909c-2.279-1.179-4.466-4.686-5.624-6.973a10.91,10.91,0,0,1-.838-8.712c1.321-3.415,4.722-5.489,7.9-7.314,2.812-1.612,5.6-3.28,8.443-4.843,2.684-1.477,5.4-1.5,8.457-1.385a1.711,1.711,0,0,1,1.342.469c.447.575.035,1.4-.391,1.988a74.475,74.475,0,0,1-13.193,14.414c-2.485,2-4.835,4.594-5.141,7.768-.057.618-.043,1.257-.064,1.882Z",
    transform: "translate(-336.827 -4.097)",
    fill: "#f6dab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M382.771,18.9c-3.572-3.543-7.74-3.65-12.547-4.289-2.9-.383-6.213-.085-8.194,2.073a7.084,7.084,0,0,0-1.534,5.886,13.515,13.515,0,0,0,2.585,5.68,24.9,24.9,0,0,0,12.6,9.188c4.835,1.47,9.827,3.295,14.989,3.153-1.022-7.782-2.336-16.168-7.9-21.7Z",
    transform: "translate(-343.659 -4.195)",
    fill: "#f6dab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M398.543,33.977c.419,3.92.561,7.505-1.143,11.2a10.971,10.971,0,0,1-4.85,4.651c-.817.462-4.921,3.777-5.822,2.769-.3-.334.114-.824.149-1.157.135-1.328.76-2.656.888-4.019a28.683,28.683,0,0,0-.547-5.865c-.284-2.372-1.221-4.324-1.754-6.653-.483-2.1-.525-4.331-1.264-6.369-.866-2.393-2.94-3.777-2.23-6.469.781-2.94,2.833-4.317,5.546-2.734,6.327,3.692,9.508,7.4,11.013,14.663Z",
    transform: "translate(-349.874 -5.411)",
    fill: "#f6dab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M387.126,3.9C384.875.419,379.911-.49,376.07.227a8.15,8.15,0,0,0-5.425,3.437,5.751,5.751,0,0,0-.05,6.227,7.315,7.315,0,0,0,4.076,2.585c5.112,1.47,17.368-.973,12.454-8.577Z",
    transform: "translate(-346.359 0.001)",
    fill: "#f6dab3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(34.814 31.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M394.053,50.816c-.568,2.911-2.833,4.914-5.056,4.48s-3.579-3.146-3.011-6.05,2.833-4.914,5.056-4.48S394.621,47.912,394.053,50.816Z",
    transform: "translate(-385.857 -44.707)",
    fill: "#fea188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M390.436,53.942a1.359,1.359,0,0,1-.895-.334.412.412,0,1,1,.547-.618.565.565,0,0,0,.682.014.55.55,0,0,0,.114-.667c-.163-.277-.547-.376-.987-.49a2.662,2.662,0,0,1-1.356-.653,1.529,1.529,0,0,1-.334-1.463,2.2,2.2,0,0,1,1.42-1.512,4.734,4.734,0,0,1,3.138.447.411.411,0,0,1-.3.767,4.12,4.12,0,0,0-2.6-.426,1.393,1.393,0,0,0-.873.937.711.711,0,0,0,.135.689,2.02,2.02,0,0,0,.966.419,2.174,2.174,0,0,1,1.484.866,1.371,1.371,0,0,1-.3,1.725,1.34,1.34,0,0,1-.852.3Z",
    transform: "translate(-386.521 -45.689)",
    fill: "#f68267"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M372.514,47.5c-.462-1.662-3.735-2.187-5.063-2.379a2.243,2.243,0,0,0-1.818.462c-.951.873-.469,1.953.675,2l5.588.234c.518.021.667-.114.611-.312Z",
    transform: "translate(-345.032 -13.073)",
    fill: "#f6dab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M353.5,48.759,350,49.227c-.533.071-1.193.092-1.491-.362a.951.951,0,0,1,.128-1.086,2.466,2.466,0,0,1,.959-.646c1.1-.483,3.728-1.527,4.914-.9,1.548.817.312,2.35-1.015,2.528Z",
    transform: "translate(-340.18 -13.347)",
    fill: "#f6dab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M368.993,54.928a1.188,1.188,0,1,1,1.385-.951A1.186,1.186,0,0,1,368.993,54.928Z",
    transform: "translate(-345.871 -15.242)",
    fill: "#422e26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M352.727,53.879a1.218,1.218,0,1,1,1.342,1.079A1.219,1.219,0,0,1,352.727,53.879Z",
    transform: "translate(-341.435 -15.23)",
    fill: "#422e26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M359.06,63.765a1.317,1.317,0,0,1-1.115-.54,1.783,1.783,0,0,1-.114-1.42l1.079-4.786a.422.422,0,0,1,.49-.312.413.413,0,0,1,.312.49l-1.079,4.786a1.174,1.174,0,0,0-.007.781.55.55,0,0,0,.49.178,2.38,2.38,0,0,0,.781-.249.408.408,0,1,1,.334.746,3.236,3.236,0,0,1-1.058.32h-.107Z",
    transform: "translate(-342.889 -16.439)",
    fill: "#f68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M368.122,68.019a.2.2,0,0,1-.2-.163,5.407,5.407,0,0,0-2.208-3.387.2.2,0,0,1,.234-.334,5.817,5.817,0,0,1,2.379,3.65.2.2,0,0,1-.163.241h-.043Z",
    transform: "translate(-345.177 -18.584)",
    fill: "#f68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M353.4,68.487h0a.206.206,0,0,1-.206-.206,4.058,4.058,0,0,1,1.441-3.06.207.207,0,1,1,.263.32,3.659,3.659,0,0,0-1.292,2.748.206.206,0,0,1-.206.206Z",
    transform: "translate(-341.571 -18.896)",
    fill: "#f68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M376.66,56.572a.211.211,0,0,1-.178-.1,1.959,1.959,0,0,0-1.846-.916.2.2,0,0,1-.227-.185.207.207,0,0,1,.185-.227,2.382,2.382,0,0,1,2.244,1.115.208.208,0,0,1-.071.284.2.2,0,0,1-.107.028Z",
    transform: "translate(-347.723 -15.985)",
    fill: "#f68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M376.247,53.782h-.014l-1.541-.121a.206.206,0,0,1,.028-.412l1.541.121a.206.206,0,0,1-.014.412Z",
    transform: "translate(-347.75 -15.439)",
    fill: "#f68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M347.815,56.814a.229.229,0,0,1-.128-.043.2.2,0,0,1-.035-.291,3.134,3.134,0,0,1,2.443-1.2h.085a.2.2,0,0,1,.2.213.191.191,0,0,1-.213.2,2.7,2.7,0,0,0-2.194,1.037.212.212,0,0,1-.163.078Z",
    transform: "translate(-339.952 -16.027)",
    fill: "#f68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M348.365,54.925a.216.216,0,0,1-.192-.128.2.2,0,0,1,.107-.27l1.321-.554a.205.205,0,1,1,.163.376l-1.321.554a.53.53,0,0,1-.078.014Z",
    transform: "translate(-340.112 -15.644)",
    fill: "#f68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M355.645,43.027a.207.207,0,0,1-.028-.412l7.008-.8a.2.2,0,0,1,.227.178.207.207,0,0,1-.178.227l-7.008.8h-.021Z",
    transform: "translate(-342.223 -12.125)",
    fill: "#f68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M356.546,39.849a.206.206,0,0,1-.014-.412l5.744-.447a.2.2,0,0,1,.22.192.207.207,0,0,1-.192.22l-5.744.447Z",
    transform: "translate(-342.484 -11.304)",
    fill: "#f68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M345.464,42.293a.421.421,0,0,1-.341-.178,3.2,3.2,0,0,1-.05-3.217,8.109,8.109,0,0,1,2.017-2.315c2.166-1.889,4.438-3.706,6.76-5.4a.412.412,0,1,1,.483.667c-2.3,1.676-4.559,3.479-6.7,5.354a7.5,7.5,0,0,0-1.832,2.066,2.352,2.352,0,0,0-.007,2.372.413.413,0,0,1-.107.575.4.4,0,0,1-.234.071Z",
    transform: "translate(-339.1 -9.019)",
    fill: "#e8c89e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M377.6,37.99a.469.469,0,0,1-.192-.043,27.616,27.616,0,0,1-10.367-9.337.411.411,0,0,1,.689-.447,26.776,26.776,0,0,0,10.054,9.06.413.413,0,0,1,.177.554.408.408,0,0,1-.362.22Z",
    transform: "translate(-345.567 -8.11)",
    fill: "#e8c89e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M385.543,32.907H385.5a16.015,16.015,0,0,1-12.22-8.372.407.407,0,0,1,.177-.554.413.413,0,0,1,.554.178,15.154,15.154,0,0,0,11.574,7.931.413.413,0,0,1-.043.824Z",
    transform: "translate(-347.382 -6.94)",
    fill: "#e8c89e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M400.933,47.736a.385.385,0,0,1-.107-.014.415.415,0,0,1-.3-.483l.27-1.285a.4.4,0,0,1,.114-.206A12.774,12.774,0,0,0,398.6,35.722a.41.41,0,0,1,.653-.5,13.559,13.559,0,0,1,2.066,12.22.418.418,0,0,1-.391.284Z",
    transform: "translate(-354.713 -10.166)",
    fill: "#e8c89e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M382.032,11.214a8.127,8.127,0,0,1-6.994-3.983.412.412,0,0,1,.717-.4A7.234,7.234,0,0,0,384,10.092a4.586,4.586,0,0,0,2.251-1.434,2.618,2.618,0,0,0,.525-2.386,2.951,2.951,0,0,0-1.825-1.718,9.521,9.521,0,0,0-2.783-.462,7.631,7.631,0,0,0-2.883.192,2.371,2.371,0,0,0-1.676,1.8c-.128,1.207,1.115,2.2,2.215,2.684a4.564,4.564,0,0,0,2.265.476,2.062,2.062,0,0,0,1.7-1.093,1.535,1.535,0,0,0-.064-1.292,1.566,1.566,0,0,0-.987-.838,1.543,1.543,0,0,0-1.257.32,1.626,1.626,0,0,0-.575.824l1.385.383a.409.409,0,1,1-.22.788l-1.733-.483a.4.4,0,0,1-.3-.4,2.457,2.457,0,0,1,2.89-2.237,2.32,2.32,0,0,1,1.541,1.271,2.322,2.322,0,0,1,.078,2,2.9,2.9,0,0,1-2.372,1.576,5.243,5.243,0,0,1-2.684-.54c-1.42-.625-2.869-1.882-2.7-3.522a3.121,3.121,0,0,1,2.23-2.492,8.432,8.432,0,0,1,3.2-.234,10.05,10.05,0,0,1,3.025.511,3.75,3.75,0,0,1,2.315,2.237,3.462,3.462,0,0,1-.667,3.153,5.4,5.4,0,0,1-2.649,1.7,7.352,7.352,0,0,1-2.215.334Z",
    transform: "translate(-347.89 -0.931)",
    fill: "#e8c89e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M341.522,35.917h-.014a.412.412,0,0,1-.4-.426c.071-2.265,1.875-4,3.564-5.453l7.832-6.738a.413.413,0,1,1,.54.625l-7.832,6.738c-1.626,1.4-3.217,2.925-3.28,4.857a.409.409,0,0,1-.412.4Z",
    transform: "translate(-338.068 -6.726)",
    fill: "#e8c89e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M361.5,71.347a5.691,5.691,0,0,0,1.207-.888c.128-.128.88-.788.462-.809a2.306,2.306,0,0,0-.54.213,10.828,10.828,0,0,1-1.065.32,10.892,10.892,0,0,1-4.3.149,8.4,8.4,0,0,1-1.022-.291c-.163-.05-.54-.234-.689-.085-.178.178.312.746.433.88A3.342,3.342,0,0,0,357,71.6a5.042,5.042,0,0,0,4.069-.036c.149-.064.3-.135.44-.213Z",
    transform: "translate(-342.245 -20.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M378.7,19.811a.318.318,0,0,1-.142-.028,20.386,20.386,0,0,0-11.723-.738.413.413,0,0,1-.5-.305.419.419,0,0,1,.305-.5,21.157,21.157,0,0,1,12.2.767.415.415,0,0,1,.241.533.42.42,0,0,1-.383.27Z",
    transform: "translate(-345.38 -5.126)",
    fill: "#e8c89e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(6.889 33.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M350.62,56.918a4.007,4.007,0,0,1-2.663-.987,4.154,4.154,0,0,1-1.094-4.729,4.425,4.425,0,0,1,4.424-2.3,3.852,3.852,0,0,1,2.876,6.284,4.142,4.142,0,0,1-.859.831,4.592,4.592,0,0,1-2.684.895Zm.22-7.221a3.594,3.594,0,0,0-3.245,1.86,3.317,3.317,0,0,0,.895,3.77,3.466,3.466,0,0,0,4.338.043,3.41,3.41,0,0,0,.689-.667h0A3.186,3.186,0,0,0,350.84,49.7Z",
    transform: "translate(-346.529 -48.054)",
    fill: "#606879"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M367.508,56.88a3.577,3.577,0,0,1-2.783-1.086,3.961,3.961,0,0,1-.525-4.338c1.406-2.705,4.438-2.478,6.6-1.463a2.917,2.917,0,0,1,1.747,2.727,3.988,3.988,0,0,1-2.279,3.536,6.647,6.647,0,0,1-2.237.6h0c-.178.014-.355.021-.525.021Zm.376-6.774a3.128,3.128,0,0,0-2.542,5.155,3.162,3.162,0,0,0,2.627.788h0a5.977,5.977,0,0,0,1.967-.525,3.21,3.21,0,0,0,1.818-2.8,2.115,2.115,0,0,0-1.278-2,6.264,6.264,0,0,0-2.585-.625Z",
    transform: "translate(-351.531 -48.173)",
    fill: "#606879"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M360.451,53.2a8.025,8.025,0,0,1-3.209-.809.4.4,0,1,1,.327-.738c1.725.753,3.138,1.072,4.857.3a.4.4,0,1,1,.327.738,5.565,5.565,0,0,1-2.3.518Z",
    transform: "translate(-349.565 -48.849)",
    fill: "#606879"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M375.574,51.681a.415.415,0,0,1-.376-.249.4.4,0,0,1,.22-.525l7.626-3.16a.4.4,0,1,1,.305.746l-7.626,3.16a.382.382,0,0,1-.156.028Z",
    transform: "translate(-354.832 -47.717)",
    fill: "#606879"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M396.557,150.267a60.35,60.35,0,0,0,1.988-14.364,140.862,140.862,0,0,0-1.662-28.615c-1.079-6.675-4.033-13.718-9.131-18.433-3.33-3.082-14.869-8.8-19.278-7.314-1.47.5-2.677,2.251-4.069,3.075a22.464,22.464,0,0,1-5.361,2.45c-3.579,1-7.953,1.164-11.034-1.243-1.541-1.2-2.137-3.309-4.346-3.6a5.808,5.808,0,0,0-4.026,1.186c-4.409,3.138-3.792,9.359-3.99,14.258-.206,5.148-.44,10.615-3.408,15.032-1.853,2.762-4.757,5.134-5.056,8.45-.256,2.847,1.512,5.432,2.329,8.173a16.807,16.807,0,0,1-.76,10.573,111.44,111.44,0,0,1-5.375,11.034c-1.917,3.742-5.723,6.462-6.461,10.843a4.518,4.518,0,0,0,1.3,3.919c5.105,4.871,14.08,3.756,20.528,4.509,8.364.973,16.5-1.669,25.186.533,4.111,1.044,8.088,2.677,12.277,3.337,3.813.6,11.609.291,14.386-2.911,1.86-2.151,2.137-6.994,2.883-9.692,1.044-3.735,2.166-7.441,3.089-11.2Z",
    transform: "translate(-286.479 -23.571)",
    fill: "#fdc46a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M320.451,161.442a.512.512,0,0,1-.284-.085.533.533,0,0,1-.17-.738l4.509-7.207c3.4-5.432,6.4-10.772,5.872-16.381a28.763,28.763,0,0,0-.973-4.594,19.315,19.315,0,0,1-1-6.973c.334-3.295,2.222-6.085,4.047-8.783.312-.462.618-.916.923-1.37,2.89-4.4,2.954-9.217,3.018-14.322.014-1.335.036-2.72.107-4.1a.54.54,0,1,1,1.079.057c-.071,1.356-.085,2.734-.107,4.062-.064,5.262-.128,10.232-3.2,14.9-.305.462-.618.923-.93,1.385-1.754,2.592-3.564,5.269-3.87,8.293a18.336,18.336,0,0,0,.966,6.589,29,29,0,0,1,1.008,4.779c.611,6.44-3.231,12.575-6.035,17.056l-4.509,7.207a.535.535,0,0,1-.454.256Z",
    transform: "translate(-287.365 -27.944)",
    fill: "#f39558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M340.252,221.508c-.561.241-1.044.575-1.6.824a2.59,2.59,0,0,0-.88.533.782.782,0,0,0-.135.951c.256.355.788.3,1.221.2.76-.17,1.52-.348,2.279-.518.476-.106,1.072-.17,1.349.227.838,1.179-5.723,4.26-6.6,4.814a3.052,3.052,0,0,0-1.051.916,1.063,1.063,0,0,0,.071,1.3c.767.717,2.641-.774,3.4-1.172.476-.249,2.364-1.555,2.151-.178-.192,1.264-5.191,3.479-4.012,4.793.462.511,1.207.114,1.7-.142a13.961,13.961,0,0,0,3.472-2.854,1.593,1.593,0,0,1,.653-.5c1.228-.348.114,1.186-.128,1.449-.667.717-1.583,1.164-2.187,1.946-.263.334-.44.852-.135,1.15a.868.868,0,0,0,.838.121,5.233,5.233,0,0,0,2.606-2.123,5.059,5.059,0,0,1,1.832-1.583c.383-.213-.028.916-.043.951a14.848,14.848,0,0,1-.994,1.953,1.2,1.2,0,0,0-.192.717c.121.738,1.427.071,1.711-.241A61.461,61.461,0,0,0,351.1,228.2a12.9,12.9,0,0,0,1.64-3.465,9.71,9.71,0,0,1,4.374-4.992c-.561.249-2.542-1.108-3.018-1.413-.788-.511-2.009-1.243-2.272-2.194-1.924,1.235-3.444,2.776-5.645,3.55-1.946.675-4.062,1.015-5.922,1.825Z",
    transform: "translate(-291.637 -62.668)",
    fill: "#fea188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M380.645,134.343c-.476,5.084-.966,10.253-2.854,15-2.13,5.333-5.922,9.856-10.175,13.718-2.4,2.18-5.276,3.934-7.591,6.177a50.634,50.634,0,0,0-4.665,4.9c-1.307,1.683-.682,3.309-1.079,5.354-.149.781-1.115,2.009-.93,2.727.241.9,3.692,2.755,4.417,3.38,1.015.88,2.514,2.379,3.941,2.492,1.257.1,2.514-.809,3.891-.93,5.12-.447,7.974-2.947,11.56-6.533,6.554-6.476,13.335-13.441,17.389-21.8a84.492,84.492,0,0,0,7.967-27.607,93.529,93.529,0,0,0-.6-24.106c-.49-3.224-.675-5.9-3.181-8.329a9.263,9.263,0,0,0-7.718-2.6c-6.8.951-7.4,6.341-7.938,12.014-.824,8.712-1.619,17.432-2.435,26.144Z",
    transform: "translate(-297.053 -27.863)",
    fill: "#fdc46a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M355.972,176.2a.51.51,0,0,1-.334-.121.531.531,0,0,1-.085-.746,49.809,49.809,0,0,1,7.477-7.065,48.476,48.476,0,0,0,7.775-7.413,51.39,51.39,0,0,0,9.323-18.944,101.236,101.236,0,0,0,2.677-21.692,45.13,45.13,0,0,0-.27-5.418c-.4-4.594-.81-9.344,1.825-13.172a.531.531,0,1,1,.873.6c-2.421,3.508-2.024,8.066-1.64,12.476a47.6,47.6,0,0,1,.27,5.546,102.915,102.915,0,0,1-2.705,21.919,52.492,52.492,0,0,1-9.522,19.342A49.6,49.6,0,0,1,363.7,169.1a48.469,48.469,0,0,0-7.328,6.9.546.546,0,0,1-.412.2Z",
    transform: "translate(-297.665 -29.398)",
    fill: "#f39558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M393.5,179.152a.493.493,0,0,1-.355-.142.519.519,0,0,1-.028-.738c10.637-11.538,18.5-27.955,21.039-43.917a64.084,64.084,0,0,0-1.69-27.607.524.524,0,1,1,1.008-.284,65.176,65.176,0,0,1,1.711,28.061c-2.563,16.161-10.53,32.783-21.3,44.464a.518.518,0,0,1-.383.17Z",
    transform: "translate(-308.548 -30.757)",
    fill: "#f39558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M403.091,93.012a.542.542,0,0,1-.362-.142,39.356,39.356,0,0,0-13.115-7.917.539.539,0,1,1,.362-1.015,40.393,40.393,0,0,1,13.477,8.13.538.538,0,0,1,.035.76.545.545,0,0,1-.4.178Z",
    transform: "translate(-307.47 -24.328)",
    fill: "#f39558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M331.059,272.672a.541.541,0,0,1-.4-.185l-16.424-18.674c-5.624-6.4-10.679-12.774-10.772-20.492-.057-5.311,2.5-10.921,7.015-15.394,4.2-4.161,9.607-7,14.336-9.238a.538.538,0,0,1,.462.973c-4.644,2.194-9.948,4.985-14.038,9.032-4.31,4.267-6.753,9.6-6.7,14.62.085,7.349,5.013,13.555,10.5,19.8l16.424,18.674a.533.533,0,0,1-.05.76.517.517,0,0,1-.355.135Z",
    transform: "translate(-282.594 -60.492)",
    fill: "#422e26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(79.259 0.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(3.685 131.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(23.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(70.387 105.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M268.5,343.26c-2.329-1.5-4.828-3.025-5.283-5.226-.731-3.5-1.342-4.125-4.963-4.459-.667-.064-7.342.142-7.271.582.426,2.67-.426,4.679-1.115,7.164-.518,1.882-.54,3.792,1.555,4.658,1.889.781,4.069.5,6,1.122,2.549.809,5.105,1.576,7.661,2.372,1.9.589,7.079,2.194,7.633-1.037.369-2.144-1.839-3.643-4.225-5.176Z",
    transform: "translate(-249.327 -333.564)",
    fill: "#fea188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M277.886,353.22c-1.37-1.5-3.2-1.86-4.864-2.847-.66-.4-1.363-.838-2.066-1.3a8.939,8.939,0,0,0,.4,1c.341.689.916,1,.937,1.832.071,2.244-2.578,2.166-4.09,1.818a77.311,77.311,0,0,1-18.831-7.044,12.616,12.616,0,0,0-.043,3.607,5.431,5.431,0,0,0,2.194,3.721c1.9,1.228,4.381.675,6.618.937a17.548,17.548,0,0,1,5.659,2.045c2.705,1.342,5.638,3.288,8.691,4.36a12.24,12.24,0,0,0,4.615.781c1.285-.057,2.741-.483,3.273-1.662.845-1.867-1.264-5.872-2.507-7.235Z",
    transform: "translate(-249.225 -337.367)",
    fill: "#a37b4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(20.51 12.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M278.4,361.117a.306.306,0,0,1-.17-.057.293.293,0,0,1-.121-.227,3.9,3.9,0,0,1,2.67-3.635.272.272,0,0,1,.284-.227.283.283,0,0,1,.277.234.273.273,0,0,1,.064.128.283.283,0,0,1-.085.27,4.258,4.258,0,0,1-2.84,3.493.357.357,0,0,1-.085.014Zm2.315-3.288a3.346,3.346,0,0,0-2,2.57A3.7,3.7,0,0,0,280.716,357.829Z",
    transform: "translate(-278.11 -352.485)",
    fill: "#8c6334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M282.764,355.11a.305.305,0,0,1-.2-.078.279.279,0,0,1-.085-.22,7.149,7.149,0,0,1,1-3.011h0a2.357,2.357,0,0,1,.944-1.015,1.154,1.154,0,0,1,1.477.327c.227.355.312.973-.568,1.867-.142.142-.3.334-.476.533-.618.717-1.314,1.527-2.073,1.6h-.028Zm1.207-3.025a7.126,7.126,0,0,0-.88,2.336,5.822,5.822,0,0,0,1.335-1.285c.178-.213.348-.4.5-.561.277-.284.717-.817.5-1.165a.6.6,0,0,0-.746-.121,1.85,1.85,0,0,0-.7.788h0Z",
    transform: "translate(-279.377 -350.653)",
    fill: "#8c6334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M284.026,362.319a.256.256,0,0,1-.156-.05,3.9,3.9,0,0,1-1.363-2.712l-.518-2.656a.285.285,0,1,1,.561-.107l.518,2.656a3.474,3.474,0,0,0,1.122,2.343.285.285,0,0,1-.156.525Z",
    transform: "translate(-279.233 -352.367)",
    fill: "#8c6334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M286.472,359.267a3.094,3.094,0,0,1-2.492-1.243c-.078-.114-.149-.227-.227-.341a3.32,3.32,0,0,0-.327-.462.728.728,0,0,0-.618-.277.284.284,0,1,1-.128-.554,1.246,1.246,0,0,1,1.164.447,4.057,4.057,0,0,1,.391.547c.064.106.128.213.2.312a2.546,2.546,0,0,0,2.94.831.288.288,0,0,1,.22.533,2.96,2.96,0,0,1-1.129.22Z",
    transform: "translate(-279.371 -352.31)",
    fill: "#8c6334"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M217.987,278.681c-.582-2.329-1.214-4.651-1.967-6.93a25.643,25.643,0,0,1-.852-11.148c.831-8.528,3.678-17.027,2.166-25.647-.753-4.317-.9-8.656-1.562-12.951-.873-5.688-5.091-7.306-10.267-8.258q-17.766-3.259-35.531-6.525c-4.161-.767-8.407-1.555-12.135-3.55s-6.951-5.425-7.59-9.607c-1.051-6.8,3.5-9.323,9-8.329,9.2,1.654,18.4-.028,27.55,1.825l22.3,4.516c6.71,1.356,12.05,3.834,18.454,6.156,2.372.9,4.892,1.91,6.348,3.991a12.746,12.746,0,0,1,1.733,5.8,289.8,289.8,0,0,1,2.769,37.7c0,9.948.121,20,.227,29.908q.1,9.362.192,18.731l-13.69.362c-2.457.064-3.316-.064-3.99-2.308-.71-2.35-1.1-4.857-1.647-7.257-.49-2.159-.98-4.324-1.512-6.476Z",
    transform: "translate(-150.096 -185.526)",
    fill: "#913e3e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(0 2.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(52.871 105.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M214.743,361.378a5.7,5.7,0,0,0,5.5-2.166c-.312.476-6.3-4.672-6.824-5.176-1.782-1.7-4.324-2.372-4.807-5.247a12.11,12.11,0,0,1,.916-5.851,3.8,3.8,0,0,0,.312-2.137c-.412-1.64-3.5-.738-4.779-.895a32.747,32.747,0,0,1-7.264-1.747c-.462-.17-3.714,8.343-3.941,8.947a2.724,2.724,0,0,0,1.74,4.31c3.394,1.456,7.583,2.592,10.466,4.9,2.592,2.073,5.212,4.566,8.684,5.056Z",
    transform: "translate(-191.891 -338.156)",
    fill: "#fea188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M224.311,366.472a14.846,14.846,0,0,0-3.082-2.386c-.533-.341-1.065-.675-1.6-1.008a5.745,5.745,0,0,1-5.5,2.166c-2.407-.348-4.5-1.782-6.49-3.181q-7.519-5.283-15.046-10.573c-.071.149-.142.3-.213.44a9.557,9.557,0,0,0-1.079,3.082,6.447,6.447,0,0,0,4.14,6.277c1.491.447,3.1.391,4.566.909,2.585.909,4.225,3.394,5.872,5.432,1.988,2.45,3.87,3.99,7.122,4.608a20.16,20.16,0,0,0,8.677-.6l.575-.149c1.072-.284,3.1-.447,3.486-1.534s-.767-2.755-1.427-3.479Z",
    transform: "translate(-191.277 -342.022)",
    fill: "#a37b4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(24.257 19.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M225.724,374.457a.266.266,0,0,1-.213-.1.271.271,0,0,1-.064-.249,3.9,3.9,0,0,1,3.415-2.947.283.283,0,0,1,.54.135.323.323,0,0,1,.036.142.279.279,0,0,1-.149.249,4.251,4.251,0,0,1-3.55,2.769h-.021Zm2.925-2.691a3.347,3.347,0,0,0-2.528,2.059A3.7,3.7,0,0,0,228.649,371.766Z",
    transform: "translate(-225.439 -367.196)",
    fill: "#8c6334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M231.414,369.539a.608.608,0,0,1-.163-.014.276.276,0,0,1-.2-.128.3.3,0,0,1-.036-.234,7.083,7.083,0,0,1,1.647-2.705h0a2.417,2.417,0,0,1,1.15-.781,1.172,1.172,0,0,1,1.37.646c.142.4.085,1.015-.973,1.7-.17.107-.369.256-.575.412a4.421,4.421,0,0,1-2.215,1.108Zm1.669-2.691a6.994,6.994,0,0,0-1.385,2.073,5.94,5.94,0,0,0,1.591-.951c.22-.163.426-.32.611-.433.27-.17.888-.618.746-1.022a.6.6,0,0,0-.7-.284,1.942,1.942,0,0,0-.866.611h0Z",
    transform: "translate(-227.053 -365.644)",
    fill: "#8c6334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M231.206,376.644a.284.284,0,0,1-.206-.085,3.9,3.9,0,0,1-.724-2.947l.085-2.705a.289.289,0,0,1,.291-.277.28.28,0,0,1,.277.291l-.085,2.705a3.471,3.471,0,0,0,.568,2.535.289.289,0,0,1-.007.4.305.305,0,0,1-.2.078Z",
    transform: "translate(-226.839 -367.09)",
    fill: "#8c6334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M234.925,374.3a3.126,3.126,0,0,1-2.826-1.846c-.057-.128-.1-.256-.142-.383a3.236,3.236,0,0,0-.213-.525.718.718,0,0,0-.54-.4.284.284,0,0,1,0-.568h0a1.243,1.243,0,0,1,1.037.7,3.793,3.793,0,0,1,.256.618c.043.114.078.234.128.348a2.536,2.536,0,0,0,2.677,1.463.284.284,0,1,1,.092.561,2.7,2.7,0,0,1-.476.043Z",
    transform: "translate(-227.028 -367.072)",
    fill: "#8c6334"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M179.844,256.583c.88-5.844,1.5-11.879,3.124-17.545.987-3.437,3.891-9.067,1.967-12.66-1.612-3-6.163-1.583-8.883-1.555-10.644.114-21.366.568-31.91-1.228-9.614-1.633-18.277-1.591-23.02-11.68-2.62-5.574-8.414-20.279.391-21.742,5.588-.93,12.738-.327,18.312.71,18.376,3.437,36.6,8.471,54.823,12.682,6.6,1.527,14.443,3.522,18.667,9.3,5.7,7.8-.178,19.079-2.443,27.358q-5.272,19.214-11.148,38.258-1.385,4.473-2.8,8.947-1.6,5.027-3.231,10.047c0,2.478-2.506,6.98-4.914,7.172-1.889.149-4.509-.937-6.376-1.328L176.045,302c-1.349-.284-2.933-.76-3.337-2.08a3.929,3.929,0,0,1,.185-2.187c1.115-3.941,3.039-8.308,3.465-12.376.234-2.237.107-4.488.4-6.76q1.438-11.024,3.089-22.019Z",
    transform: "translate(-116.817 -189.712)",
    fill: "#913e3e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M231.476,261.863a.609.609,0,0,1-.192-.035.569.569,0,0,1-.355-.689l2.9-10.225c.227-.809.447-1.626.667-2.443a52.807,52.807,0,0,1,2.258-7.122,51.843,51.843,0,0,0,3.7-11.112c1.022-5.759-.1-11.041-3.089-14.5-2.634-3.046-6.568-4.622-10.054-5.858a122.538,122.538,0,0,0-23.254-5.773.57.57,0,1,1,.163-1.129,124.25,124.25,0,0,1,23.467,5.83c3.884,1.378,7.846,3.082,10.53,6.185,3.217,3.714,4.438,9.344,3.351,15.444a53.147,53.147,0,0,1-3.77,11.354,52.346,52.346,0,0,0-2.208,6.973c-.22.824-.44,1.647-.667,2.457l-2.705,9.508a.56.56,0,0,1-.036.355l-.2.44a.557.557,0,0,1-.518.334Z",
    transform: "translate(-141.971 -190.584)",
    fill: "#783434"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M191.164,87.783c-.788-4.559-2.833-8.535-7.555-10.828-6.135-2.989-5.688,4.693-4.2,8.464,2.13,5.432,3.905,11.269,4.047,17.084.142,5.766-1.314,12.241.5,17.822.873,2.691,2.577,5.141,2.826,7.96.227,2.6-.838,5.141-1.022,7.74-.284,3.891,2.265,8.9,4.722,11.758,2.9,3.373,10.182,3.948,9.543-2.386-.206-2.08-1.427-3.905-2.5-5.7-6.128-10.289-6.859-22.083-6.554-33.763.142-5.446,1.221-12.277.206-18.142Z",
    transform: "translate(-131.006 -22.21)",
    fill: "#fea188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M138.68,66.113a2.514,2.514,0,0,0-.114.241c-.9,2.237,1.079,3.415,2.237,4.828,1.6,1.96,2.741,4.353,4.218,6.419a65.063,65.063,0,0,0,10.63,11.588c2.563,2.187,6.369,3.969,8.18.383,1.711-3.408,2.563-8.151,3.607-11.865.582-2.059,1.669-3.941,2.109-6.05a4.778,4.778,0,0,0-.057-3.053c-.7-1.25-2.457-.185-3.763-.305a3.551,3.551,0,0,1-2.776-1.555,4.9,4.9,0,0,1-.256-3.33,35.036,35.036,0,0,1,2.712-8.421c.966-2.123-.859-2.854-2.705-3.465-2.506-.838-4.885-2.009-7.406-2.819-3.181-1.022-5.318-.249-8.464-.4.966,6.014-.44,12.22-5.844,15.806a6.407,6.407,0,0,0-2.3,1.988Z",
    transform: "translate(-119.372 -14.06)",
    fill: "#fea188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M148.507,94.609c3.557,4.331,7.96,5.262,8.641-.646,0-6.327.66-13.058,1.221-19.363,1.889-.625,4.189-.533,5.538,1.179a10.427,10.427,0,0,1,1.676,4.466A98.066,98.066,0,0,1,167.124,94.3c.341,5.127,1.9,10.488,2.762,15.593.852,5.02,2.123,9.891,0,14.847a52.506,52.506,0,0,0-3.1,16.558c-.05,2.187.156,4.4.32,6.582a25.527,25.527,0,0,0,.589,4.2c.284,1.15.71,2.031-.547,2.968a6.259,6.259,0,0,1-3.067.923q-5.837.7-11.666,1.4c-3.607.433-6.788-.383-10.36-.376-3.387.007-6.788.092-10.168.341-4.2.312-8.322,1.6-12.461,1.846-3.089.185-2.379-1.86-2.109-4.36.554-5.226-.1-10.125-.348-15.316-.085-1.775.376-3.493.334-5.3-.064-2.407-.163-4.821-.3-7.221-.305-5.389-1.555-11.02-1.477-16.388.064-4.779.071-9.586-.071-14.407-.178-5.865-.263-12.085,2.72-17.134,3-5.07,10.175-7.463,15.834-5.929,5.9,1.6,8.727,8.869,10.658,13.981a26.248,26.248,0,0,0,3.827,7.512Z",
    transform: "translate(-112.718 -21.162)",
    fill: "#c9ced2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(39.693 113.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(47.717 3.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M260.313,172.149a1.917,1.917,0,0,1-1.768-.369,6.446,6.446,0,0,0-1.591-1,4.076,4.076,0,0,0-2.35.227q-4.3,1.31-8.613,2.627a8.052,8.052,0,0,0-3.941,2.073c-.7.817-1.378,3.3.085,3.678,1.143.291,4.566-1.8,5.688-2.244q6.241-2.492,12.483-4.992Z",
    transform: "translate(-236.625 -167.006)",
    fill: "#618480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M245.083,168.683a16.228,16.228,0,0,0-4.054,3.131c-.249.256-2.45,4.026-1.683,4.076-.916-.064-4.253-4.622-4.615-4.374a27.666,27.666,0,0,1,5.361-2.3c1.7-.667,3.415-1.278,5.162-1.8a62.938,62.938,0,0,1,8.634-1.889c.178-.028.391-.035.49.107a.322.322,0,0,1-.163.44,1.088,1.088,0,0,1-.525.064c-2.854-.128-6.121,1.243-8.606,2.556Z",
    transform: "translate(-234.73 -165.507)",
    fill: "#c9ced2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M258.073,169.471c-1.853-.994-5.9.809-7.74,1.484a30.829,30.829,0,0,0-5.766,2.734c-1.037.646-4.885,2.045-3.082,3.806.788.767,1.527.213,2.435-.142,1.626-.646,3.252-1.285,4.878-1.931q5-1.97,9.983-3.948a1.5,1.5,0,0,0-.7-2Z",
    transform: "translate(-236.551 -166.571)",
    fill: "#c9ced2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M241.134,175.416a.275.275,0,0,1-.185-.071.283.283,0,0,1-.028-.4,24.1,24.1,0,0,1,16-8.3.279.279,0,0,1,.312.256.286.286,0,0,1-.256.312,23.489,23.489,0,0,0-15.621,8.1.291.291,0,0,1-.22.1Z",
    transform: "translate(-236.504 -165.835)",
    fill: "#c9ced2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M213.775,173.663c-1.669-.66-2.791-1.889-4.2-3.018q-2.418-1.928-4.835-3.848c-.5-.4-4.175-3.827-4.58-3.65-10.374,4.665-21.671,9.685-32.606,12.994.4,1.555,4.452,3.2,5.276,3.671q5.006,2.822,10.147,5.389c2.364,1.179,4.835,2.343,7.477,2.457a19.808,19.808,0,0,0,7.328-1.562q7.946-2.791,15.891-5.574c1.328-.462,2.641-.944,3.976-1.392a14,14,0,0,0,2.386-.689c-1.718-1.548-4.743-4.175-6.256-4.779Z",
    transform: "translate(-167.535 -161.118)",
    fill: "#618480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M204.736,165.964q2.418,1.928,4.835,3.848c1.413,1.129,2.535,2.357,4.2,3.018,1.52.6,4.537,3.231,6.256,4.779a1.586,1.586,0,0,0,.213-.142c2.634-2.343-5.581-7.8-7.136-8.854q-4.708-3.185-9.408-6.369a15.369,15.369,0,0,0-2.506-1.477,7.321,7.321,0,0,0-.937-.327c-2.258-.6-3.273.746-5.063,1.654-2.109,1.065-4.3,2.009-6.469,2.94q-6.529,2.8-13.278,5.056c-2.279.76-4.63,1.335-6.852,2.215a1.168,1.168,0,0,1-.043,1.541c-.263.27-.66.4-.866.717a.876.876,0,0,0-.121.753C178.5,172,189.8,166.979,200.171,162.321c.4-.185,4.076,3.252,4.58,3.65Z",
    transform: "translate(-167.529 -160.292)",
    fill: "#c9ced2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M239.815,182.032c.625-.334,1.321-.831,1.427.291a2.362,2.362,0,0,1-.163.93,1.287,1.287,0,0,1-1.491.291,3.767,3.767,0,0,1-1.264-1.008,9.079,9.079,0,0,1-.944-1.086c.632.256,1.115.838,1.86.8a1.555,1.555,0,0,0,.575-.213Z",
    transform: "translate(-187.782 -166.427)",
    fill: "#618480"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M239.526,178.794a12.369,12.369,0,0,0-5.176-4.615l.241-.518a12.907,12.907,0,0,1,5.418,4.828l-.483.3Z",
    transform: "translate(-186.903 -164.168)",
    fill: "#b0b4b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(3.074 54.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M129.123,149.465c-.149-.092-.305-.185-.454-.277-3.415-2.123-4.48-6.518-5.254-10.459-2.684-13.7-4.175-27.145-6.369-40.935-1.157-7.264-3.671-20.627,7.37-21.138,10.36-.483,9.032,16.31,9.99,23.212q1.97,14.112,3.934,28.232a35.64,35.64,0,0,0,2.414,10.054c2.031,4.438,6.895,7.484,10.672,10.4a68.17,68.17,0,0,0,18.021,9.486,10.984,10.984,0,0,1,4.019,2.144,3.606,3.606,0,0,1,.923,4.161c-1.228,2.151-4.438,1.527-6.746.618-12.256-4.835-27.2-8.6-38.513-15.5Z",
    transform: "translate(-115.956 -76.646)",
    fill: "#fea188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M202.956,184.72c1.108-.575,4.7-2.613,5.808-1.314,1.136,1.342-1.569,3.43-2.634,3.785a8,8,0,0,0-1.782.611,1.27,1.27,0,0,0-.582,1.6c.419.7,1.321.454,1.974.4,1.058-.078,2.137-.05,3.2-.178a45.835,45.835,0,0,0,6.682-1.484c.7-.192,4.083-1.9,4.424-.582.32,1.25-4.594,2.961-5.475,3.259a2.975,2.975,0,0,1-3.33,2.017,18.612,18.612,0,0,0-2.336,1.725,15.311,15.311,0,0,1-2.783,1.307,23.266,23.266,0,0,1-6.533.916,29.067,29.067,0,0,1-8.506-.788,2.36,2.36,0,0,1-.66-.234c-.88-.511-.866-1.768-.731-2.776.142-1.079.383-2.159,1.512-2.379a18.007,18.007,0,0,0,6.106-2.478c1.882-1.143,3.692-2.4,5.652-3.415Z",
    transform: "translate(-137.316 -107.477)",
    fill: "#fea188"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(0 53.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M135.153,93.844c0-4.864-.277-9.841-2.315-14.265-1.654-3.6-8.159-4.267-11.638-3.359-6.76,1.768-8.059,9.444-8.762,15.387a118.675,118.675,0,0,0-.76,17.4c0,.192.014.391.021.582.036.959,6.128,1.463,7.065,1.441,2.563-.057,5.112.085,7.676-.05.724-.036,9.437-.369,9.4-1.378q-.351-7.882-.7-15.77Z",
    transform: "translate(-111.627 -75.855)",
    fill: "#c9ced2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M193.828,83.961c1.164,3.493.3,6.746.3,10.331v6.866c0,1.385.639,4.693-.291,5.815-1,1.207-7.044,1.413-8.151.305-1.314-.866-1.889-4.573-2.272-6a80.374,80.374,0,0,1-2.166-14.194c-.22-2.585-1.5-7.157-.1-9.5,1.307-2.194,4.388-1.953,6.454-1.157,3.288,1.264,5.162,4.346,6.227,7.541Z",
    transform: "translate(-131.597 -75.856)",
    fill: "#c9ced2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M144.664,114.538a.678.678,0,0,1-.234-1.314c.4-.149.781-.277,1.15-.391,1.86-.6,2.492-.888,2.237-2.57l-1.576-10.5c-.156-1.037-.277-2.123-.391-3.181A38.888,38.888,0,0,0,144.8,90.2a.675.675,0,1,1,1.3-.369,40.527,40.527,0,0,1,1.1,6.611c.121,1.086.234,2.116.383,3.124l1.576,10.5c.433,2.911-1.477,3.522-3.167,4.069-.348.114-.717.227-1.086.369a.721.721,0,0,1-.241.043Z",
    transform: "translate(-121.009 -79.764)",
    fill: "#adb6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M189.153,109.311a.683.683,0,0,1-.667-.547,214.288,214.288,0,0,1-3.217-22.984.677.677,0,1,1,1.349-.114,211.643,211.643,0,0,0,3.2,22.842.679.679,0,0,1-.533.8.782.782,0,0,1-.128.014Z",
    transform: "translate(-132.979 -78.52)",
    fill: "#adb6bd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(9.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M138.946,66.484a8.751,8.751,0,0,0,2.507.866c2.088.32,4.885.476,6.312-1.349,1.3-1.654,1.129-3.77,1.1-5.751a36.257,36.257,0,0,0-1.079-9.089,57.577,57.577,0,0,1-1.74-7.392c-.334-2.478-.22-4.743-.873-7.193-.98-3.65-3.224-6.895-3.848-10.651a16.518,16.518,0,0,1,1.037-7.747c.4-1.235.909-2.421,1.349-3.643.355-.994.774-2.144-.667-1.846-.774.163-1.2.724-1.86,1.058a7.763,7.763,0,0,0-2.237,1.115,8.2,8.2,0,0,0-1.583,2.35,50.533,50.533,0,0,0-3.124,9.614c-.7,2.627-.625,5.354-1.427,7.953-1.825,5.936-6.277,10.736-7.64,16.843a17.308,17.308,0,0,0-.128,6.888A5.09,5.09,0,0,0,126,60.917a5.958,5.958,0,0,0,2.656,1.527q3.77,1.374,7.534,2.741a30.251,30.251,0,0,1,2.748,1.292Z",
    transform: "translate(-124.758 -3.759)",
    fill: "#503d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M180.558,63.047a8.372,8.372,0,0,1-2.308.014c-10.2-1.456-6.383-16.239-3.117-21.877,2.364-4.083,4.814-5.815,5.382-10.864a55.222,55.222,0,0,0-.241-9.252,22.9,22.9,0,0,0-1.307-7c-.731-2.024-.412-4.267-.831-6.348.078.376,1.278.568,1.576.788,1.541,1.115,2.478,3.763,3.309,5.425a89.765,89.765,0,0,1,3.706,8.23,24.594,24.594,0,0,1,1.86,9.181c-.028,1.6-.277,3.2-.249,4.8.092,5.112,3.628,10.608,5.659,15.131.98,2.173,1.946,4.736.809,6.831-1.853,3.4-6.937,2.691-10.083,3.792a21.693,21.693,0,0,1-4.175,1.15Z",
    transform: "translate(-138.352 -2.331)",
    fill: "#503d3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(41.365 21.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M187.3,34.975a11.8,11.8,0,0,1-1.193,3.217c-.376.689-1.022,1.434-1.853,1.335a1.476,1.476,0,0,1-1.179-1.172,5.2,5.2,0,0,1,.036-1.69c.2-2.017-.824-4.878,1.718-6.128a2,2,0,0,1,2.421.4,2.152,2.152,0,0,1,.3,1.143,11.635,11.635,0,0,1-.234,2.89Z",
    transform: "translate(-183.015 -30.31)",
    fill: "#fea188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M185.463,36.782a1.092,1.092,0,0,1-.469-.1.2.2,0,0,1,.163-.362.762.762,0,0,0,.845-.156.622.622,0,0,0,.007-.8.475.475,0,0,0-.391-.135.419.419,0,0,0-.327.163.192.192,0,0,1-.206.078.2.2,0,0,1-.149-.156,3.829,3.829,0,0,1,0-1.562,1.97,1.97,0,0,1,.973-1.285,1.343,1.343,0,0,1,1.6.284.2.2,0,0,1-.3.256.966.966,0,0,0-1.122-.185,1.533,1.533,0,0,0-.76,1.022,2.881,2.881,0,0,0-.043,1.065.921.921,0,0,1,1.015.178,1.006,1.006,0,0,1,0,1.328,1.132,1.132,0,0,1-.831.355Z",
    transform: "translate(-183.549 -30.895)",
    fill: "#f68267"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 13.463,
    cy: 20.095,
    rx: 13.463,
    ry: 20.095,
    transform: "translate(15.752 3.653) rotate(-0.13)",
    fill: "#fea188"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(12.927 21.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M143.224,34.975a11.8,11.8,0,0,0,1.193,3.217c.376.689,1.022,1.434,1.853,1.335a1.476,1.476,0,0,0,1.179-1.172,5.2,5.2,0,0,0-.035-1.69c-.2-2.017.824-4.878-1.718-6.128a2,2,0,0,0-2.421.4,2.152,2.152,0,0,0-.3,1.143,11.635,11.635,0,0,0,.234,2.89Z",
    transform: "translate(-142.964 -30.31)",
    fill: "#fea188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M145.815,36.784a1.106,1.106,0,0,1-.831-.355,1,1,0,0,1,0-1.328.93.93,0,0,1,.7-.256.88.88,0,0,1,.312.078,2.873,2.873,0,0,0-.043-1.065,1.542,1.542,0,0,0-.76-1.022.979.979,0,0,0-1.129.185.2.2,0,1,1-.3-.256,1.347,1.347,0,0,1,1.6-.284,1.915,1.915,0,0,1,.973,1.285,3.831,3.831,0,0,1,0,1.562.189.189,0,0,1-.149.156.2.2,0,0,1-.206-.078.443.443,0,0,0-.327-.163.554.554,0,0,0-.4.135.622.622,0,0,0,.007.8.755.755,0,0,0,.845.156.2.2,0,0,1,.263.1.2.2,0,0,1-.1.263,1.208,1.208,0,0,1-.469.1Z",
    transform: "translate(-143.184 -30.898)",
    fill: "#f68267"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M159.468,30.217a.451.451,0,0,0,.355-.334c.05-.284-.241-.5-.5-.625a8.215,8.215,0,0,0-3.742-.809c-.589.021-1.179.028-1.761.107-.27.036-1.591.241-1.5.71a.221.221,0,0,0,.185.163.819.819,0,0,0,.263-.014,12.049,12.049,0,0,1,3.2-.156,21.713,21.713,0,0,1,2.947.909,1.273,1.273,0,0,0,.54.05h.028Z",
    transform: "translate(-132.748 -8.341)",
    fill: "#503d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M171.847,30.352c.249-.043.5-.121.632-.156a9.91,9.91,0,0,1,1.938-.291,9,9,0,0,1,3.572.277,1.732,1.732,0,0,0,.419.149.36.36,0,0,0,.383-.163c.263-.525-2.322-1.164-2.727-1.221a9.044,9.044,0,0,0-2.7.036c-.5.085-2.038.227-2.2.817s.256.625.682.554Z",
    transform: "translate(-138.203 -8.461)",
    fill: "#503d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M174.173,33.87a1.211,1.211,0,0,1,.241-.774,1.355,1.355,0,0,1,1.271-.483,1.7,1.7,0,0,1,1.037.646h0a1.015,1.015,0,0,1,.192.966,1.212,1.212,0,0,1-.213.355,1.011,1.011,0,0,1-.973.561.609.609,0,0,1-.156-.014,1.323,1.323,0,0,1-.859-.241,1.347,1.347,0,0,1-.149-.135.762.762,0,0,1-.4-.88Z",
    transform: "translate(-139.073 -9.544)",
    fill: "#4c3932"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M155.653,33.37a1.211,1.211,0,0,1,.241-.774,1.355,1.355,0,0,1,1.271-.483,1.7,1.7,0,0,1,1.037.646h0a1.015,1.015,0,0,1,.192.966,1.212,1.212,0,0,1-.213.355,1.011,1.011,0,0,1-.973.561.609.609,0,0,1-.156-.014,1.323,1.323,0,0,1-.859-.241,1.348,1.348,0,0,1-.149-.135.762.762,0,0,1-.4-.88Z",
    transform: "translate(-133.704 -9.399)",
    fill: "#4c3932"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M181.289,13.852c-.511-4.267-3.479-8.4-6.831-10.963A9.707,9.707,0,0,0,168.714.73c-1.228,0-1.505.54-2.017,1.619a12.831,12.831,0,0,0-.916,3.025c-.27,1.349-.518,2.869.241,4.019a5.665,5.665,0,0,0,2.372,1.725,46.229,46.229,0,0,1,8.918,5.83c1.051.873,2.151,2.009,2.009,3.366a8.5,8.5,0,0,0,1.974-6.454Z",
    transform: "translate(-136.576 -0.305)",
    fill: "#503d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M156.777,10.128a23.562,23.562,0,0,1,2.2-1.1,4.869,4.869,0,0,1,.625-2.8,6.649,6.649,0,0,0,.774-2.5,5.282,5.282,0,0,1,.611-2.45c.121-.22.249-.49.121-.7a.667.667,0,0,0-.554-.227,17.785,17.785,0,0,0-4.069-.149,15.634,15.634,0,0,0-3.579.98,17.464,17.464,0,0,0-5.979,4.026A21.567,21.567,0,0,0,141.4,16.156a4.862,4.862,0,0,0,.54,3.983c.746,1.022,1.889,1.164,3.053,1.534a.854.854,0,0,0,.376.057.8.8,0,0,0,.469-.383c.731-.994,1.5-1.917,2.159-2.947a25.075,25.075,0,0,1,8.769-8.265Z",
    transform: "translate(-129.531 -0.131)",
    fill: "#503d3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(3.654 0.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M166.05,9.62a.29.29,0,0,1-.284-.249c-.227-1.718-.5-5.844,1.541-8.372A.026.026,0,0,0,167.3.979a.289.289,0,0,1,.192-.355l.277-.078a.286.286,0,0,1,.284.476c-2.23,2.293-1.946,6.561-1.718,8.286a.287.287,0,0,1-.249.32h-.036Z",
    transform: "translate(-140.257 -0.534)",
    fill: "#473335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M149.572,17.79h-.05a.286.286,0,0,1-.234-.327,10.33,10.33,0,0,1,4.424-6.753.294.294,0,0,1,.4.078.289.289,0,0,1-.085.4,9.76,9.76,0,0,0-4.175,6.376.277.277,0,0,1-.284.234Z",
    transform: "translate(-135.523 -3.471)",
    fill: "#473335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M149.516,72.984a.318.318,0,0,1-.135-.036.284.284,0,0,1-.121-.383,8.966,8.966,0,0,0,.4-6.206,34.375,34.375,0,0,0-1.164-3.572c-.32-.859-.646-1.747-.916-2.641a13.481,13.481,0,0,1-.028-8.89.283.283,0,1,1,.525.213,12.969,12.969,0,0,0,.05,8.514c.263.88.589,1.761.9,2.606a33.86,33.86,0,0,1,1.186,3.628,9.568,9.568,0,0,1-.447,6.611.276.276,0,0,1-.256.149Z",
    transform: "translate(-134.806 -15.189)",
    fill: "#473335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M139.744,75.943a.25.25,0,0,1-.085-.014.282.282,0,0,1-.185-.355,55.753,55.753,0,0,0,2.123-9.806.286.286,0,1,1,.568.071,56.321,56.321,0,0,1-2.144,9.912.281.281,0,0,1-.27.2Z",
    transform: "translate(-132.675 -19.375)",
    fill: "#473335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M195.833,57.3a.323.323,0,0,1-.142-.036c-5.787-3.288-5.815-9.927-4.821-14.911a.285.285,0,1,1,.561.107c-.959,4.807-.944,11.183,4.544,14.308a.287.287,0,0,1,.107.391A.28.28,0,0,1,195.833,57.3Z",
    transform: "translate(-147.438 -12.593)",
    fill: "#473335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M183.231,79.773a.283.283,0,0,1-.256-.156,24.055,24.055,0,0,1-2.556-9.082.285.285,0,0,1,.263-.305.291.291,0,0,1,.305.263,23.321,23.321,0,0,0,2.492,8.869.288.288,0,0,1-.121.383.278.278,0,0,1-.128.028Z",
    transform: "translate(-144.55 -20.742)",
    fill: "#473335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M187.586,61.7a.276.276,0,0,1-.22-.107,12.918,12.918,0,0,1-2.585-10.374.285.285,0,1,1,.561.107,12.326,12.326,0,0,0,2.471,9.912.282.282,0,0,1-.043.4.273.273,0,0,1-.178.064Z",
    transform: "translate(-145.752 -15.162)",
    fill: "#473335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M200.786,71.513a.265.265,0,0,1-.107-.021,18.3,18.3,0,0,1-7.9-6.007.284.284,0,1,1,.454-.341,17.753,17.753,0,0,0,7.654,5.815.287.287,0,0,1-.1.554Z",
    transform: "translate(-148.117 -19.234)",
    fill: "#473335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M192.994,78.512a.3.3,0,0,1-.22-.1l-1.981-2.364a.287.287,0,0,1,.44-.369l1.981,2.364a.291.291,0,0,1-.036.4.307.307,0,0,1-.185.064Z",
    transform: "translate(-147.539 -22.292)",
    fill: "#473335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M180.945,19.543a.3.3,0,0,1-.284-.234,18.671,18.671,0,0,0-4.786-9.969.286.286,0,0,1,.4-.4,19.3,19.3,0,0,1,4.949,10.274.284.284,0,0,1-.227.334h-.05Z",
    transform: "translate(-143.208 -2.945)",
    fill: "#473335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M130.8,71.062a.288.288,0,0,1-.277-.213,18.779,18.779,0,0,1,5.183-18.27.286.286,0,1,1,.391.419,18.187,18.187,0,0,0-5.02,17.7.282.282,0,0,1-.2.348c-.028,0-.05.007-.078.007Z",
    transform: "translate(-129.904 -15.602)",
    fill: "#473335"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M166.919,42.622a.2.2,0,0,1-.2-.185.2.2,0,0,1,.185-.206A2.507,2.507,0,0,0,167.977,42a.7.7,0,0,0,.376-.767,1.145,1.145,0,0,0-.284-.376l-.064-.064c-1.093-1.15-1.434-2.925-1.051-5.425a.2.2,0,0,1,.227-.163.192.192,0,0,1,.163.227c-.362,2.372-.057,4.033.951,5.091l.064.064a1.559,1.559,0,0,1,.369.518,1.077,1.077,0,0,1-.547,1.235,2.7,2.7,0,0,1-1.243.277h-.014Z",
    transform: "translate(-136.925 -10.301)",
    fill: "#f68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M159.89,50.45a6.263,6.263,0,0,0,2.3,1.733,4.756,4.756,0,0,0,2.059.632,5.152,5.152,0,0,0,1.1-.028,5.306,5.306,0,0,0,2-.7c.241-.142,1.307-.753,1.342-1.051.036-.256-.142-.341-.391-.348a7.624,7.624,0,0,0-1.811-.731c-.639-.142-1.115.284-1.725.362-.568.071-1.065-.4-1.683-.412a8.613,8.613,0,0,0-2.791.5,2.433,2.433,0,0,0-.4.043Zm.689-.035h0Z",
    transform: "translate(-134.945 -14.564)",
    fill: "#f68267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M163.159,61.79a6.806,6.806,0,0,1-2.272-.4,12.267,12.267,0,0,1-3.671-2.038L155.931,58.3a.2.2,0,0,1-.028-.277.194.194,0,0,1,.277-.028l1.285,1.058a11.984,11.984,0,0,0,3.557,1.967,6.917,6.917,0,0,0,7.065-1.669.2.2,0,1,1,.263.291,7.8,7.8,0,0,1-5.191,2.144Z",
    transform: "translate(-133.776 -16.894)",
    fill: "#f68267"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderVector);
export default __webpack_public_path__ + "static/media/header-vector.390fe892a8a5a08bc4b59dd79c2e0a46.svg";
export { ForwardRef as ReactComponent };